const messages = {
  'app.pages.versions.excludeArchived': 'Excluir archivadas',
  'app.pages.applications.openingOptions': 'Opciones de apertura',
  'app.pages.applications.readOnly': 'Solo lectura',
  'app.pages.versions.openInNewInstance': 'Abrir en nueva instancia',
  'app.pages.versions.openInNewInstanceHelp':
    'Inicia un proceso independiente de las sesiones abiertas. Usa recursos adicionales.',
  'app.pages.versions.searchVersions': 'Buscar versiones',
  'app.pages.applications.openWithOptions': 'Abrir con opciones…',
  'app.pages.applications.recommended': 'Recomendado',
  'app.pages.applications.useDefaultConfiguration': 'Usar configuración por defecto',
  'app.pages.applications.recommendedResources': 'Opciones de recursos',
  'app.pages.applications.recommendedResourcesHelp':
    'Al abrir con opciones, solo se ofrecerán estos recursos. Si se deja vacío, se ofrecen todos.',
  'app.pages.applications.recommendedResourcesUnavailable':
    'Ningún recurso permitido está disponible. La aplicación se abrirá con la configuración por defecto.',
  'app.pages.applications.resourcesLoadError':
    'No se pudieron cargar los recursos. La aplicación puede abrirse con la configuración por defecto o se puede reintentar.',
  'app.pages.applications.resourceUnavailable': 'No disponible',
  'app.pages.applications.retry': 'Reintentar',
  'common.code': 'Código',
  'common.diagram': 'Diagrama',
  'common.preview': 'Vista previa',
  'common.result': 'Resultado',
  'common.shortcuts': 'Atajos',
  'common.app': 'Aplicación',
  'common.apps': 'Aplicaciones',
  'common.confirm': 'Confirmar',
  'common.close': 'Cerrar',
  'common.cancel': 'Cancelar',
  'common.run': 'Evaluar',
  'common.stop': 'Detener',
  'common.home': 'Inicio',
  'common.error': 'Error',
  'common.console': 'Consola',
  'common.all': 'Todo',
  'common.allPlural': 'Todos',
  'common.apply': 'Aplicar',
  'common.noResultsFound': 'No se encontraron resultados',
  'common.options': 'Opciones',
  'common.goToNode': 'Ir al nodo',
  'common.goToInterface': 'Ir a la interfaz',
  'common.goToModule': 'Ir al módulo',
  'common.goToApplicationFiles': 'Ir a los archivos de la aplicación',
  'common.goToVersionFiles': 'Ir a los archivos de la versión',
  'common.top': 'Superior',
  'common.bottom': 'Inferior',
  'common.left': 'Izquierda',
  'common.right': 'Derecha',
  'common.default': 'Por defecto',
  'common.custom': 'Personalizado',
  'common.none': 'Ninguno',
  'common.interface': 'Interfaz',
  'common.text': 'Texto',
  'common.true': 'Verdadero',
  'common.false': 'Falso',
  'common.hide': 'Esconder',
  'common.show': 'Mostrar',
  'common.position': 'Posición',
  'common.inside': 'Dentro',
  'common.outside': 'Fuera',
  'common.running': 'Ejecutando',
  'common.general': 'General',
  'common.value': 'Valor',
  'common.edit': 'Editar',
  'common.username': 'Usuario',
  'common.password': 'Contraseña',
  'common.invalidPassword': 'Contraseña inválida',
  'common.required': 'Obligatorio',
  'common.copy': 'Copiar',
  'common.cut': 'Cortar',
  'common.pasteBelow': 'Pegar debajo',
  'common.about': 'Acerca de',
  'common.documentation': 'Documentación',
  'common.addDocumentation': 'Agregar documentación',
  'common.editDocumentation': 'Editar documentación',
  'common.hasDocumentation': 'Tiene documentación',
  'common.documentationUpdated': 'Documentación actualizada correctamente',
  'common.help': 'Ayuda',
  'common.from': 'Desde',
  'common.to': 'Hasta',
  'common.color': 'Color',
  'common.values': 'Valores',
  'common.applyTo': 'Aplicar a',
  'common.save': 'Guardar',
  'common.paste': 'Pegar',
  'common.total': 'Total',
  'common.totals': 'Totales',
  'common.row': 'Fila',
  'common.rows': 'Filas',
  'common.column': 'Columna',
  'common.columns': 'Columnas',
  'common.measures': 'Medidas',
  'common.labels': 'Etiquetas',
  'common.read': 'Leer',
  'common.properties': 'Propiedades',
  'common.selectInterface': 'Seleccionar interfaz',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.table': 'Tabla',
  'common.tables': 'Tablas',
  'common.cube': 'Cubo',
  'common.discard': 'Descartar',
  'common.settings': 'Ajustes',
  'common.resetView': 'Restablecer vista',
  'common.viewError': 'Ver error',
  'common.reloadComponent': 'Recargar componente',
  'common.fields': 'Campos',
  'common.delete': 'Borrar',
  'common.add': 'Agregar',
  'common.information': 'Información',
  'common.openApp': 'Abrir app',
  'common.openAppInNewInstance': 'Abrir app en nueva instancia',
  'common.description': 'Descripción',
  'common.version': 'Versión',
  'common.versions': 'Versiones',
  'common.screenshots': 'Capturas de pantalla',
  'common.showInstallationLogs': 'Mostrar logs de instalación',
  'common.hideInstallationLogs': 'Ocultar logs de instalación',
  'common.noResults': 'Sin resultados',
  'common.conditionFormatType': 'Tipo de condición',
  'common.loadingAppVersion': 'Cargando versión de la aplicación',
  'common.loadingTextEditor': 'Cargando editor de texto..',
  'common.creatingAppVersion': 'Creando versión de la aplicación',
  'common.notAllowedCharacters':
    'El texto contiene uno o más caracteres no permitidos. Por favor, elimina los siguientes caracteres: / \\ : * ? ',
  'common.status': 'Estado',
  'common.activate': 'Activar',
  'common.archive': 'Archivar',
  'common.unarchive': 'Desarchivar',
  'common.invalidCharactersMessage': 'No se permiten los siguientes caracteres: {characters}',
  'common.import': 'Importar',
  'common.export': 'Exportar',
  'common.scenarios': 'Escenarios',
  'common.selectANode': 'Elegir un nodo',
  'common.selectedNode': 'Nodo seleccionado',
  'common.deleteAll': 'Borrar todo',
  'common.creator': 'Creador',
  'common.scenario': 'Escenario',
  'common.validating': 'Validando',
  'common.selectedNode.incorrect': 'El nodo seleccionado es incorrecto. Selecciona otro nodo.',
  'common.max': 'Máximo',
  'common.min': 'Mínimo',
  'common.internalTests': 'Pruebas internas',
  'common.used': 'Usado',
  'common.generalSettings': 'Configuración general',
  'common.clipboard': 'Portapapeles',
  'common.clipboard.clear': 'Vaciar portapapeles',
  'common.apiKeysManager': 'Administrador de claves API',
  'common.user': 'Usuario',
  'common.items': 'Elementos',
  'common.assistant': 'Asistente',
  'common.assistants': 'Asistentes',
  'common.sources': 'Fuentes',
  'common.team': 'Equipo',
  'common.appConsolidation': 'Consolidación',
  'common.changes': 'Cambios',
  'common.destination': 'Destino',
  'common.new': 'Nuevo',
  'common.old': 'Viejo',
  'common.definition': 'Definición',
  'common.nodes': 'Nodos',
  'common.appManagement': 'Administración de la aplicación',
  'common.modules': 'Módulos',
  'common.maximize': 'Maximizar',
  'common.minimize': 'Minimizar',
  'common.areYouSureYouWantToProceed': '¿Estás seguro de querer continuar?',
  'common.load': 'Cargar',
  'common.colors': 'Colores',
  'common.component': 'Componente',
  'common.source': 'Origen',
  'common.string': 'Texto',
  'common.integer': 'Entero',
  'common.float': 'Decimal',
  'common.boolean': 'Booleano',
  'common.date': 'Fecha',
  'common.datetime': 'Fecha y hora',
  'common.extraSettings': 'Opciones adicionales',
  'common.apiKeys': 'Claves de API',
  'common.applicationEnvironment': 'Entorno de la aplicación',
  'common.moduleRestrictions': 'Restricciones de módulos',
  'common.workflowProcesses': 'Procesos de flujo de trabajo',
  'common.lostMessage': 'se perderán.',
  'common.attemptingReconnectServer': 'Intentando reconectar con el servidor, por favor espera...',
  'common.connectionReestablished': 'Conexión restablecida',
  'common.order': 'Orden',
  'common.nodeInterface': 'Interfaz de nodo',
  'common.pleaseWait': 'Por favor espera...',
  'common.context': 'Contexto',
  'common.name': 'Nombre',
  'common.assistantBot': 'Asistente',
  'common.assistantBots': 'Asistentes',
  'common.open': 'Abrir',
  'common.somethingWentWrong': 'Algo salió mal',
  'common.details': 'Detalles',
  'common.reloadPage': 'Recargar página',
  'common.titleAndId': 'Título + id',
  'common.expand': 'Expandir',
  'common.seeMore': 'Ver más',
  'common.application': 'Aplicación',
  'common.companyPreference': 'Preferencias de la compañía',
  'common.externalLinks': 'Enlaces externos',
  'common.instance': 'Instancia',
  'common.instanceId': 'ID de la instancia',
  'common.logging': 'Logs',
  'common.modelManager': 'Administrador de modelos',
  'common.userCompany': 'Usuario de la compañía',
  'common.forceRun': 'Forzar evaluación',
  'common.of': 'de',
  'common.scrollBottom': 'Scroll hacia abajo',
  'common.scrollTop': 'Scroll hacia arriba',
  'common.tableCopied': 'Tabla copiada',
  'common.copyId': 'Copiar id',
  'common.refresh': 'Actualizar',
  'common.invalidCharactersCompanyValidation':
    'Caracteres inválidos. Utilizar únicamente letras en minúsculas, letras en mayúsculas, números del 0 al 9, guiones bajos o medios',
  'common.invalidCharactersFilesAndFoldersValidation':
    'Caracteres inválidos. Utilizar únicamente letras en minúsculas, letras en mayúsculas, números del 0 al 9, guiones bajos o medios (_-) y símbolos "+", "%", "&" y "*"',
  'common.invalidCharactersAppsVersionsScenariosValidation':
    'Caracteres inválidos. Utilizar únicamente letras en minúsculas, letras en mayúsculas, números del 0 al 9, guiones bajos o medios (_-), paréntesis y símbolos "+", "%", "&" y "*"',
  'common.undo': 'Deshacer',
  'common.redo': 'Rehacer',
  'common.darkMode': 'Modo oscuro',
  'common.lightMode': 'Modo claro',
  'common.copyTableToClipboard': 'Copiar tabla al portapapeles',
  'common.websocketsStatus': 'Estado de Websockets',
  'common.connected': 'Conectado',
  'common.disconnected': 'Desconectado',
  'common.persistenceType': 'Tipo de persistencia',
  'common.inDefinition': 'En definición',
  'common.inMemory': 'En memoria',
  'common.onDisk': 'En disco',
  'common.persistencePath': 'Ruta de persistencia',
  'common.componentCodeError': 'Hubo un error en el código del componente',
  'common.resultError': 'No se pudo mostrar el resultado de este componente',
  'common.componentDefinitionError': 'Hubo un error en la definición del componente',
  'common.nodeResultError': 'No se pudo mostrar el resultado de este nodo',
  'common.noPermissionToNavigate': 'No tienes permiso para ir a {path}',
  'common.addContext': 'Agregar contexto',
  'common.addAsContext': 'Agregar como contexto',
  'common.addComponent': 'Agregar componente',
  'common.addComponentToAgentContext': 'Agregar componente al contexto del agente',
  'common.addNodeContextMessage': 'Para agregar contexto, selecciona y ejecuta un nodo',
  'common.addComponentToContextMessage': 'Haz click en un componente para agregarlo como contexto',
  'common.selectComponentToContextMessage': 'Seleccionar un componente como contexto',
  'common.sort': 'Ordenar',
  'common.ascending': 'Ascendente',
  'common.descending': 'Descendente',
  'common.preference': 'Preferencia',
  'common.insert': 'Insertar',
  'common.searchBy': 'Buscar por',
  'common.searchFields': 'Buscar campos',
  'common.clear': 'Limpiar',
  'common.charts': 'Gráficos',
  'common.indicators': 'Indicadores',
  'common.indexes': 'Índices',

  copying_app_to_user_workspace: 'Copiando aplicación en espacio de trabajo del usuario',
  creating_environment: 'Creando ambiente',
  starting_environment: 'Iniciando ambiente',
  loading_workspace: 'Cargando espacio de trabajo',
  engine_created: 'Motor de cálculo creado',
  starting_pyplan_calc_engine: 'Inicializando motor de cálculo',
  opening_app: 'Abriendo aplicación',
  cancel_opening_app: 'Cancelar apertura',
  canceling_app_opening: 'Cancelando...',
  error_opening_app: 'Ocurrió un error al abrir la aplicación',
  installing_requirements_file_libraries: 'Instalando librerías desde archivo requirements.txt',
  no_libraries_to_install: 'Sin librerías para instalar',
  processing_startup_nodes: 'Procesando nodos iniciales',
  reading_app_properties: 'Leyendo propiedades de la aplicación',
  reading_app_modules: 'Leyendo módulos de la aplicación',
  loading_interfaces: 'Cargando interfaces',
  creating_nodes: 'Creando nodos',
  applying_migrations: 'Aplicando migraciones',
  done: 'Listo',
  may_take: 'Esta tarea puede demorar hasta 5 minutos. Por favor espera...',
  'common.checkingPythonLibrariesUsedInModel':
    'Verificando las bibliotecas de python utilizadas en el modelo',
  'common.librariesAlreadyInstalled': 'Librerías ya instaladas',
  'common.resultsNotFound': 'Sin resultados, realiza una búsqueda',
  need_logout: 'Logout requerido',
  need_logout_detail:
    'El administrador ha solicitado cerrar la instancia. Por favor, guarda y cierra la instancia lo antes posible',
  session_killed_detail: 'Logout requerido',
  session_killed: 'El administrador cerró tu instancia',
  instance_purged: 'Tu instancia expiró debido a inactividad',
  instance_purged_detail: 'Cerrar la instancia',
  session_purged: 'Tu sesión expiró debido a inactividad',
  session_purged_detail: 'Iniciar sesión de nuevo',
  engine_down:
    'El motor de cálculo se cerró de forma inesperada. Por favor, cerrar la instancia y abrir una nueva',
  engine_down_detail: 'Cerrar instancia',
  error_installing_libs_from_requirements:
    'Error instalando librerías desde el archivo requirements.txt',
  error_creating_new_version: 'Error creando nueva versión',
  error_version_name_already_exists: 'El nombre de la versión elegido ya existe',
  app_recovered_from_backup: 'Aplicación recuperada desde copia de seguridad',
  indexing_documents: 'Indexando documentos',
  recovered_existing_instance: 'La aplicación se recuperó desde una instancia existente.',
  app_closed_in_another_tab: 'La aplicación se cerró en otra pestaña.',
  app_closed_by_agent: 'El agente cerró la aplicación.',
  'app.agentLive.anAgent': 'Un agente',
  'app.agentLive.working': '{name} está trabajando en esta aplicación',
  'app.agentLive.follow': 'Seguir al agente',
  'app.agentLive.status': 'Trabajando en esta aplicación vía MCP',
  'app.agentLive.tooltip':
    '{name} está trabajando en esta aplicación vía MCP. Ves sus cambios acá a medida que los hace. Hacé clic para elegir si la pantalla lo sigue.',
  'app.agentLive.followHelp':
    'Te lleva a los nodos e interfaces que edita. No lo hace mientras tengas cambios sin confirmar.',
  'app.agentLive.nodeCreated': 'El agente creó un nodo',
  'app.agentLive.nodeUpdated': 'El agente modificó un nodo',
  'app.agentLive.nodesMoved': 'El agente movió nodos de un módulo',
  'app.agentLive.interfaceChangedWhileEditing': 'El agente cambió esta interfaz mientras la editás',
  'app.agentLive.viewCaptured': 'El agente tomó una captura de tu pantalla para revisar su trabajo',
  'app.agentLive.interfaceChangedWhileEditingDetail':
    'No se refrescó para no perder tus cambios. Si los guardás, reemplazás los del agente.',
  'app.agentLive.nodesDeleted': 'El agente eliminó nodos de un módulo',
  'app.agentLive.interfaceCreated': 'El agente creó una interfaz',
  'app.agentLive.interfaceUpdated': 'El agente modificó una interfaz',
  session_closed_in_another_tab: 'La sesión se cerró en otra pestaña.',
  indexing_app_elements: 'Indexando elementos de la aplicación',
  uploading_app_documentation: 'Subiendo documentación de la aplicación',

  //home
  'app.components.HomePage.header': 'Página de inicio',
  //notifier
  'common.notifier.dismissSnackbar': 'Cerrar',
  'common.notifier.readMore': 'Ver más',

  //Initial configuration
  'app.pages.initialConfig.initialSetUp': 'Configuración inicial',
  'app.pages.initialConfig.internalTesting': 'Pruebas internas',
  'app.pages.initialConfig.finish': 'Finalizar',
  'app.pages.initialConfig.initialConfig': 'Por favor ingresa el nombre de la compañía',
  'app.pages.initialConfig.userAdminInfo':
    'Ingresa información del usuario administrador de la compañía',
  'app.pages.initialConfig.copyKey':
    'Copia el código de activación y envíaselo al administrador del sistema para generar el código de licencia',
  'app.pages.initialConfig.finishMessage': 'Proceso finalizado con éxito',
  'app.pages.initialConfig.licenseSuccess': 'Licencia creada con éxito',

  // Internal tests
  'app.pages.internalTests.runTests': 'Ejecutar pruebas',
  'app.pages.internalTests.deleteApp': 'Borrar aplicación',
  'app.pages.internalTests.createPublicFolder': 'Crear carpeta pública',
  'app.pages.internalTests.removePublicFolder': 'Borrar carpeta pública',
  'app.pages.internalTests.systemResources': 'Recursos del sistema',

  //cards
  'app.components.cards.instanceCard.openAgo': 'Abierta hace {number} mins',
  'app.components.cards.instanceCard.currentInstance': 'Instancia Actual',
  'app.components.cards.instanceCard.activeAgo': 'Activa hace {number} mins',
  'app.components.cards.instanceCard.deleteInstance': 'Eliminar instancia',
  'app.components.cards.instanceCard.selectInstance': 'Seleccionar instancia',
  'app.components.cards.instanceCard.changeInstance':
    'Cambiar a esta instancia:{br}- Nombre: {title}{br}- Versión: {version}{br}- Ruta: {modelPath}',
  'app.components.cards.instanceCard.currentInstanceTooltip':
    '- Nombre: {title}{br}- Versión: {version}{br}- Ruta: {modelPath}',

  //login
  'app.pages.login.init': 'Inicio',
  'app.pages.login.usernameLabel': 'Usuario',
  'app.pages.login.passwordLabel': 'Contraseña',
  'app.pages.login.forgotPassword': '¿Olvidaste la contraseña?',
  'app.pages.login.sendInstructions': 'Enviar Instrucciones',
  'app.pages.login.login': 'Iniciar Sesión',
  'app.pages.login.connectWithSocialMedia': 'Conectar con redes sociales',
  'app.pages.login.connectWithApp': 'Conectar con {app}',
  'app.pages.login.or': 'o',
  'app.pages.login.orContinueWith': 'o continuar con:',
  'app.pages.login.SSOTo': 'SSO a {company}',
  'app.pages.login.createAnAccount': 'Crear una cuenta',
  'app.pages.login.copyright': 'Copyright © Pyplan {year}.',
  'app.pages.login.selectCompany': 'Selecciona una empresa',
  'app.pages.login.licenseInfo': 'Información de licencia',
  'app.pages.login.invalidLicense': 'Licencia inválida',
  'app.pages.login.carousel.previous': 'Anterior', //in spanish and pt these are duplicated, but are unique in english
  'app.pages.login.carousel.next': 'Siguiente',
  'app.pages.login.carousel.viewMore': 'Ver más',
  'app.pages.login.carousel.userPasswordExpired':
    '¡La contraseña de tu usuario ha caducado! Por favor, elige una nueva para mantener tu cuenta segura.',
  'app.pages.login.carousel.userPasswordRepeated':
    'La nueva contraseña debe ser diferente de la actual.',
  'app.pages.login.rememberMe': 'Recordarme',
  'app.pages.login.resetPasswordMessage':
    'Si existe una cuenta para este usuario, recibirás un correo electrónico con instrucciones para restablecer tu contraseña.',
  'app.pages.login.resetPassword': 'Restablecer contraseña',
  'app.pages.login.passwordChangedSuccessfully': 'Contraseña cambiada con éxito',
  'app.pages.login.invalidToken': 'El token no es válido.',
  'app.pages.login.multiFactorAuthentication': 'Autenticación de múltiples factores',
  'app.pages.login.scanQrCode':
    'Mejora la seguridad de tu cuenta descargando una aplicación de Autenticación en Dos Pasos (2FA), como Google Authenticator o Microsoft Authenticator, en tu dispositivo móvil. Escanea el código QR que se muestra a continuación utilizando la aplicación para generar códigos de verificación únicos cada vez que inicies sesión.',
  'app.pages.login.enterCode': 'Ingresa el código generado por tu aplicación de autenticación',
  'app.pages.login.enterCodePlaceholder': 'Ingresa el código',
  'app.pages.login.enterCodeError': 'El código no es válido',
  'app.pages.login.enterCodeSuccess':
    'La autenticación de múltiples factores se habilitó correctamente',
  'app.pages.login.verify': 'Verificar',
  'app.pages.login.cantUseAuthAppNow':
    'No puedo usar mi aplicación de autenticación en este momento.',
  'app.pages.login.sendCodeToEmail':
    'Te hemos enviado el código de verificación a tu casilla de correo electrónico {userSecretMail}. Por favor ingresa el código para continuar.',
  'app.pages.login.loadingInstanceData': 'Cargando datos de la instancia',
  'app.pages.login.deleteSSOTo': 'Borrar link "SSO a {company}"',
  'app.pages.login.invalidCredentials':
    'No se pudo iniciar sesión con las credenciales proporcionadas.',
  'app.pages.login.accountDisabled':
    'La cuenta de usuario está deshabilitada. Por favor, contacta a tu administrador.',
  'app.pages.login.invalidInput': "Debes incluir 'usuario' y 'contraseña'.",
  'app.pages.login.directAccessCompanyDenied': 'Tu cuenta no tiene acceso a la compañía {company}.',
  'app.pages.login.privacyMessage': 'Al ingresar, aceptas los',
  'app.pages.login.termsOfService': 'Términos de servicio',
  'app.pages.login.privacyPolicy': 'Política de privacidad',

  //topbar
  'app.pages.app.topbar.notifications': 'Notificaciones',
  'app.pages.app.topbar.showMore': 'Ver más',
  'app.pages.app.topbar.showNotifications': 'Ver notificaciones',
  'app.pages.app.topbar.showErrors': 'Mostrar errores',
  'app.pages.app.topbar.defaultInterface': 'Interfaz por defecto',
  'app.pages.app.topbar.summary': 'Resumen',
  'app.pages.app.topbar.manageLibs': 'Librerías',
  'app.pages.app.topbar.reloadApp': 'Recargar aplicación',
  'app.pages.app.topbar.createNew.app': 'Aplicación',
  'app.pages.app.topbar.layout.diagram': 'Resultado',
  'app.pages.app.topbar.layout.preview': 'Código+Preview',
  'app.pages.app.topbar.layout.result': 'Código+Resultado',
  'app.pages.app.topbar.saveAs': 'Guardar como',
  'app.pages.app.topbar.saveAsNewVersion': 'Guardar como nueva versión',
  'app.pages.app.topbar.saveApplicationInMyWorkspace':
    'Guardar aplicación en mi espacio de trabajo',
  'app.pages.app.topbar.saveApplicationInTeam': 'Guardar aplicación en mi equipo',
  'app.pages.app.topbar.claimWriteMode': 'Reclamar escritura',
  'app.pages.app.topbar.writeModeClaimed': 'Ya puedes guardar tus cambios',
  'app.pages.app.topbar.appName': 'Nombre de la aplicación',
  'app.pages.app.topbar.appNameValidationError':
    'El nombre de la aplicación no puede contener alguno de los siguientes caracteres: ',
  'app.pages.app.topbar.selectAppVersionsToCopy':
    'Selecciona las versiones de la aplicación a copiar',
  'app.pages.app.topbar.copiesAllAppVersionMessage':
    'Se copiarán todas las versiones si no hay ninguna seleccionada',
  'app.pages.app.topbar.logout': 'Cerrar sesión',
  'app.pages.app.topbar.libsManager.uninstalled': 'La librería fue desinstalada exitosamente',
  'app.pages.app.topbar.libsManager.version': 'Versión',
  'app.pages.app.topbar.libsManager.refresh': 'Refrescar',
  'app.pages.app.topbar.libsManager.location': 'Ubicación',
  'app.pages.app.topbar.libsManager.actions': 'Acciones',
  'app.pages.app.topbar.libsManager.installedLibraries': 'Librerías instaladas',
  'app.pages.app.topbar.libsManager.install': 'Instalar',
  'app.pages.app.topbar.libsManager.appRequirements': 'Requerimientos de la app',
  'app.pages.app.topbar.libsManager.saveFileInstallLibraries':
    'Guardar archivo e instalar librerías',
  'app.pages.app.topbar.libsManager.saveInstallLibraries': 'Guardar e instalar',
  'app.pages.app.topbar.libsManager.requirementsFile': 'Archivo requirements.txt',
  'app.pages.app.topbar.libsManager.pipInstallError': 'No se permiten espacios en blanco',
  'app.pages.app.topbar.libsManager.systemLib': 'lib de sistema',
  'app.pages.app.topbar.libsManager.userLib': 'lib de usuario',
  'app.pages.app.topbar.libsManager.filter': 'Filtrar',
  'app.pages.app.topbar.libsManager.libraries': 'Librerías',
  'app.pages.app.topbar.showConsole': 'Ver consola',
  'app.pages.app.topbar.showPinnedNodes': 'Ver nodos pinneados',
  'app.pages.app.topbar.hidePinnedNodes': 'Ocultar nodos pinneados',
  'app.pages.app.topbar.closeConsole': 'Cerrar consola',
  'app.pages.app.topbar.appProperties': 'Propiedades',
  'app.pages.app.topbar.appPropertiesUpdatedSuccessfully':
    'Propiedades de la aplicación actualizadas exitosamente',
  'app.pages.app.topbar.deparmentsError':
    'Hay una interfaz sin departamentos.Por favor elige al menos 1 departamento.',
  'app.pages.app.topbar.deparmentRepeated': 'El departamento {name} ya tiene una interfaz definida',
  'app.pages.app.topbar.allDeps': 'Todos',
  'app.pages.app.topbar.selecteDefaultInterface':
    'Selecciona la interfaz por defecto para la aplicación',
  'app.pages.app.topbar.libsManager.cantInstallHead':
    'Estás utilizando un entorno de librerías compartido. Pyplan necesita generar un entorno exclusivo para que puedas agregar/quitar librerías (esta tarea puede tardar unos minutos).',
  'app.pages.app.topbar.libsManager.cantInstallTasksHead':
    'Para esto se realizarán las siguientes tareas:',
  'app.pages.app.topbar.libsManager.cantInstallTask1': 'se guardará la aplicación actual',
  'app.pages.app.topbar.libsManager.cantInstallTask2': 'un nuevo entorno exclusivo será generado',
  'app.pages.app.topbar.libsManager.cantInstallTask3':
    'la aplicación se abrirá nuevamente con el entorno exclusivo',
  'app.pages.app.topbar.libsManager.cantInstallConfirmationMessage':
    '¿Estás seguro de que deseas realizar estas tareas?',
  'app.pages.app.topbar.libsManager.cantInstallButtonText': 'Sí, realizar estas tareas',
  'app.pages.app.topbar.changeAppVersion': 'Cambiar versión de la aplicación',
  'app.pages.app.topbar.changeVersion': 'Cambiar versión',
  'app.pages.app.topbar.takeScreenshot': 'Tomar captura de pantalla',
  'app.pages.app.topbar.goToAppFolder': 'Ir a carpeta de la aplicación',
  'app.pages.app.topbar.screenshotResult': 'Resultado de la captura de pantalla',
  'app.pages.app.topbar.downloadScreenshot': 'Descargar imagen',
  'app.pages.app.topbar.saveImageAsAppThumbnail': 'Guardar imagen como miniatura de la aplicación',
  'app.pages.app.topbar.appIdError':
    'El ID de la aplicación sólo puede contener números, letras, guiones y debe tener más de 7 caracteres',
  'app.pages.app.topbar.mustRestartAppWarning':
    'Para que los cambios surtan efecto, debes reiniciar la aplicación.',
  'app.pages.app.topbar.allDataRelatedTo': 'Todos los datos relacionados con:',
  'app.pages.app.topbar.additionalInformation': 'Información adicional',
  'app.pages.app.topbar.nodesEvaluatedMessage': 'Nodos evaluados al abrir la aplicación',
  'app.pages.app.topbar.noNodesEvaluated':
    'No hay nodos que se evalúen cuando se abre la aplicación.',
  'app.pages.app.topbar.defaultSettings': 'Opciones predeterminadas',
  'app.pages.app.topbar.componentHeaderBackgroundColor':
    'Color de fondo del encabezado del componente - tablas, gráficos, indicadores, formularios',
  'app.pages.app.topbar.componentHeaderTextColor':
    'Color del texto del encabezado del componente - tablas, gráficos, indicadores, formularios',
  'app.pages.app.topbar.commonHeaderBackgroundColor':
    'Color de fondo del encabezado del componente - índices, selectores',
  'app.pages.app.topbar.commonHeaderColor':
    'Color del texto del encabezado del componente - índices, selectores',
  'app.pages.app.topbar.libsManager.creatingEnvironmentSuccess': 'Entorno creado',
  'app.pages.app.topbar.showColumnFilterIcon': 'Mostrar icono de filtro de columna',
  'app.pages.app.topbar.showIndex': 'Mostrar índice',
  'app.pages.app.topbar.defaultStylesComponentHeaderColorsSection':
    'Colores del encabezado del componente',
  'app.pages.app.topbar.defaultStylesTableOptionsSection': 'Opciones de tablas',
  'app.pages.app.topbar.defaultStylesChartOptionsSection': 'Opciones de gráficos',
  'app.pages.app.topbar.defaultStylesFormatsSection': 'Formatos predeterminados',
  'app.pages.app.topbar.dateFormatLabel': 'Formato de fechas',
  'app.pages.app.topbar.dateTimeFormatLabel': 'Formato de fecha y hora',
  'app.pages.app.topbar.indexFormatLabel': 'Formato de índices',
  'app.pages.app.topbar.selectorFormatLabel': 'Formato de selectores',
  'app.pages.app.topbar.defaultStylesFormPropertiesSection': 'Opciones de formularios',
  'app.pages.app.topbar.buildAutomaticDateHierarchies':
    'Construir jerarquías de fechas automáticas',
  'app.pages.app.topbar.scenarioFillMissingWithZero': 'Rellenar valores faltantes con cero',
  'app.pages.app.topbar.scenarioZeroDivisionReturnsZero': 'La división por cero retorna cero',
  'app.pages.app.topbar.fontFamily': 'Familia de fuente',
  'app.pages.app.topbar.tableNonEditableCellBackgroundColor': 'Color de fondo de celda no editable',
  'app.pages.app.topbar.tableNonEditableCellColor': 'Color de texto de celda no editable',
  'app.pages.app.topbar.tableEditableCellBackgroundColor': 'Color de fondo de celda editable',
  'app.pages.app.topbar.tableEditableCellColor': 'Color de texto de celda editable',
  'app.pages.app.topbar.tableLabelsBackgroundColor': 'Color de fondo de etiquetas',
  'app.pages.app.topbar.tableLabelsColor': 'Color de texto de etiquetas',
  'app.pages.app.topbar.tableColorsLightTheme': 'Tema claro',
  'app.pages.app.topbar.tableColorsDarkTheme': 'Tema oscuro',
  'app.pages.app.topbar.chartColorPalettes': 'Paletas de colores',

  //Info menu dialog:
  'app.pages.app.closeApp': 'Cerrar aplicación',
  'app.pages.app.closedSuccessfully': 'Aplicación cerrada exitosamente',
  'app.pages.app.reloadSuccessfully': 'Aplicación recargada exitosamente',
  'app.pages.app.saveSuccessfully': 'Aplicación guardada exitosamente',
  'app.pages.app.appNewPath': 'La aplicación fue guardada en: ',
  'app.pages.app.saveApp': 'Guardar',
  'app.pages.app.newModelName': 'Nombre del nuevo modelo',
  'app.pages.app.newModelNamePlaceholder': 'Ingresa el nombre del nuevo modelo',
  'app.pages.app.unconfirmedNodes': 'Nodos sin confirmar',
  'app.pages.app.saveDefinitionsAndApp': 'Confirmar definiciones y guardar aplicación',
  'app.pages.app.discardDefinitionsAndSaveApp': 'Descartar definiciones y guardar aplicación',
  'app.pages.app.unconfirmedNodesAlert':
    'Hay {number} nodos con definiciones sin confirmar. ¿Qué te gustaría hacer?',
  'app.pages.app.lostDataAlert':
    'Los cambios no guardados de la aplicación se perderán. ¿Estás seguro?',
  'app.pages.app.unsavedChanges': 'Tienes cambios no guardados. ¿Qué te gustaría hacer?',
  'app.pages.app.saveChangesAndOpenApp': 'Guardar cambios y abrir app',
  'app.pages.app.discardChangesAndOpenApp': 'Descartar cambios y abrir app',
  'app.pages.app.saveChangesAndCreateApp': 'Guardar cambios y crear app',
  'app.pages.app.discardChangesAndCreateApp': 'Descartar cambios y crear app',
  'app.pages.app.saveChangesAndLogout': 'Guardar cambios y cerrar sesión',
  'app.pages.app.saveChangesAndReload': 'Guardar cambios y recargar app',
  'app.pages.app.saveChangesAndCloseApp': 'Guardar cambios y cerrar app',

  //sidebarMenu
  'app.pages.app.sidebarMenu.fileManager': 'Administrador de archivos',
  'app.pages.app.sidebarMenu.code': 'Código',
  'app.pages.app.sidebarMenu.interfaces': 'Interfaces',
  'app.pages.app.sidebarMenu.tools': 'Herramientas',
  'app.pages.app.sidebarMenu.aiManagement': 'Gestión de IA',
  'app.pages.app.sidebarMenu.scheduledTasks': 'Tareas programadas',
  'app.pages.app.sidebarMenu.myAccount': 'Mi cuenta',
  'app.pages.app.sidebarMenu.settings': 'Ajustes',
  'app.pages.app.sidebarMenu.securityOptions': 'Opciones de seguridad',
  'app.pages.app.sidebarMenu.users': 'Usuarios',
  'app.pages.app.sidebarMenu.departments': 'Departamentos',
  'app.pages.app.sidebarMenu.teams': 'Equipos',
  'app.pages.app.sidebarMenu.instance': 'Administrador de instancias',
  'app.pages.app.sidebarMenu.permissionByRole': 'Permisos por rol',
  'app.pages.app.sidebarMenu.applications': 'Aplicaciones',
  'app.pages.app.sidebarMenu.processManager': 'Procesos',
  'app.pages.app.sidebarMenu.home': 'Inicio',
  'app.pages.app.sidebarMenu.numberLocale': 'Formato numérico',
  'app.pages.app.sidebarMenu.language': 'Idioma',
  'app.pages.app.sidebarMenu.applicationAnalysis': 'Análisis',
  'app.pages.app.sidebarMenu.connections': 'Conexiones',
  'app.pages.app.sidebarMenu.applicationTests': 'Pruebas de la aplicación',
  'app.pages.app.sidebarMenu.support': 'Soporte',
  'app.pages.app.sidebarMenu.supportNewTicket': 'Crear ticket',
  'app.pages.app.sidebarMenu.supportMyTickets': 'Mis tickets',
  'app.pages.support.errors.tabBlocked':
    'El navegador bloqueó la pestaña de Pyplan Support. Permite las ventanas emergentes de este sitio e inténtalo nuevamente.',
  'app.pages.support.errors.timeout':
    'Pyplan tardó demasiado en abrir Pyplan Support. Inténtalo nuevamente.',
  'app.pages.support.errors.network':
    'No se pudo conectar con Pyplan para abrir Pyplan Support. Revisa tu conexión e inténtalo nuevamente.',
  'app.pages.support.errors.invalidResponse':
    'No se pudo abrir Pyplan Support porque Pyplan envió una respuesta inesperada. Inténtalo nuevamente.',
  'app.pages.support.errors.notEnabled': 'Pyplan Support no está habilitado para tu empresa.',
  'app.pages.support.errors.emailRequired':
    'Tu usuario necesita un email válido para abrir Pyplan Support. Pide a tu administrador que lo agregue.',
  'app.pages.support.errors.sessionExpired':
    'Tu sesión ya no puede abrir Pyplan Support. Inicia sesión de nuevo e inténtalo nuevamente.',
  'app.pages.support.errors.unavailable':
    'No se pudo abrir Pyplan Support (error {status}). Inténtalo más tarde.',

  //home
  'app.pages.app.home.myPyplan': 'Mi Pyplan',
  'app.pages.app.home.openApps': 'Aplicaciones abiertas',
  'app.pages.app.home.workspaces': 'Espacios de trabajo',
  'app.pages.app.home.folders': 'Carpetas',
  'app.pages.app.home.instanceKilledSuccessfully': 'Instancia eliminada exitosamente',
  'app.pages.app.home.instanceChangedSuccessfully': 'Instancia cambiada exitosamente',
  //home.pyplanResources
  'app.pages.app.home.pyplanResources': 'Recursos Pyplan',
  'app.pages.app.home.pyplanResources.videos': 'Videos',
  'app.pages.app.home.pyplanResources.videosCaption': 'Ver Pyplan en acción',
  'app.pages.app.home.pyplanResources.documentation': 'Documentación',
  'app.pages.app.home.pyplanResources.documentationCaption': 'Pasos básicos',
  'app.pages.app.home.pyplanResources.examples': 'Ejemplos',
  'app.pages.app.home.pyplanResources.examplesCaption': 'de aplicaciones',

  //home.shortcutsPanel
  'app.pages.app.home.shortcutsPanel.tutorials': 'Tutoriales',
  'app.pages.app.home.shortcutsPanel.examples': 'Ejemplos',
  'app.pages.app.home.shortcutsPanel.demos': 'Demostraciones',
  'app.pages.app.home.shortcutsPanel.models': 'Modelos',
  'app.pages.app.home.shortcutsPanel.noModelFound':
    'No se abrieron modelos recientemente. Explora tus archivos o crea uno nuevo.',
  'app.pages.app.home.shortcutsPanel.noExamplesFound': 'No se encontraron ejemplos',
  'app.pages.app.home.shortcutsPanel.my_apps': 'Mis aplicaciones',
  'app.pages.app.home.shortcutsPanel.public_apps': 'Aplicaciones públicas',
  'app.pages.app.home.shortcutsPanel.recently_opened': 'Abiertas recientemente',
  'app.pages.app.home.shortcutsPanel.noPermissionsToViewApps':
    'No tienes permisos para ver aplicaciones. Por favor, contacta a un administrador.',

  //editProfile
  'app.pages.editProfile.editProfile': 'Perfil',
  'app.pages.editProfile.changePasswordAlert':
    'Si cambias tu contraseña, tu instancia se cerrará y deberás iniciar sesión nuevamente',
  'app.pages.editProfile.currentPassword': 'Contraseña actual',
  'app.pages.editProfile.currentPasswordIncorrect': 'La contraseña actual es incorrecta',
  //my account
  'app.pages.myAccount.title': 'Mi cuenta',
  'app.pages.myAccount.preferences': 'Preferencias',
  'app.pages.myAccount.accessTokens': 'Tokens de acceso',
  'app.pages.accessTokens.title': 'Tokens de acceso personales',
  'app.pages.accessTokens.description':
    'Los tokens de acceso personales permiten que clientes headless (Claude Code, scripts, otros clientes MCP) e integraciones de API se autentiquen en tu nombre con un token bearer estático, en reemplazo del login interactivo. Trátalos como contraseñas.',
  'app.pages.accessTokens.create': 'Crear token',
  'app.pages.accessTokens.name': 'Nombre',
  'app.pages.accessTokens.defaultCompany': 'Company por defecto',
  'app.pages.accessTokens.defaultCompanyHelp':
    'La sesión arranca en esta company; el asistente puede cambiarla luego.',
  'app.pages.accessTokens.expiration': 'Expiración',
  'app.pages.accessTokens.expiresInDays': '{days} días',
  'app.pages.accessTokens.createdAt': 'Creado',
  'app.pages.accessTokens.expiresAt': 'Expira',
  'app.pages.accessTokens.lastUsed': 'Último uso',
  'app.pages.accessTokens.status': 'Estado',
  'app.pages.accessTokens.active': 'Activo',
  'app.pages.accessTokens.expired': 'Expirado',
  'app.pages.accessTokens.revoked': 'Revocado',
  'app.pages.accessTokens.revoke': 'Revocar',
  'app.pages.accessTokens.revokeConfirm':
    '¿Revocar este token? Los clientes que lo usen dejarán de funcionar.',
  'app.pages.accessTokens.copyWarning': 'Copia este token ahora; no se volverá a mostrar.',
  'app.pages.accessTokens.copy': 'Copiar',
  'app.pages.accessTokens.copied': 'Copiado',
  'app.pages.accessTokens.empty': 'Todavía no tienes tokens de acceso.',
  'app.pages.accessTokens.descriptionForAgent':
    'Los tokens de acceso permiten que este agente se autentique desde clientes headless (Claude Code, scripts, otros clientes MCP) con un bearer token estático. El agente no puede iniciar sesión, así que sus tokens se gestionan aquí. Trátalos como contraseñas.',
  'app.pages.accessTokens.emptyForAgent': 'Este agente todavía no tiene tokens de acceso.',
  'app.pages.accessTokens.nameRequired': 'El nombre es obligatorio',
  'app.pages.accessTokens.createError': 'No se pudo crear el token. Inténtalo nuevamente.',
  //scim tokens (company manager)
  'app.pages.scimTokens.title': 'Tokens SCIM',
  'app.pages.scimTokens.create': 'Crear token',
  'app.pages.scimTokens.name': 'Nombre',
  'app.pages.scimTokens.company': 'Company',
  'app.pages.scimTokens.prefix': 'Prefijo',
  'app.pages.scimTokens.createdAt': 'Creado',
  'app.pages.scimTokens.expiresAt': 'Expira',
  'app.pages.scimTokens.lastUsedAt': 'Último uso',
  'app.pages.scimTokens.status': 'Estado',
  'app.pages.scimTokens.active': 'Activo',
  'app.pages.scimTokens.expired': 'Expirado',
  'app.pages.scimTokens.revoked': 'Revocado',
  'app.pages.scimTokens.revoke': 'Revocar',
  'app.pages.scimTokens.revokeConfirm': '¿Revocar este token? Entra ID dejará de poder usarlo.',
  'app.pages.scimTokens.copy': 'Copiar',
  'app.pages.scimTokens.copied': 'Copiado',
  'app.pages.scimTokens.copyWarning': 'Copia este token ahora; no se volverá a mostrar.',
  'app.pages.scimTokens.empty': 'Esta company todavía no tiene tokens SCIM.',
  'app.pages.scimTokens.nameRequired': 'El nombre es obligatorio',
  'app.pages.scimTokens.noExpiration': 'Sin expiración',
  'app.pages.scimTokens.createError': 'No se pudo crear el token. Inténtalo nuevamente.',
  'app.pages.scimTokens.tabSecretToken': 'Secret Token',
  'app.pages.scimTokens.tabOAuth2': 'OAuth 2.0',
  'app.pages.scimTokens.oauth2Create': 'Crear client',
  'app.pages.scimTokens.oauth2Help':
    'El Token Endpoint que hay que cargar en Entra es /api/oauth2/token de este servidor.',
  'app.pages.scimTokens.oauth2ClientId': 'Client ID',
  'app.pages.scimTokens.oauth2ClientSecret': 'Client Secret',
  'app.pages.scimTokens.oauth2CopyWarning':
    'Copia el Client Secret ahora; no se volverá a mostrar.',
  'app.pages.scimTokens.oauth2Empty': 'Esta company todavía no tiene clients OAuth2.',
  'app.pages.myAccount.personalData': 'Datos personales',
  'app.pages.myAccount.formatAndLanguage': 'Formato e idioma',
  'app.pages.myAccount.theme': 'Tema',

  //managers
  'app.pages.app.managers.firstPage': 'Primera',
  'app.pages.app.managers.prevPage': 'Anterior',
  'app.pages.app.managers.nextPage': 'Siguiente',
  'app.pages.app.managers.lastPage': 'Última',
  'app.pages.app.managers.cancel': 'Cancelar',
  'app.pages.app.managers.create': 'Crear',
  'app.pages.app.managers.update': 'Actualizar',
  'app.pages.app.managers.search': 'Buscar',
  'app.pages.app.managers.searchHelperText': 'Escribe al menos 3 caracteres',
  'app.pages.app.managers.companyManager': 'Administrador de compañías',
  'app.pages.app.managers.folder': 'Carpeta',
  'app.pages.app.managers.departmentManager': 'Administrador de Departamentos',
  'app.pages.app.managers.rowsPerPage': 'Filas por página',
  'app.pages.app.managers.company': 'Compañía',
  'app.pages.app.managers.company.companies': 'Compañías',
  'common.name.isRequired': 'El nombre es requerido',
  'app.pages.app.managers.company.notFound': 'Compañía no encontrada',
  'app.pages.app.managers.company.placeholder': 'Elige una compañía',
  'app.pages.app.managers.company.isRequired': 'La compañía es requerida',
  'app.pages.app.managers.roleManager': 'Administrador de roles',
  'app.pages.managers.invalidJSON': 'No es un JSON válido',
  'app.pages.managers.actions': 'Acciones',
  'app.pages.managers.departments': 'Departamentos',
  'app.components.departmentSelector.searchPlaceholder': 'Escribe para buscar departamentos...',
  'app.pages.managers.mainDepartment': 'Departamento principal',
  'app.pages.managers.add': 'Agregar',
  'app.pages.managers.role': 'Rol',
  'app.pages.managers.roles': 'Roles',
  'app.pages.app.managers.back': 'Volver',
  'app.pages.app.managers.unkwownStep': 'Paso desconocido',
  'app.pages.app.managers.saveButton': 'Guardar',
  'app.pages.app.managers.nextButton': 'Siguiente',
  'app.pages.app.managers.companies': 'Compañías',
  'app.pages.managers.instances': 'Instancias',
  'app.pages.managers.password': 'Contraseña',
  'app.pages.managers.newPassword': 'Nueva contraseña',
  'app.pages.managers.confirmPassword': 'Confirmar contraseña',
  'app.pages.managers.passwordIsRequired': 'La contraseña es requerida',
  'app.pages.managers.ConfirmPasswordIsRequired': 'Confirmar contraseña es requerido',
  'app.pages.managers.passwordMinLength':
    'La contraseña es demasiado corta - debe tener  {number} caracteres mínimo',
  'app.pages.managers.passwordInvalidRequisites':
    'La contraseña debe tener al menos una mayúscula, una minúscula, un número y un carácter especial',
  'app.pages.managers.passwordsNotMatch': 'Las contraseñas no coinciden',
  'app.pages.managers.send': 'Enviar',
  'app.pages.app.managers.delete': 'Eliminar',
  'app.pages.app.managers.createAppFromThis': 'Crear aplicación a partir de ésta',
  'app.pages.app.managers.applicationSuccessfullyCreated': 'Aplicación creada exitosamente en',
  'app.pages.app.managers.newFolder': 'Nueva carpeta',
  'app.pages.app.managers.newFile': 'Nuevo archivo',
  'app.pages.app.managers.rename': 'Renombrar',
  'app.pages.app.managers.set_permission': 'Configurar permisos',
  'app.pages.app.managers.duplicate': 'Duplicar',
  'app.pages.app.managers.openAsReadOnly': 'Abrir como sólo lectura',
  'app.pages.app.managers.copyAppToWorkspace': 'Copiar aplicación en espacio de trabajo',
  'app.pages.app.managers.copyAppToTeam': 'Copiar aplicación a un equipo',
  'app.pages.app.managers.copyAppToPublic': 'Copiar aplicación a Public',
  'app.pages.app.managers.downloadApp': 'Descargar aplicación',
  'app.pages.app.managers.appDownloaded': 'Aplicación descargada',
  'app.pages.app.managers.copyInterfaceId': 'Copiar id de la interfaz',
  'app.pages.app.managers.idCopied': 'Id copiado',
  'app.pages.app.managers.folderExists': 'La carpeta ya existe',

  // Connections Manager
  'app.pages.app.managers.connectionsManager.connection': 'Conexión',
  'app.pages.app.managers.connectionsManager.connections': 'Conexiones',
  'app.pages.app.managers.connectionsManager.addNewConnection': 'Agregar nueva conexión',
  'app.pages.connectionsManager.addConnection': 'Agregar conexión',
  'app.pages.app.managers.connectionsManager.stablishingConnection': 'Estableciendo conexión',
  'app.pages.app.managers.connectionsManager.createConnection': 'Crear conexión',
  'app.pages.app.managers.connectionsManager.testConnection': 'Probar conexión',
  'app.pages.managers.connectionsManager.successfullyTestedConnection':
    'Conexión probada exitosamente',
  'app.pages.app.managers.editConnection': 'Editar conexión',
  'app.pages.app.managers.removeConnection': 'Eliminar conexión',
  'app.pages.app.managers.areYouSureYouWantToRemoveConnection':
    '¿Estás seguro de que deseas eliminar esta conexión?',
  'app.pages.connectionsManager.erpSystems': 'Sistemas ERP',
  'app.pages.connectionsManager.crmSystems': 'Sistemas CRM',
  'app.pages.connectionsManager.relationalDatabases': 'Bases de datos relacionales',
  'app.pages.connectionsManager.nosqlDatabases': 'Bases de datos NoSQL',
  'app.pages.connectionsManager.flatFiles': 'Archivos planos',
  'app.pages.connectionsManager.cloudPlatforms': 'Plataformas en la nube',
  'app.pages.connectionsManager.dataWarehouses': 'Almacenes de datos',
  'app.pages.connectionsManager.apisAndServices': 'APIs y servicios',
  'app.pages.connectionsManager.supplyChainServices': 'Servicios de cadena de suministro',
  'app.pages.managers.connectionsManager.connectionsNotFound': 'No se encontraron conexiones',
  'app.pages.managers.connectionsManager.successfullyCreatedConnection':
    'Conexión creada exitosamente',
  'app.pages.managers.connectionsManager.successfullyUpdatedConnection':
    'Conexión actualizada exitosamente',
  'app.pages.managers.connectionsManager.successfullyRemovedConnection':
    'Conexión eliminada exitosamente',
  'app.pages.managers.connectionsManager.executed': 'Ejecutado',

  // Translation Manager
  'app.pages.app.managers.translationsManager': 'Traducciones',
  'app.pages.app.managers.translationsManager.initialText': 'Texto inicial',
  'app.pages.app.managers.translationsManager.parent': 'Padre',
  'app.pages.app.managers.translationsManager.node': 'Nodo',
  'app.pages.app.managers.translationsManager.node.plural': 'Nodos',
  'app.pages.app.managers.translationsManager.interface': 'Interfaz',
  'app.pages.app.managers.translationsManager.interface.plural': 'Interfaces',
  'app.pages.app.managers.translationsManager.component': 'Componente de interfaz',
  'app.pages.app.managers.translationsManager.component.plural': 'Componentes de interfaz',
  'app.pages.app.managers.translationsManager.menuItemText': 'Texto del ítem de menú',
  'app.pages.app.managers.translationsManager.menuItemText.plural': 'Textos de ítems de menú',
  'app.pages.app.managers.translationsManager.menuItemSubtitle': 'Subtítulo del ítem de menú',
  'app.pages.app.managers.translationsManager.menuItemSubtitle.plural':
    'Subtítulos de ítems de menú',
  'app.pages.app.managers.translationsManager.menuActionText': 'Texto de la acción del menú',
  'app.pages.app.managers.translationsManager.menuActionText.plural': 'Textos de acciones del menú',
  'app.pages.app.managers.translationsManager.menuActionSubtitle':
    'Subtítulo de la acción del menú',
  'app.pages.app.managers.translationsManager.menuActionSubtitle.plural':
    'Subtítulos de acciones del menú',
  'app.pages.app.managers.translationsManager.translationsNotFound':
    'No se encontraron traducciones',
  'app.pages.app.managers.translationsManager.filterType': 'Filtrar por tipo',
  'app.pages.app.managers.translationsManager.interfaceDocumentationSuccessfullyUpdated':
    'Documentación de la interfaz actualizada exitosamente',
  'app.pages.app.managers.translationsManager.automaticallyCompleteTranslations':
    'Completar automáticamente traducciones',
  'app.pages.app.managers.translationsManager.confirmAutomaticTranslations':
    'Confirmar traducciones automáticas',
  'app.pages.app.managers.translationsManager.translationsCompleted': 'Traducciones completadas',
  'app.pages.app.managers.translationsManager.confirmAutomaticTranslationsContent':
    'Se traducirán automáticamente los siguientes ítems: ',
  'app.pages.app.managers.translationsManager.translateCurrentRow': 'Traducir fila actual',
  'app.pages.app.managers.translationsManager.translatingCurrentRow': 'Traduciendo fila actual',
  'app.pages.app.managers.translationsManager.translatingItems': 'Traduciendo {numbers} ítems',
  'app.pages.app.managers.translationsManager.translationsSettings':
    'Configuración de traducciones',
  'app.pages.app.managers.translationsManager.automaticTranslationsError':
    'Ocurrió un error al intentar traducir automáticamente los elementos. Por favor, inténtalo de nuevo más tarde.',

  // Notifications Manager
  'app.pages.app.notificationsManager.notificationsManager': 'Administrador de notificaciones',
  'app.pages.app.notificationsManager.addNotification': 'Agregar notificación',
  'app.pages.app.notificationsManager.editNotification': 'Editar notificación',
  'app.pages.app.notificationsManager.successChangedNotificationStatus':
    'Estado de notificación cambiado exitosamente',
  'app.pages.app.notificationsManager.removeNotification': 'Eliminar notificación',
  'app.pages.app.notificationsManager.removeNotificationConfirmation':
    '¿Estás seguro de que deseas eliminar esta notificación?',
  'app.pages.app.notificationsManager.successRemovedNotification':
    'Notificación eliminada exitosamente',
  'app.pages.app.notificationsManager.successAddedNotification':
    'Notificación agregada exitosamente',
  'app.pages.app.notificationsManager.effectiveDate': 'Fecha de validez',
  'app.pages.app.notificationsManager.noNotifications': 'Sin notificaciones',
  'app.pages.app.notificationsManager.notificationTitle': 'Título de la notificación',
  'app.pages.app.notificationsManager.notificationDescription': 'Descripción de la notificación',
  'app.pages.app.notificationsManager.notification': 'Notificación',

  //companyManager
  'app.pages.app.companyManager.newCompany': 'Crear compañía',
  'app.pages.app.companyManager.editCompany': 'Actualizar compañía',
  'app.pages.app.companyManager.companyPreferences': 'Preferencias',
  'app.pages.app.companyManager.scimTokens': 'Tokens SCIM',
  'app.pages.app.companyManager.successChangedStatus': 'Estado cambiado con éxito',
  //companyManager.companyTable
  'app.pages.app.companyManager.companyTable.companyStatusColumn': 'Estado',
  'app.pages.app.companyManager.companyTable.companyTableAriaLabel': 'Tabla de compañías',
  'app.pages.app.companyManager.companyTable.companiesNotFound': 'No se han encontrado compañías',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataTitle':
    'Eliminar la compañía {companyName}',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataWarning':
    'Esto eliminará la compañía de forma permanente y quitará las asignaciones de todos sus usuarios. Se eliminarán de forma permanente sus departamentos, teams, roles, tareas programadas, configuración de IA, secrets, api keys, historial de emails y procesos de workflow, y se borrarán las carpetas Public, Teams y Media junto con todos los workspaces de los usuarios. Esta acción no se puede deshacer.',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataInputLabel':
    'Escribe "{keyword}" para confirmar',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataConfirmButton': 'Eliminar compañía',
  'app.pages.app.companyManager.companyTable.deleteCompanyDataDisabledCurrentCompany':
    'No puedes eliminar la compañía a la que estás conectado actualmente',
  'app.pages.app.companyManager.companyTable.successDeletedCompanyData':
    'Compañía eliminada correctamente',
  'app.pages.app.companyManager.hasSaml': 'Tiene configuración SAML',
  'app.pages.app.companyManager.noSamlConfiguration':
    'La compañía {company} no tiene SAML configurado',
  'app.pages.login.samlCompanyAccessDenied':
    'Tu usuario no pertenece a la compañía {company}. Inicia sesión con una compañía válida o contacta a tu administrador.',

  //companyManager.addOrEdit
  'app.pages.companyManager.addOrEdit.companyNameField': 'Nombre de la compañía',
  'app.pages.companyManager.addOrEdit.companyCodeField': 'Nombre de la carpeta',
  'app.pages.companyManager.addOrEdit.companyActivationCodeField': 'Código de activación',
  'app.pages.companyManager.addOrEdit.copiedCompanyActivationCode':
    'Código de activación - Copiado ✓',
  'app.pages.companyManager.addOrEdit.companyLicenseField': 'Licencia',
  'app.pages.companyManager.addOrEdit.companyLogos': 'Logos',
  'app.pages.companyManager.addOrEdit.companyLogo': 'Logo de la compañía',
  'app.pages.companyManager.addOrEdit.companyLogoHelp':
    'Se muestra dentro de la aplicación y en la pantalla de login.',
  'app.pages.companyManager.addOrEdit.companyEmailLogo': 'Logo para emails',
  'app.pages.companyManager.addOrEdit.companyEmailLogoHelp':
    'Se muestra en los emails que envía la plataforma. Se renderiza a 36 px de alto sobre fondo blanco, así que conviene una imagen clara y apaisada.',
  'app.pages.companyManager.addOrEdit.emailLogoDropzoneFirstRow':
    'Arrastra y suelta el logo para emails o',
  'app.pages.companyManager.addOrEdit.dropzoneFirstRow':
    'Arrastra y suelta un logo para la compañía aquí o',
  'app.pages.companyManager.addOrEdit.dropzoneLinkRow': 'Explora tus archivos',
  'app.pages.companyManager.addOrEdit.companyFieldRequiredError': 'Campo requerido',
  'app.pages.companyManager.addOrEdit.companyFieldMaxLengthError':
    'No puede exceder los 255 caracteres',
  'app.pages.companyManager.addOrEdit.companyFolderAlreadyExists':
    'Ya existe una carpeta con ese nombre, por favor elige otro código',
  'app.pages.companyManager.addOrEdit.copyToClipboard': 'Copiar al portapapeles',
  'app.pages.companyManager.addOrEdit.copiedData': 'Datos copiados al portapapeles',
  'app.pages.companyManager.addOrEdit.invalidFileExtension':
    'Archivo inválido. Se requiere una imagen',
  'app.pages.app.companyManager.successAddedCompany': 'Compañía creada con éxito',
  'app.pages.app.companyManager.successEditedCompany': 'Compañía editada con éxito',
  'app.pages.app.companyManager.removeLicense': 'Remover licencia',
  'app.pages.companyManager.addOrEdit.licenseExpirationDateField':
    'Fecha de expiración de la licencia',
  'app.pages.companyManager.addOrEdit.licensesAssignedField': 'Licencias asignadas',
  'app.pages.companyManager.addOrEdit.licensesAvailableField': 'Licencias disponibles',
  'app.pages.companyManager.addOrEdit.licensesOccupiedField': 'Licencias ocupadas',
  'app.pages.companyManager.addOrEdit.licenseUsageTitle': 'Asientos por rol',
  'app.pages.companyManager.addOrEdit.licenseUsageExceeded': 'Excedido',
  'app.pages.companyManager.addOrEdit.licenseUsageNoRole': 'Sin rol con este nombre',
  'app.pages.companyManager.addOrEdit.licenseWarningsTitle':
    'Esta licencia tiene advertencias. Se puede guardar igual.',
  'app.pages.license.savedWithWarnings': 'La licencia se guardó con advertencias',
  'app.pages.companyManager.addOrEdit.licenseExpirationRecipientsField':
    'Notificar el vencimiento de la licencia a',
  'app.pages.companyManager.addOrEdit.invalidLicenseExpirationRecipients':
    'Uno o más destinatarios del aviso de vencimiento ya no son usuarios activos de la empresa. Se actualizó la lista: revísala y guarda de nuevo.',
  'app.pages.companyManager.addOrEdit.licenseExpirationRecipientsHelp':
    'Si no se elige ninguno, el aviso se envía a los usuarios con rol Super Administrator, Administrator y App Administrator.',

  //Department Manager
  'app.pages.DepartmentPage.addDepartment': 'Agregar departamento',
  'app.pages.DepartmentPage.editDepartment': 'Editar departamento',
  'app.pages.DepartmentPage.engineDefinitions': 'Definiciones del motor',
  'app.pages.DepartmentPage.loginAction': 'Acciones al loguearse',
  'app.pages.DepartmentPage.deniedItems': 'Accesos denegados',
  'app.pages.DepartmentPage.allowedItems': 'Accesos permitidos',
  'app.pages.DepartmentPage.name.maxLengthError':
    'El tamaño máximo del nombre es de {number} caracteres',
  'app.pages.DepartmentPage.department.notFound': 'No se han encontrado departamentos',
  'app.pages.DepartmentPage.department.created': 'Departamento creado',
  'app.pages.DepartmentPage.department.updated': 'Departamento actualizado',
  'app.pages.DepartmentPage.departmentManagerTable': 'Tabla de administrador de departamentos',
  'app.pages.DepartmentPage.addLoginAction': 'Agregar acción al loguearse',
  'app.pages.DepartmentPage.downloadReport': 'Descargar reporte de departamentos',
  'app.pages.DepartmentPage.reportDownloaded': 'Reporte de departamentos descargado',
  'app.pages.DepartmentPage.department': 'Departamento',

  //Role Manager
  'app.pages.RolePage.addRole': 'Agregar rol',
  'app.pages.RolePage.editRole': 'Editar rol',
  'app.pages.RolePage.role.notFound': 'No se han encontrado roles',
  'app.pages.RolePage.role.permission.template': 'Plantilla de Permisos',
  'app.pages.RolePage.role.permission.administrator': 'Administrador',
  'app.pages.RolePage.role.permission.appAdministrator': 'Administrador de App',
  'app.pages.RolePage.role.permission.creatorWithPublicAccess': 'Creador con Acceso al Public',
  'app.pages.RolePage.role.permission.creator': 'Creador',
  'app.pages.RolePage.role.permission.explorer': 'Navegador',
  'app.pages.RolePage.role.permission.viewer': 'Visualizador',
  'app.pages.RolePage.role.permission.loginOnlyUser': 'Usuario con Login Únicamente',
  'app.pages.RolePage.role.permission.override': 'Estás por sobreescribir todos los permisos',
  'app.pages.RolePage.role.created': 'Rol creado',
  'app.pages.RolePage.role.updated': 'Rol actualizado',
  'app.pages.RolePage.name.maxLengthError':
    'El nombre del rol no puede ser mayor a {number} caracteres',
  'app.pages.RolePage.name.exist': 'El nombre del rol ya existe',
  'app.pages.RolePage.roleManagerTable': 'Tabla de administrador de roles',

  //notFoundPage
  'app.components.notFoundPage.message': 'La página que buscas no existe',
  'app.components.notFoundPage.orGoTo': 'o ir a',
  'app.components.notFoundPage.returnToThe': 'Volver a la',
  'app.components.notFoundPage.previousPage': 'página anterior',
  'app.components.notFoundPage.homePage': 'página de inicio',

  //Company Preferences
  'app.pages.app.companyManager.companyPreferences.notFound': 'Preferencias no encontradas',
  'app.pages.app.companyManager.companyPreferences.title': 'Preferencias de la compañía ',
  'app.pages.app.companyManager.companyPreferences.copyDefaultValue': 'Copiar valor por defecto',
  'app.pages.app.companyManager.companyPreferences.defaultValueCopied': 'Valor por defecto copiado',
  'app.pages.app.companyManager.companyPreferences.preferenceUpdated': 'Preferencia actualizada',
  'app.pages.app.companyManager.companyPreferences.preferenceCreated': 'Preferencia creada',
  'app.pages.app.companyManager.companyPreferences.preferenceDelete': 'Preferencia removida',
  'app.pages.app.companyManager.companyPreferences.saveCustomValue': 'Guardar valor personalizado',
  'app.pages.app.companyManager.companyPreferences.removeCustomValue':
    'Remover valor personalizado',
  'app.pages.app.companyManager.companyPreferences.openJsonEditor': 'Abrir editor de JSON',
  'app.pages.app.companyManager.companyPreferences.jsonEditorTitle': 'Editar valor JSON',
  'app.pages.app.companyManager.companyPreferences.editDefaultValue': 'Editar valor por defecto',
  'app.pages.app.companyManager.companyPreferences.invalidValue':
    'No es un valor válido. Valores disponibles: {values}',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingUploadTooltip':
    'Subir {fileName}',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingUploaded': 'Archivo subido',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingUploadError':
    'Error al subir el archivo',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingWrongFileName':
    "Se esperaba un archivo llamado '{expectedName}'",
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingManageFiles':
    'Administrar archivos subidos',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingStatusUploaded': 'Subido',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingStatusError': 'Error al subir',
  'app.pages.app.companyManager.companyPreferences.samlCustomMappingStatusPending':
    'Aún no se subió',

  //Permissions by role
  'app.pages.app.permissionsByRole': 'Permisos por rol',
  'app.pages.app.permissionsByRole.permissionActivated': 'Permiso activado',
  'app.pages.app.permissionsByRole.permissionDeactivated': 'Permiso desactivado',
  'app.pages.app.permissionsByRole.allPermissionsActivated':
    'Todos los permisos para {name} fueron activados',
  'app.pages.app.permissionsByRole.permission': 'Permiso',
  'app.pages.app.permissionsByRole.permissionsUpdated': 'Permisos actualizados',

  //team manager
  'app.pages.app.teamManager.team': 'Administrador de equipos',
  'app.pages.app.teamManager.addTeam': 'Crear equipo',
  'app.pages.app.teamManager.editTeam': 'Editar equipo',
  'app.pages.app.teamManager.accessLevel': 'Niveles de acceso',
  'app.pages.app.teamManager.teamDeleted': 'Equipo {name} borrado',
  'app.pages.app.teamManager.deleteTeam': 'Borrar equipo',
  'app.pages.app.teamManager.areYouSureToDeleteTeam': '¿Estás seguro de borrar el equipo {name}?',
  'app.pages.app.teamManager.departmentsAsociated':
    'Está asociado con los siguientes departamentos:',
  'app.pages.app.teamManager.readOnly': 'Sólo lectura',
  'app.pages.app.teamManager.readAndWrite': 'Lectura y escritura',
  'app.pages.app.teamManager.updateTeam': 'Actualizar equipo',
  'app.pages.app.teamManager.createTeam': 'Crear equipo',
  'app.pages.app.teamManager.teamDepartments': 'No hay departamentos',
  'app.pages.app.teamManager.downloadReport': 'Descargar reporte de equipos',
  'app.pages.app.teamManager.reportDownloaded': 'Reporte de equipos descargado',
  'app.pages.app.teamManager.teamUpdated': 'Equipo actualizado',
  'app.pages.app.teamManager.teamCreated': 'Equipo creado',
  'app.pages.teamManager.name.maxLengthError':
    'El nombre del grupo no puede ser mayor a {number} caracteres',
  'app.pages.teamManager.teamsNotFound': 'No se encontraron equipos',
  //User Manager
  'app.pages.UserPage.userManager': 'Administrador de usuarios',
  'app.pages.UserPage.addUser': 'Agregar usuario',
  'app.pages.UserPage.editUser': 'Editar usuario',
  'app.pages.UserPage.email': 'Correo electrónico',
  'app.pages.UserPage.login': 'Nombre de usuario',
  'app.pages.UserPage.usersNotFound': 'Usuarios no encontrados',
  'app.pages.UserPage.changePassword': 'Cambiar contraseña',
  'app.pages.UserPage.manageCompanies': 'Administrar compañías',
  'app.pages.UserPage.passwordChanged': 'Contraseña cambiada',
  'app.pages.UserPage.downloadReport': 'Descargar Reporte de usuarios',
  'app.pages.UserPage.reportsDownloaded': 'Reporte de usuarios descargado',
  'app.pages.UserPage.firstName': 'Nombre',
  'app.pages.UserPage.firstNameIsRequired': 'El nombre es requerido',
  'app.pages.UserPage.firstNameMaxLength': 'El tamaño máximo del nombre es {number} caracteres',
  'app.pages.UserPage.firstNamePlaceholder': 'Ingresa tu nombre',
  'app.pages.UserPage.lastNamePlaceholder': 'Ingresa tu apellido',
  'app.pages.UserPage.lastNameIsRequired': 'El apellido es requerido',
  'app.pages.UserPage.lastNameMaxLength': 'El tamaño máximo del apellido es {number} caracteres',
  'app.pages.UserPage.emailPlaceholder': 'Ingresa tu correo electrónico',
  'app.pages.UserPage.emailIsInvalid': 'Correo electrónico incorrecto',
  'app.pages.UserPage.emailContainingÑ': 'El email no puede contener "Ñ"',
  'app.pages.UserPage.emailIsRequired': 'El correo electrónico es requerido',
  'app.pages.UserPage.emailAlreadyExist': 'El correo electrónico ya existe',
  'app.pages.UserPage.lastName': 'Apellido',
  'app.pages.UserPage.userNameIsRequired': 'El nombre de usuario es requerido',
  'app.pages.UserPage.userNamePlaceholder': 'Ingresa tu nombre de usuario',
  'app.pages.UserPage.passwordPlaceholder': 'Ingresa tu contraseña',
  'app.pages.UserPage.usernameAlreadyExist': 'El nombre de usuario ya existe',
  'app.pages.UserPage.usernameInvalid':
    'El nombre de usuario puede tener "@", "+", "-", "_" o "." caracteres. Los espacios en blanco no están permitidos.',
  'app.pages.UserPage.steps.userInformation': 'Información del usuario',
  'app.pages.UserPage.steps.roleAndCompanySelection': 'Selección de rol y compañía',
  'app.pages.UserPage.steps.roleAndCompanySelection.departmentPlaceholder':
    'Por favor elige un departamento',
  'app.pages.UserPage.steps.roleAndCompanySelection.rolePlaceholder': 'Por favor elige un rol',
  'app.pages.UserPage.steps.roleAndCompanySelection.addCompany': 'Agregar compañía',
  'app.pages.UserPage.steps.roleAndCompanySelection.removeCompany': 'Remover compañía',
  'app.pages.UserPage.steps.roleAndCompanySelection.noCompaniesAdded':
    'No hay compañías agregadas, por favor agrega una',
  'app.pages.UserPage.steps.roleAndCompanySelection.roleWarning':
    'Este rol se aplica a todas las compañías, excepto a aquellas que tienen un rol específico asignado',
  'app.pages.UserPage.steps.roleAndCompanySelection.noPermissionToRemove':
    'No tienes permiso para remover asignaciones de compañías. Solo los Super Administradores pueden modificar asignaciones usuario-compañía.',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainWarningTitle':
    'Advertencia de Validación de Dominio de Email',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainWarningMessage':
    'No existen usuarios con el dominio de email "@{domain}" en la compañía "{companyName}". Esto puede indicar una asignación incorrecta de compañía.',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainConfirmPlaceholder':
    'Ingresa el email del usuario para confirmar',
  'app.pages.UserPage.steps.roleAndCompanySelection.emailDomainConfirmLabel':
    'Confirma ingresando la dirección de email completa',
  'app.pages.UserPage.toggleActiveUser.errorNoRoles':
    '{user} no tiene un rol para la compañía {company}',
  'app.pages.UserPage.toggleActiveUser.activated': 'Usuario activado',
  'app.pages.UserPage.toggleActiveUser.desactivated': 'Usuario desactivado',
  'app.pages.UserPage.userUnlocked': 'Usuario desbloqueado',
  'app.pages.UserPage.userCreated': 'Usuario creado',
  'app.pages.UserPage.userUpdated': 'Usuario actualizado',
  'app.pages.UserPage.errorCompanyWithNoRoles': 'Hay una compañía sin roles',
  'app.pages.UserPage.errorCompanyWithNoDepartments': 'Hay una compañía sin departamentos',
  'app.pages.UserPage.deleteUser': 'Eliminar usuario',
  'app.pages.UserPage.areYouSureToDeleteUser': '¿Estás seguro de eliminar el usuario {name}?',
  'app.pages.UserPage.userDeleted': 'Usuario eliminado',
  'app.pages.UserPage.changeStatus': 'Cambiar estado',
  'app.pages.UserPage.unlockUser': 'Desbloquear usuario',
  'app.pages.UserPage.ChangePasswordLogin': 'Modificar contraseña al iniciar sesión',
  'app.pages.UserPage.enableMfa': 'Habilitar autenticación de múltiples factores',
  'app.pages.UserPage.setNewQrCode': 'Establecer nuevo código QR',
  'app.pages.UserPage.validateSetNewQRCode':
    'Se configurará un nuevo código QR para el usuario {user}. ¿Deseas continuar?',
  'app.pages.UserPage.qrCodeSuccesfullySeted': 'Nuevo código QR establecido',
  'app.pages.UserPage.lastLogin': 'Último acceso',
  'app.pages.UserPage.creationDate': 'Fecha de creación',
  'app.pages.UserPage.clearFilters': 'Limpiar filtros',
  'app.pages.UserPage.activeUsersOnly': 'Solo usuarios activos',
  'app.pages.UserPage.addMultipleUsers': 'Agregar múltiples usuarios',
  'app.pages.UserPage.dragDropCsvMultipleUsers':
    'Arrastra y suelta un archivo CSV con información de usuarios',
  'app.pages.UserPage.roleAndDepartmentAppliedToAll':
    'El rol y departamento seleccionados se aplicarán a todos los usuarios',
  'app.pages.UserPage.bulkCreationSummary': 'Resumen de creación masiva',
  'app.pages.UserPage.bulkUsersTotal': 'Total de usuarios',
  'app.pages.UserPage.bulkUsersCreated': 'Creados',
  'app.pages.UserPage.bulkUsersAssignedExisting': 'Usuarios existentes asignados a la compañía',
  'app.pages.UserPage.bulkUsersAlreadyInCompany': 'Usuarios que ya pertenecían a la compañía',
  'app.pages.UserPage.bulkUsersErrorsTitle': 'Errores',
  'app.pages.UserPage.bulkUsersStatusUnavailable':
    'No se pudo obtener el avance de la creación masiva. Revisa la lista de usuarios para ver el resultado.',
  'app.pages.UserPage.downloadSampleCsv': 'Descargar CSV de ejemplo',

  //Code Diagram Nodes
  'app.pages.Code.Diagram.Nodes.variable': 'Variable',
  'app.pages.Code.Diagram.Nodes.datareading': 'Lectura de datos',
  'app.pages.Code.Diagram.Nodes.button': 'Botón',
  'app.pages.Code.Diagram.Nodes.index': 'Índice',
  'app.pages.Code.Diagram.Nodes.module': 'Módulo',
  'app.pages.Code.Diagram.Nodes.inputscalar': 'Escalar',
  'app.pages.Code.Diagram.Nodes.inputselector': 'Selector',
  'app.pages.Code.Diagram.Nodes.inputdateselector': 'Selector de fechas',
  'app.pages.Code.Diagram.Nodes.inputchoice': 'Opción',
  'app.pages.Code.Diagram.Nodes.inputdataframe': 'Tabla de datos',
  'app.pages.Code.Diagram.Nodes.inputdataarray': 'Matriz de datos',
  'app.pages.Code.Diagram.Nodes.inputcube': 'Cubo',
  'app.pages.Code.Diagram.Nodes.text': 'Texto',
  'app.pages.Code.Diagram.Nodes.generic': 'Genérico',
  'app.pages.Code.Diagram.Nodes.form': 'Formulario',
  'app.pages.Code.Diagram.Nodes.inputInitialName': 'Nombre del nodo',
  'app.pages.Code.Diagram.Nodes.inputData': 'Entrada de datos',
  'app.pages.Code.Diagram.Nodes.chooseInputType': 'Elige el tipo de entrada de datos',
  'app.pages.Code.Diagram.Nodes.report': 'Reporte',
  'app.pages.Code.Diagram.Nodes.outputnode': 'Salida',
  'app.pages.Code.Diagram.Nodes.reportwizard': 'Wizard de reporte',
  'app.pages.Code.Diagram.Nodes.beingUsedInInterfaces': 'El nodo está siendo usado en interfaces',
  'app.pages.Code.Diagram.Nodes.nodeHasNoInterfaces': 'El nodo no tiene interfaces',
  'app.pages.Code.Diagram.Nodes.beingUsedInModulesAndInterfaces':
    'Tiene salidas fuera de su módulo y está siendo utilizado en interfaces',
  'app.pages.Code.Diagram.Nodes.someNodesAreBeingUsedInInterfaces':
    'Algunos nodos están siendo utilizados en interfaces',
  'app.pages.Code.Diagram.Nodes.nextStep': 'Siguiente paso',
  'app.pages.Code.Diagram.Nodes.outsideModule': 'Este nodo está ubicado fuera del módulo actual',

  //Code Diagram Menu
  'app.pages.Code.Diagram.Menu.hideMenu': 'Ocultar menú',
  'app.pages.Code.Diagram.Menu.wizards': 'Asistentes',
  'app.pages.Code.Diagram.Menu.importModule': 'Importar módulo',
  'app.pages.Code.Diagram.Menu.importModule.steps.selectModule': 'Selección del módulo',
  'app.pages.Code.Diagram.Menu.importModule.steps.importType': 'Tipo de importación',
  'app.pages.Code.Diagram.Menu.importModule.steps.importType.switch': 'Cambiar',
  'app.pages.Code.Diagram.Menu.importModule.steps.importType.merge': 'Fusionar',
  'app.pages.Code.Diagram.Menu.importModule.sucessful': 'Módulo importado exitosamente',
  'app.pages.Code.Diagram.Menu.importModule.hasOutputsOutsideItsModule':
    'Tiene salidas fuera de su módulo',
  //Code Diagram Delete dialog
  'app.pages.Code.Diagram.DeleteDialog.deleteNodes': '¿Eliminar nodos?',
  'app.pages.Code.Diagram.DeleteDialog.confirmationtext':
    '¿Estás seguro de eliminar {number} nodos seleccionados?',
  //Node Properties Dialog
  'app.pages.Code.Diagram.Nodes.properties.title': 'Título del nodo',
  'app.pages.Code.Diagram.Nodes.properties.id': 'Identificador del nodo',
  'app.pages.Code.Diagram.Nodes.properties.nodeClass': 'Tipo de nodo',
  'app.pages.Code.Diagram.Nodes.properties.units': 'Unidades',
  'app.pages.Code.Diagram.Nodes.properties.evaluateOnStart': 'Evaluar al inicio',
  'app.pages.Code.Diagram.Nodes.properties.releaseMemory': 'Liberar memoria',
  'app.pages.Code.Diagram.Nodes.properties.prefixIdentifier': 'Prefijo del módulo',
  'app.pages.Code.Diagram.Nodes.properties.setIdFromTitle': 'Usar título como identificador',
  'app.pages.Code.Diagram.Nodes.properties.normalizeIdentifier':
    'Normalizar identificador (minúsculas, eliminar caracteres inválidos, resolver conflictos)',
  'app.pages.Code.Diagram.Nodes.properties.idHelperText':
    'El identificador debe comenzar con una letra, y sólo puede contener letras minúsculas, números y guiones bajos',
  'app.pages.Code.Diagram.Nodes.properties.idRequired':
    'El identificador del nodo no puede estar vacío',
  'app.pages.Code.Diagram.Nodes.properties.prefixIdHelperText':
    'El prefijo del módulo debe comenzar con una letra, y sólo puede contener letras minúsculas, números y guiones bajos',
  'app.pages.Code.Diagram.Nodes.properties.hierarchyMap': 'Mapa de jerarquía',
  'app.pages.Code.Diagram.Nodes.inputs': 'Entradas',
  'app.pages.Code.Diagram.Nodes.outputs': 'Salidas',
  'app.pages.Code.Diagram.Nodes.general': 'General',
  'app.pages.Code.Diagram.Nodes.metadata': 'Metadatos',
  'app.pages.Code.Diagram.Nodes.translations': 'Traducciones',
  'app.pages.Code.Diagram.Nodes.addNewTranslation': 'Agregar nueva traducción',
  'app.pages.Code.Diagram.Nodes.noLanguageConfiguredMessage':
    'La aplicación debe tener configurado un idioma por defecto para agregar traducciones',
  'app.pages.Code.Diagram.Nodes.creationDate': 'Fecha de creación',
  'app.pages.Code.Diagram.Nodes.lastModification': 'Última modificación',
  'app.pages.Code.Diagram.Nodes.lastModificationUser': 'Usuario',
  'app.pages.Code.Diagram.Nodes.lastUserThatModified': 'Último usuario que modificó',
  'app.pages.Code.Diagram.Nodes.docs': 'Documentación',
  'app.pages.Code.Diagram.Nodes.noInputs': 'No hay entradas',
  'app.pages.Code.Diagram.Nodes.noOutputs': 'No hay salidas',
  'app.pages.Code.Diagram.Nodes.noDocs': 'No hay documentación para esta sección.',
  'app.pages.Code.Diagram.Nodes.editDocs': 'Editar docs',
  'app.pages.Code.Diagram.Nodes.docsEdited': 'Documentación editada',
  'app.pages.Code.Diagram.Nodes.selectNodeToShowDocs':
    'Selecciona un nodo para mostrar la documentación',
  'app.pages.Code.itemHeader.saveDefaultView': 'Guardar vista por defecto',
  //Context Menu
  'app.pages.Code.Diagram.ContextMenu.resize': 'Redimensionar nodos como {string}',
  'app.pages.Code.Diagram.ContextMenu.alignment': 'Alinear nodos a {string}',
  'app.pages.Code.Diagram.ContextMenu.showInputs': 'Mostrar entradas',
  'app.pages.Code.Diagram.ContextMenu.showOutputs': 'Mostrar salidas',
  'app.pages.Code.Diagram.ContextMenu.moveNodeToBackground': 'Mover nodo al fondo',
  'app.pages.Code.Diagram.ContextMenu.nodeMovedToBackground': 'Nodo movido al fondo',
  'app.pages.Code.Diagram.ContextMenu.moveNodeToFront': 'Mover nodo al frente',
  'app.pages.Code.Diagram.ContextMenu.nodeMovedToFront': 'Nodo movido al frente',
  'app.pages.Code.Diagram.ContextMenu.sizes.width': 'Mismo ancho',
  'app.pages.Code.Diagram.ContextMenu.sizes.height': 'Misma altura',
  'app.pages.Code.Diagram.ContextMenu.sizes.size': 'Mismo tamaño',
  'app.pages.Code.Diagram.ContextMenu.alignment.top': 'Bordes superiores',
  'app.pages.Code.Diagram.ContextMenu.alignment.centerH': 'Centrar horizontalmente',
  'app.pages.Code.Diagram.ContextMenu.alignment.centerV': 'Centrar verticalmente',
  'app.pages.Code.Diagram.ContextMenu.alignment.bottom': 'Bordes inferiores',
  'app.pages.Code.Diagram.ContextMenu.alignment.right': 'Bordes derechos',
  'app.pages.Code.Diagram.ContextMenu.alignment.left': 'Bordes izquierdos',
  'app.pages.Code.Diagram.ContextMenu.exportModule': 'Exportar módulo',
  'app.pages.Code.Diagram.ContextMenu.moduleExported': 'Módulo exportado',
  'app.pages.Code.Diagram.ContextMenu.setRestriction': 'Establecer restricción',
  'app.pages.Code.Diagram.ContextMenu.pinNode': 'Fijar nodo',
  'app.pages.Code.Diagram.ContextMenu.unpinNode': 'Quitar nodo',
  'app.pages.Code.pinnedNodes.allGroups': 'Todos',
  'app.pages.Code.pinnedNodes.createGroup': 'Nuevo grupo',
  'app.pages.Code.pinnedNodes.createGroupTooltip': 'Crear un nuevo grupo de nodos fijados',
  'app.pages.Code.pinnedNodes.newGroup': 'Nuevo grupo',
  'app.pages.Code.pinnedNodes.groupColorTooltip': 'Elige el color del grupo',
  'app.pages.Code.pinnedNodes.groupName': 'Nombre del grupo',
  'app.pages.Code.pinnedNodes.groupNameInUse': 'Ya existe un grupo con ese nombre',
  'app.pages.Code.pinnedNodes.renameGroup': 'Renombrar grupo',
  'app.pages.Code.pinnedNodes.deleteGroup': 'Eliminar grupo',
  'app.pages.Code.pinnedNodes.deleteGroupConfirmation':
    'Se eliminará el grupo "{name}". Sus nodos siguen fijados, sin grupo.',
  'app.pages.Code.pinnedNodes.emptyGroup':
    'Fija nodos con este grupo seleccionado para agregarlos aquí',
  'app.pages.Code.Diagram.ContextMenu.apiEndpoint': 'Obtener API URL',
  'app.pages.Code.Diagram.apiEndpoint.endpointFor': 'API URL para: ',
  'app.pages.Code.Diagram.apiEndpoint.shareInstance': 'Compartir instancia',
  'app.pages.Code.Diagram.apiEndpoint.apiURLcopied': 'API URL copiada ',
  'app.pages.Code.Diagram.apiEndpoint.message':
    'y envía los parámetros de la función como un objeto JSON en el cuerpo de la petición.',
  'app.pages.Code.Diagram.ContextMenu.openWizard': 'Abrir asistente',
  'app.pages.Code.Diagram.ContextMenu.compareNodes': 'Comparar nodos',
  'app.pages.Code.Diagram.ContextMenu.handlingDataWidget': 'Manipulación de datos',
  'app.pages.Code.Diagram.Wizards.dropDuplicates': 'Eliminar duplicados',
  'app.pages.Code.Diagram.ContextMenu.dataSystemNodeNoData': 'Nodo de sistema sin datos',

  //Code Diagram Wizards
  'app.pages.Code.Diagram.Wizards.openWizard': 'Abrir asistente',
  'app.pages.Code.Diagram.Wizards.selectColumns': 'Seleccionar columnas',
  'app.pages.Code.Diagram.Wizards.editInExcel': 'Editar en Excel',
  'app.pages.Code.Diagram.Wizards.selectRows': 'Seleccionar filas',
  'app.pages.Code.Diagram.Wizards.name': 'Nombre de columna',
  'app.pages.Code.Diagram.Wizards.isIndex': 'Es índice',
  'app.pages.Code.Diagram.Wizards.dtype': 'Tipo de dato',
  'app.pages.Code.Diagram.Wizards.editTableDefinition': 'Editar definición de Tabla',
  'app.pages.Code.Diagram.Wizards.removeColumn': 'Borrar columna',
  'app.pages.Code.Diagram.Wizards.addNewColumn': 'Agregar nueva columna',
  'app.pages.Code.Diagram.Wizards.column': 'Columna',
  'app.pages.Code.Diagram.Wizards.editCubeDefinition': 'Editar definición del Cubo',
  'app.pages.Code.Diagram.Wizards.deleteCubeData': 'Eliminar datos del Cubo',
  'app.pages.Code.Diagram.Wizards.deleteCubeDataMessage':
    '¿Estás seguro de que deseas eliminar los datos del Cubo de la base de datos?',
  'app.pages.Code.Diagram.Wizards.deleteCubeDataConfirm':
    'Los datos del Cubo se eliminaron correctamente de la base de datos',
  'app.pages.Code.Diagram.Wizards.availableIndexes': 'Índices disponibles',
  'app.pages.Code.Diagram.Wizards.selectedIndexes': 'Índices seleccionados',
  'app.pages.Code.Diagram.Wizards.filter': 'Filtrar',
  'app.pages.Code.Diagram.Wizards.defaultValue': 'Valor por defecto',
  'app.pages.Code.Diagram.Wizards.defaultValueType': 'Tipo de valor por defecto',
  'app.pages.Code.Diagram.Wizards.scalar': 'Escalar',
  'app.pages.Code.Diagram.Wizards.model_node': 'Nodo del modelo',
  'app.pages.Code.Diagram.Wizards.app_node': 'Nodo de la app',
  'app.pages.Code.Diagram.Wizards.node_id': 'El identificador del nodo ya existe, selecciona otro',
  'app.pages.Code.Diagram.Wizards.calculatedField': 'Campo calculado',
  'app.pages.Code.Diagram.Wizards.setIndex': 'Establecer índice',
  'app.pages.Code.Diagram.Wizards.groupAgregate': 'Agrupar/agregar',
  'app.pages.Code.Diagram.Wizards.createindex': 'Crear Índice',
  'app.pages.Code.Diagram.Wizards.createcube': 'Crear Cubo',
  'app.pages.Code.Diagram.Wizards.form': 'Formulario',
  'app.pages.Code.Diagram.Wizards.report': 'Reporte',
  'app.pages.Code.Diagram.Wizards.editFormDefinition': 'Editar definición del Formulario',
  'app.pages.Code.Diagram.Wizards.deleteFormData': 'Eliminar datos del Formulario',
  'app.pages.Code.Diagram.Wizards.deleteFormDataMessage':
    '¿Estás seguro de que deseas eliminar los datos del Formulario de la base de datos?',
  'app.pages.Code.Diagram.Wizards.deleteFormDataConfirm':
    'Los datos del Formulario se eliminaron correctamente de la base de datos',
  'app.pages.Code.Diagram.Wizards.formFieldError': 'Id o título de campo no puede ser "id"',
  'app.pages.Code.Diagram.Wizards.formFieldNoWhiteSpacesError':
    'El campo ID no puede contener espacios en blanco.',
  'app.pages.Code.Diagram.Wizards.fieldId': 'ID de campo',
  'app.pages.Code.Diagram.Wizards.fieldTitle': 'Título de campo',
  'app.pages.Code.Diagram.Wizards.columnType': 'Tipo de columna',
  'app.pages.Code.Diagram.Wizards.hidden': 'Oculto',
  'app.pages.Code.Diagram.Wizards.readOnly': 'Sólo lectura',
  'app.pages.Code.Diagram.Wizards.formula': 'Fórmula',
  'app.pages.Code.Diagram.Wizards.values': 'Valores',
  'app.pages.Code.Diagram.Wizards.filterRowsByDomain': 'Filtrar filas por dominio',
  'app.pages.Code.Diagram.Wizards.strict': 'Estricto',
  'app.pages.Code.Diagram.Wizards.relatedMap': 'Mapa relacionado',
  'app.pages.Code.Diagram.Wizards.relatedMapColumnValues': 'Columna con valores',
  'app.pages.Code.Diagram.Wizards.relatedColumns': 'Columnas relacionadas',
  'app.pages.Code.Diagram.Wizards.fromNode': 'Desde nodo',
  'app.pages.Code.Diagram.Wizards.fromNodeDetails':
    'El resultado del nodo debe ser una función que recibe un DataFrame de Pandas como parámetro y devuelve un DataFrame de Pandas',
  'app.pages.Code.Diagram.Wizards.advancedOptions': 'Opciones avanzadas',
  'app.pages.Code.Diagram.Wizards.appNode': 'Nodo de la app',
  'app.pages.Code.Diagram.Wizards.typeNewValues':
    'Escribir nuevos valores. Presionar Enter para confirmar',
  'app.pages.Code.Diagram.Wizards.columnType.input': 'Input',
  'app.pages.Code.Diagram.Wizards.columnType.checkbox': 'Checkbox',
  'app.pages.Code.Diagram.Wizards.columnType.selector': 'Selector',
  'app.pages.Code.Diagram.Wizards.columnType.related_selector': 'Selector relacionado',
  'app.pages.Code.Diagram.Wizards.columnType.calc': 'Cálculo',
  'app.pages.Code.Diagram.Wizards.columnType.dataframe_column': 'Columna de DataFrame',
  'app.pages.Code.Diagram.Wizards.columnType.system': 'Sistema',
  'app.pages.Code.Diagram.Wizards.tableName': 'Nombre de la tabla',
  'app.pages.Code.Diagram.Wizards.formSettings': 'Opciones de formulario',
  'app.pages.Code.Diagram.Wizards.editFormSettings': 'Editar opciones de formulario',
  'app.pages.Code.Diagram.Wizards.addNewField': 'Agregar nuevo campo',
  'app.pages.Code.Diagram.Wizards.addNewItem': 'Agregar nuevo elemento',
  'app.pages.Code.Diagram.Wizards.databaseEngine': 'Motor de base de datos',
  'app.pages.Code.Diagram.Wizards.databaseConnection': 'Conexión a base de datos',
  'app.pages.Code.Diagram.Wizards.databasePath': 'Ruta a base de datos',
  'app.pages.Code.Diagram.Wizards.host': 'Host',
  'app.pages.Code.Diagram.Wizards.database': 'Base de datos',
  'app.pages.Code.Diagram.Wizards.databaseCustomURL': 'URL personalizada',
  'app.pages.Code.Diagram.Wizards.initialEmptyRows': 'Filas vacías iniciales',
  'app.pages.Code.Diagram.Wizards.allowAddRows': 'Permitir agregar filas',
  'app.pages.Code.Diagram.Wizards.allowRemoveRows': 'Permitir eliminar filas',
  'app.pages.Code.Diagram.Wizards.allowAddNewColumns': 'Permitir agregar nuevas columnas',
  'app.pages.Code.Diagram.Wizards.allowRowReordering': 'Permitir reordenar filas',
  'app.pages.Code.Diagram.Wizards.validateSelectorsOnInitialRender':
    'Validar valores de selectores al cargar el formulario',
  'app.pages.Code.Diagram.Wizards.trackHistory': 'Registrar historial de datos',
  'app.pages.Code.Diagram.Wizards.fixedColumns': 'Columnas fijas',
  'app.pages.Code.Diagram.Wizards.formRecreateTableMessage':
    'Todos los datos del formulario se borrarán y se volverá a crear desde cero.',
  'app.pages.Code.Diagram.Wizards.formSubmitConfirmation':
    'Se sobreescribirá la definición del formulario.',
  'app.pages.Code.Diagram.Wizards.fromDataFrame': 'Desde DataFrame',
  'app.pages.Code.Diagram.Wizards.sourceDataFrameNode': 'Nodo con DataFrame de origen',
  'app.pages.Code.Diagram.Wizards.sourceDataFrameIdColumn': 'Columna ID de DataFrame de origen',
  'app.pages.Code.Diagram.Wizards.removeOldRows': 'Borrar filas antiguas',
  'app.pages.Code.Diagram.Wizards.newFieldName': 'Nombre del nuevo campo',
  'app.pages.Code.Diagram.Wizards.newItemName': 'Nombre del nuevo elemento',
  'app.pages.Code.Diagram.Wizards.expression': 'Expresión',
  'app.pages.Code.Diagram.Wizards.fieldList': 'Campos disponibles',
  'app.pages.Code.Diagram.Wizards.agregate': 'Funciones de agregación',
  'app.pages.Code.Diagram.Wizards.groupBy': 'Agrupar por',
  'app.pages.Code.Diagram.Wizards.filterDataFrame': 'Filtrar DataFrame',
  'app.pages.Code.Diagram.Wizards.condition': 'Condición',
  'app.pages.Code.Diagram.Wizards.addNewFilter': 'Agregar nuevo filtro',
  'app.pages.Code.Diagram.Wizards.valueIsRequired': 'El valor es requerido',
  'app.pages.Code.Diagram.Wizards.mustHaveAtLeastValues': 'Debe tener al menos {number} valor/es',
  'app.pages.Code.Diagram.Wizards.filterDataArray': 'Filtrar DataArray',
  'app.pages.Code.Diagram.Wizards.dimension': 'Dimensión',
  'app.pages.Code.Diagram.Wizards.editIndex': 'Editar índice',
  'app.pages.Code.Diagram.Wizards.itemList': 'Listado de items',
  'app.pages.Code.Diagram.Wizards.count': 'Cantidad',
  'app.pages.Code.Diagram.Wizards.insertAbove': 'Insertar fila arriba',
  'app.pages.Code.Diagram.Wizards.insertBelow': 'Insertar fila abajo',
  'app.pages.Code.Diagram.Wizards.removeRow': 'Eliminar fila',
  'app.pages.Code.Diagram.Wizards.index': 'Índice',
  'app.pages.Code.Diagram.Wizards.renameIndex': 'Renombrar índice',
  'app.pages.Code.Diagram.Wizards.files': 'Archivos',
  'app.pages.Code.Diagram.Wizards.databases': 'Bases de datos',
  'app.pages.Code.Diagram.Wizards.online': 'En línea',
  'app.pages.Code.Diagram.Wizards.dataReadingNode': 'Nodo de lectura de datos',
  'app.pages.Code.Diagram.Wizards.readCsvFile': 'Leer archivo CSV',
  'app.pages.Code.Diagram.Wizards.readExcelFile': 'Leer archivo Excel',
  'app.pages.Code.Diagram.Wizards.dataPreview': 'Vista previa de datos',
  'app.pages.Code.Diagram.Wizards.schema': 'Esquema',
  'app.pages.Code.Diagram.Wizards.csvDataSource': 'Fuente de datos CSV',
  'app.pages.Code.Diagram.Wizards.excelDataSource': 'Fuente de datos Excel',
  'app.pages.Code.Diagram.Wizards.backStep': 'Regresar',
  'app.pages.Code.Diagram.Wizards.finishingDataRead':
    'Finalizando la creación del nodo, por favor espera...',
  'app.pages.Code.Diagram.Wizards.nextStep': 'Siguiente',
  'app.pages.Code.Diagram.Wizards.chooseDataSource': 'Selecciona una fuente de datos',
  'app.pages.Code.Diagram.Wizards.selectFile': 'Selecciona archivo desde el servidor',
  'app.pages.Code.Diagram.Wizards.selectFolder': 'Seleccionar carpeta',
  'app.pages.Code.Diagram.Wizards.selectFileFromUrl': 'Selecciona archivo desde URL',
  'app.pages.Code.Diagram.Wizards.encoding': 'Codificación',
  'app.pages.Code.Diagram.Wizards.separator': 'Separador',
  'app.pages.Code.Diagram.Wizards.dataSetSample': 'Muestra del conjunto de datos',
  'app.pages.Code.Diagram.Wizards.sheetName': 'Nombre de la hoja',
  'app.pages.Code.Diagram.Wizards.definedRanges': 'Rangos definidos',
  'app.pages.Code.Diagram.Wizards.customRange': 'Rango personalizado',
  'app.pages.Code.Diagram.Wizards.setNewHeaderFirstRow': 'Establecer encabezado con primera fila',
  'app.pages.Code.Diagram.Wizards.exampleCustomRange': 'Ejemplo: A1:B10',
  'app.pages.Code.Diagram.Wizards.sortDataFrame': 'Ordenar DataFrame',
  'app.pages.Code.Diagram.Wizards.criteria': 'Criterio',
  'app.pages.Code.Diagram.Wizards.addNewOrderCondition': 'Agregar nueva condición de orden',
  'app.pages.Code.Diagram.Wizards.indexOptions': 'Opciones de índice',
  'app.pages.Code.Diagram.Wizards.transform': 'Transformar',
  'app.pages.Code.Diagram.Wizards.toDataFrame': 'A DataFrame',
  'app.pages.Code.Diagram.Wizards.changeIndex': 'Cambiar índice',
  'app.pages.Code.Diagram.Wizards.oldIndex': 'Índice anterior',
  'app.pages.Code.Diagram.Wizards.newIndex': 'Nuevo índice',
  'app.pages.Code.Diagram.Wizards.compareMode': 'Modo de comparación',
  'app.pages.Code.Diagram.Wizards.searchIndex': 'Buscar índice',
  'app.pages.Code.Diagram.Wizards.byPosition': 'Por posición',
  'app.pages.Code.Diagram.Wizards.byValue': 'Por valor',
  'app.pages.Code.Diagram.Wizards.list': 'Lista',
  'app.pages.Code.Diagram.Wizards.rangeType': 'Tipo de rango',
  'app.pages.Code.Diagram.Wizards.frequency': 'Frecuencia',
  'app.pages.Code.Diagram.Wizards.cumulative': 'Acumulativo',
  'app.pages.Code.Diagram.Wizards.periods': 'Periodos',
  'app.pages.Code.Diagram.Wizards.stringPrefix': 'Prefijo de cadena',
  'app.pages.Code.Diagram.Wizards.to': 'A',
  'app.pages.Code.Diagram.Wizards.steps': 'Pasos',
  'app.pages.Code.Diagram.Wizards.enterNumericalValue': 'Ingresa un valor numérico',
  'app.pages.Code.Diagram.Wizards.invalidDate':
    'Fecha inválida, por favor introduce una fecha con formato: AAAA-MM-DD',
  'app.pages.Code.Diagram.Wizards.startDateIsRequired': 'Fecha de inicio es requerida',
  'app.pages.Code.Diagram.Wizards.endDateIsRequired': 'Fecha de fin es requerida',
  'app.pages.Code.Diagram.Wizards.yearly': 'Anual',
  'app.pages.Code.Diagram.Wizards.monthly': 'Mensual',
  'app.pages.Code.Diagram.Wizards.weekly': 'Semanal',
  'app.pages.Code.Diagram.Wizards.daily': 'Diario',
  'app.pages.Code.Diagram.Wizards.saveLabels': 'Guardar etiquetas',
  'app.pages.Code.Diagram.Wizards.nestedHeaders': 'Encabezados anidados',
  'app.pages.Code.Diagram.Wizards.nestedHeadersTypeNewValues':
    'Escribir nuevos encabezados anidados. Presionar Enter para confirmar',
  'app.pages.Code.Diagram.Wizards.deleteAndRecreateTable': 'Borrar y recrear tabla',
  'app.pages.Code.Diagram.Wizards.itemName': 'Nombre de elemento',
  'app.pages.Code.Diagram.Wizards.editReportDefinition': 'Editar definición de Reporte',
  'app.pages.Code.Diagram.Wizards.itemsFromIndex': 'Elementos desde índice',
  'app.pages.Code.Diagram.Wizards.indexNode': 'Nodo índice',
  'app.pages.Code.Diagram.Wizards.addItemsFromIndex': 'Agregar elementos desde índice',
  'app.pages.Code.Diagram.Wizards.asNegative': 'En negativo',
  'app.pages.Code.Diagram.Wizards.itemIsNotInItemsList':
    'El elemento "{item}" no existe en la lista de elementos del nodo "{nodeId}"',
  'app.pages.Code.Diagram.Wizards.reportSubmitConfirmation':
    'Se sobreescribirá la definición del reporte.',
  'app.pages.Code.Diagram.Wizards.outputType': 'Tipo de salida',
  'app.pages.Code.Diagram.Wizards.removeNonExistingCombinations':
    'Eliminar combinaciones inexistentes',
  'app.pages.Code.Diagram.Wizards.allowDimensionChanges': 'Permitir cambio de dimensiones',
  'app.pages.Code.Diagram.Wizards.confirmWizardChanges': 'Confirmar cambios del asistente',
  'app.pages.Code.Diagram.Wizards.overWriteDefinition': 'Sobreescribir definición',
  'app.pages.Code.Diagram.Wizards.createNewNodeWithCurrentChanges':
    'Crear nuevo nodo con los cambios actuales',
  'app.pages.Code.Diagram.Wizards.renameColumn': 'Renombrar columna',
  'app.pages.Code.Diagram.Wizards.deleteColumn': 'Eliminar columna',
  'app.pages.Code.Diagram.Wizards.duplicateColumn': 'Duplicar columna',
  'app.pages.Code.Diagram.Wizards.changeDataType': 'Cambiar tipo de dato',
  'app.pages.Code.Diagram.Wizards.sortColumn': 'Ordenar columna',
  'app.pages.Code.Diagram.Wizards.removeDuplicates': 'Eliminar duplicados',
  'app.pages.Code.Diagram.Wizards.newColumnName': 'Nuevo nombre de columna',
  'app.pages.Code.Diagram.Wizards.deleteColumnMessage':
    'La columna {column} será eliminada del dataframe. ¿Deseas continuar?',
  'app.pages.Code.Diagram.Wizards.newDuplicateColumnName': 'Nuevo nombre de columna duplicada',
  'app.pages.Code.Diagram.Wizards.changeColumnType': 'Cambiar tipo de columna',
  'app.pages.Code.Diagram.Wizards.columnSanitization': 'Limpieza de columna',
  'app.pages.Code.Diagram.Wizards.addNewSanitizeAction': 'Agregar nueva acción de limpieza',
  'app.pages.Code.Diagram.Wizards.sanitizationColumnOptions': 'Opciones para limpiar la columna',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveDuplicatesWords':
    'Eliminar palabras duplicadas de la columna',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.ReplaceMultiSpace':
    'Reemplazar múltiples espacios por un solo espacio',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemovePunctuation':
    'Eliminar la puntuación del texto',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveNumbers': 'Eliminar números del texto',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.KeepOnlyAlphaNumeric':
    'Conservar solo caracteres alfanuméricos',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.NormalizeAccents':
    'Normalizar acentos del texto',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveSpaces': 'Eliminar espacios del texto',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.AddSpaceBetweenWords':
    'Añadir espacio entre palabras',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveRepeatedChars':
    'Eliminar caracteres repetidos',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.UpperWordCase': 'Palabras en mayúscula',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.LowerWordCase': 'Palabras en minúscula',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.TitleWordCase': 'Palabras en título',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.RemoveHiddenChars':
    'Eliminar caracteres ocultos',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.ReplaceHypensWithSpace':
    'Reemplazar guiones por espacios',
  'app.pages.Code.Diagram.Wizards.cleanColumnOptions.ReplaceText': 'Reemplazar texto',
  'app.pages.Code.Diagram.Wizards.textToReplace': 'Texto a reemplazar',
  'app.pages.Code.Diagram.Wizards.replaceWith': 'Reemplazar con',
  'app.pages.Code.Diagram.Wizards.stopWords': 'Palabras vacías',
  'app.pages.Code.Wizards.Upper': 'Mayúsculas',
  'app.pages.Code.Wizards.Lower': 'Minúsculas',
  'app.pages.Code.Wizards.Title': 'Título',
  'app.pages.Code.Wizards.Capitalize': 'Capitalizar',
  'app.pages.Code.Wizards.Swapcase': 'Intercambiar mayúsculas y minúsculas',
  'app.pages.Code.Diagram.Wizards.applyChangesInNewColumn': 'Aplicar cambios en nueva columna',
  'app.pages.Code.Diagram.Wizards.fillEmptyValues': 'Completar valores vacíos',
  'app.pages.Code.Diagram.Wizards.fillValue': 'Valor de relleno',
  'app.pages.Code.Diagram.Wizards.fillMethod': 'Método de relleno',
  'app.pages.Code.Diagram.Wizards.searchConditionValue': 'Buscar valor de condición',
  'app.pages.Code.Diagram.Wizards.selectorType': 'Tipo de selector',
  'app.pages.Code.Diagram.Wizards.selectorType.standard': 'Estándar',
  'app.pages.Code.Diagram.Wizards.selectorType.date': 'Fecha',

  //Interfaces
  'app.pages.Interfaces.Table.add1RowAbove': 'Insertar 1 fila arriba',
  'app.pages.Interfaces.Table.add5RowsAbove': 'Insertar 5 filas arriba',
  'app.pages.Interfaces.Table.add1RowBelow': 'Insertar 1 fila debajo',
  'app.pages.Interfaces.Table.add5RowsBelow': 'Insertar 5 filas debajo',
  'app.pages.Interfaces.Table.addRow': 'Insertar fila',
  'app.pages.Interfaces.Table.removeRow': 'Eliminar fila/s',
  'app.pages.Interfaces.Table.copy': 'Copiar',
  'app.pages.Interfaces.Table.copyTable': 'Copiar tabla',
  'app.pages.Interfaces.Table.copyWithHeaders': 'Copiar con encabezados',
  'app.pages.Interfaces.Table.copyOnlyHeaders': 'Copiar sólo encabezados',
  'app.pages.Interfaces.Table.copyAllGroupHeaders': 'Copiar con todos los grupos de encabezados',
  'app.pages.Interfaces.Form.addRowsAbove': 'Agregar filas arriba',
  'app.pages.Interfaces.Form.addRowsBelow': 'Agregar filas abajo',
  'app.pages.Interfaces.Form.multiselectSelected': 'Seleccionados',
  'app.pages.Interfaces.Form.multiselectNotSelected': 'No seleccionados',
  'app.pages.Interfaces.Form.multiselectLoadingMore': 'Cargando más...',
  'app.pages.Interfaces.Form.multiselectSearch': 'Buscar...',
  'app.pages.Interfaces.Form.refreshData': 'Actualizar datos',
  'app.pages.Interfaces.Form.refreshDataAlert':
    'Actualizar los datos los volverá a leer desde la base de datos. Se perderán los cambios que aún no hayan sido confirmados.',
  'app.pages.Interfaces.Form.confirmChangesAndRefresh': 'Confirmar cambios y actualizar',
  'app.pages.Interfaces.Form.discardChangesAndRefresh': 'Descartar cambios y actualizar',
  'app.pages.Interfaces.History.title': 'Historial de datos',
  'app.pages.Interfaces.History.source': 'Origen',
  'app.pages.Interfaces.History.oldValue': 'Valor anterior',
  'app.pages.Interfaces.History.newValue': 'Valor nuevo',
  'app.pages.Interfaces.History.viewRowHistory': 'Ver historial de la fila',
  'app.pages.Interfaces.History.changedCells': '{count, plural, one {# celda} other {# celdas}}',
  'app.pages.Interfaces.History.inRows': 'en {count, plural, one {# fila} other {# filas}}',
  'app.pages.Interfaces.History.insertedRows':
    '{count, plural, one {# fila agregada} other {# filas agregadas}}',
  'app.pages.Interfaces.History.deletedRows':
    '{count, plural, one {# fila eliminada} other {# filas eliminadas}}',
  'app.pages.Interfaces.History.editSession':
    '{count, plural, one {# edición} other {# ediciones}}',
  'app.pages.Interfaces.History.batches': 'Lotes',
  'app.pages.Interfaces.History.users': 'Usuarios',
  'app.pages.Interfaces.History.lastChange': 'Último cambio',
  'app.pages.Interfaces.History.empty': 'No hay cambios registrados',
  'app.pages.Interfaces.History.operation.update': 'Valor modificado',
  'app.pages.Interfaces.History.operation': 'Operación',
  'app.pages.Interfaces.History.fullName': 'Nombre completo',
  'app.pages.Interfaces.History.batch': 'Lote',
  'app.pages.Interfaces.History.download': 'Descargar historial',
  'app.pages.Interfaces.History.operation.insert': 'Fila agregada',
  'app.pages.Interfaces.History.operation.delete': 'Fila eliminada',
  'app.pages.Interfaces.History.source.interface': 'Interfaz',
  'app.pages.Interfaces.History.source.diagram': 'Diagrama',
  'app.pages.Interfaces.History.source.html_interface': 'Interfaz HTML',
  'app.pages.Interfaces.History.source.agent': 'Agente',
  'app.pages.Interfaces.History.source.office_addin': 'Complemento de Excel',
  'app.pages.Interfaces.History.source.code': 'Código',
  'app.pages.Interfaces.Table.drilldownBy': 'Expandir por:',
  'app.pages.Interfaces.Table.drilldownBack': 'Volver a:',
  'app.pages.Interfaces.Table.drilldownsApplied': 'Drilldowns aplicados:',
  'app.pages.Interfaces.Table.removeDrilldowns': 'Quitar drilldowns',
  'app.pages.Interfaces.Table.drilldownBackOneLevel': 'Volver un nivel',
  'app.pages.Interfaces.SelectWithAutocomplete.noOptions': 'Sin opciones',
  'app.pages.Interfaces.SelectWithAutocomplete.loading': 'Cargando...',
  'app.pages.Interfaces.IndexFilterDialog.availableElements': 'Elementos disponibles',
  'app.pages.Interfaces.IndexFilterDialog.selectedElements': 'Elementos seleccionados',
  'app.pages.Interfaces.IndexFilterDialog.filterElements': 'Filtrar elementos',
  'app.pages.Interfaces.IndexFilterDialog.contains': 'Contiene',
  'app.pages.Interfaces.IndexFilterDialog.notcontains': 'No contiene',
  'app.pages.Interfaces.IndexFilterDialog.equal': 'Igual a',
  'app.pages.Interfaces.IndexFilterDialog.equal_to_node_values': 'Igual a los valores del nodo',
  'app.pages.Interfaces.IndexFilterDialog.regular_expression': 'Expresión regular',
  'app.pages.Interfaces.IndexFilterDialog.notequal': 'Distinto de',
  'app.pages.Interfaces.IndexFilterDialog.greater_than': 'Mayor a',
  'app.pages.Interfaces.IndexFilterDialog.greater_than_equal_to': 'Mayor o igual a',
  'app.pages.Interfaces.IndexFilterDialog.less_than': 'Menor a',
  'app.pages.Interfaces.IndexFilterDialog.less_than_equal_to': 'Menor o igual a',
  'app.pages.Interfaces.IndexFilterDialog.begin_with': 'Comienza con',
  'app.pages.Interfaces.IndexFilterDialog.not_begin_with': 'No comienza con',
  'app.pages.Interfaces.IndexFilterDialog.end_with': 'Termina con',
  'app.pages.Interfaces.IndexFilterDialog.not_end_with': 'No termina con',
  'app.pages.Interfaces.IndexFilterDialog.naDisplayValue': '(vacíos)',
  'app.pages.Interfaces.IndexFilterDialog.earliest': 'Primero',
  'app.pages.Interfaces.IndexFilterDialog.latest': 'Último',
  'app.pages.Interfaces.IndexFilterDialog.between': 'Entre',
  'app.pages.Interfaces.IndexFilterDialog.notbetween': 'No entre',
  'app.pages.Interfaces.IndexFilterDialog.matches_pattern': 'Coincide con patrón',
  'app.pages.Interfaces.IndexFilterDialog.not_matches_pattern': 'No coincide con patrón',
  'app.pages.Interfaces.IndexFilterDialog.rowsCount': 'Cuenta',
  'app.pages.Interfaces.ConditionFilterDialog.filterApplied': 'Filtro por condición aplicado',
  'app.pages.Interfaces.ConditionFilterDialog.clearFilter': 'Limpiar filtro',
  'app.pages.Interfaces.ConditionFilterDialog.showWhen': 'Mostrar elementos que cumplan',
  'app.pages.Interfaces.ConditionFilterDialog.combinator': 'Cómo combinar las condiciones',
  'app.pages.Interfaces.ConditionFilterDialog.all': 'todas las condiciones (Y)',
  'app.pages.Interfaces.ConditionFilterDialog.any': 'alguna condición (O)',
  'app.pages.Interfaces.ConditionFilterDialog.and': 'Y',
  'app.pages.Interfaces.ConditionFilterDialog.or': 'O',
  'app.pages.Interfaces.ConditionFilterDialog.addCondition': 'Agregar condición',
  'app.pages.Interfaces.ConditionFilterDialog.removeCondition': 'Quitar condición',
  'app.pages.Interfaces.ConditionFilterDialog.patternHelp':
    'Comodines del patrón: * cualquier cantidad de caracteres, ? un solo carácter, ~ antes de * ? ~ para buscarlos literalmente.\nEj.: *aceite*girasol*. No distingue mayúsculas de minúsculas.',
  'app.pages.Interfaces.ItemHeader.filterByValues': 'Filtrar por valores',
  'app.pages.Interfaces.ItemHeader.filterByCondition': 'Filtrar por condición',
  'app.pages.Interfaces.ItemHeader.filterByNodeValues': 'Filtrar por valores de nodo',
  'app.pages.Interfaces.NodeFilterDialog.filterApplied': 'Filtro por valores de nodo aplicado',
  'app.pages.Interfaces.NodeFilterDialog.node': 'Nodo',
  'app.pages.Interfaces.NodeFilterDialog.help':
    'Se filtran los elementos que coinciden con los valores del nodo (una lista, un índice o un único valor) cada vez que se carga la vista. Los valores del nodo que no existen en la dimensión se ignoran.',
  'app.pages.Interfaces.SelectFormColumnsDialog.nodeHelp':
    'Se muestran las columnas cuyo nombre o título está en el resultado del nodo (una lista, un índice o un único valor) cada vez que se carga la vista. Los valores del nodo que no son columnas se ignoran.',
  'app.pages.Interfaces.SelectFormColumnsDialog.conditionHelp':
    'Las condiciones se evalúan sobre los títulos de las columnas cada vez que se carga la vista.',
  'app.pages.Interfaces.Components.core.Node': 'Nodo',
  'app.pages.Interfaces.Components.core.Index': 'Índice',
  'app.pages.Interfaces.Components.core.Selector': 'Selector',
  'app.pages.Interfaces.Components.core.Chart': 'Gráfico',
  'app.pages.Interfaces.Components.core.PlotlyChart': 'Gráfico plotly',
  'app.pages.Interfaces.Components.core.InputValue': 'Entrada de valor',
  'app.pages.Interfaces.Components.core.Table': 'Tabla',
  'app.pages.Interfaces.Components.core.InputDataArray': 'Entrada de dataarray',
  'app.pages.Interfaces.Components.core.InputDataFrame': 'Entrada de dataframe',
  'app.pages.Interfaces.Components.core.Html': 'Texto enriquecido',
  'app.pages.Interfaces.Components.core.Menu': 'Menú',
  'app.pages.Interfaces.Components.core.Empty': 'Vacío',
  'app.pages.Interfaces.Components.core.Generic': 'Genérico',
  'app.pages.Interfaces.Components.core.Indicator': 'Indicador',
  'app.pages.Interfaces.Components.core.Choice': 'Elección',
  'app.pages.Interfaces.Components.core.Button': 'Botón',
  'app.pages.Interfaces.Components.core.Button.disable': 'Deshabilitar botón',
  'app.pages.Interfaces.Components.core.Button.runButtonDefaultMessage':
    '¿Estás seguro/a de que quieres ejecutar este botón?',
  'app.pages.Interfaces.Components.core.Form': 'Formulario',
  'app.pages.Interfaces.Components.core.MyTasks': 'Tareas',
  'app.pages.Interfaces.Components.core.ScheduledTasks': 'Tareas programadas',
  'app.pages.Interfaces.Components.core.InputData': 'Entrada de datos',
  'app.pages.Interfaces.Components.core.MatplotlibChart': 'Gráfico matplotlib',
  'app.pages.Interfaces.Components.core.Assistant': 'Asistente',
  'app.pages.Interfaces.Components.core.Notifications': 'Notificaciones',
  'app.pages.Interfaces.Components.core.DynamicHtml': 'Menú HTML',
  'app.pages.Interfaces.Components.core.Filter': 'Filtro',
  'app.pages.Interfaces.Components.core.Filters': 'Filtros',
  'app.pages.Interfaces.Components.core.UploadManager': 'Gestor de archivos',
  'app.pages.Interfaces.Components.core.HtmlVisualization': 'Visualización HTML',
  'app.pages.Interfaces.Components.core.ApplyFilters': 'Aplicar filtros',
  'app.pages.Interfaces.Components.core.multiple': 'Múltiple',
  'app.pages.Interfaces.Components.core.multiSelect': 'Multi-selección',
  'app.pages.Interfaces.Components.core.numberOfValuesToDisplayInCell':
    'Cantidad de valores a mostrar en la celda',
  'app.pages.Interfaces.View.InterfaceName': 'Interfaz {name}',
  'app.pages.Interfaces.View.share': 'Compartir',
  'app.pages.Interfaces.View.Empty':
    'La interfaz está vacía actualmente. Ingresa al modo edición para agregar componentes.',
  'app.pages.Interfaces.View.openMenu': 'Abrir menú',
  'app.pages.Interfaces.Edit': 'Editar interfaz',
  'app.pages.Interfaces.Edit.Menu.componentConfig': 'Configuración del componente',
  'app.pages.Interfaces.Edit.Menu.newComponent': 'Nuevo componente',
  'app.pages.Interfaces.Edit.Menu.title': 'Título',
  'app.pages.Interfaces.Edit.Menu.chartEvents': 'Eventos',
  'app.pages.Interfaces.Edit.Menu.data': 'Datos',
  'app.pages.Interfaces.Edit.Menu.indexSync': 'Índices sincronizados',
  'app.pages.Interfaces.Edit.Menu.indexSync.all': 'Sincronizar todos los índices',
  'app.pages.Interfaces.Edit.Menu.indexSync.syncedCount': '{synced} de {total} sincronizados',
  'app.pages.Interfaces.Edit.Menu.styleEditor': 'Estilos',
  'app.pages.Interfaces.Edit.Menu.icon': 'Ícono',
  'app.pages.Interfaces.Edit.Menu.advancedPivot': 'Pivot avanzado',
  'app.pages.Interfaces.Edit.Menu.layoutProperties': 'Diseño',
  'app.pages.Interfaces.Edit.Menu.valueFormat': 'Formato de valores',
  'app.pages.Interfaces.Edit.Menu.valueFormatSecondaryAxis': 'Formato de valores - Eje secundario',
  'app.pages.Interfaces.Edit.Menu.conditionalFormat': 'Formato condicional',
  'app.pages.Interfaces.Edit.Menu.cellProperties': 'Propiedades de celdas',
  'app.pages.Interfaces.Edit.Menu.progressBar': 'Barra de progreso',
  'app.pages.Interfaces.Edit.Menu.heatmap': 'Mapa de calor',
  'app.pages.Interfaces.Edit.Menu.componentStyle': 'Componente',
  'app.pages.Interfaces.Edit.Menu.general': 'General',
  'app.pages.Interfaces.Edit.Menu.scenarios': 'Escenarios',
  'app.pages.Interfaces.Edit.Menu.columnsToShow': 'Columnas a mostrar',
  'app.pages.Interfaces.Edit.Menu.scheduledTasksOptions': 'Opciones',
  'app.pages.Interfaces.Edit.Menu.notificationsOptions': 'Opciones',
  'app.pages.Interfaces.Edit.Menu.confirmationDialog': 'Diálogo de confirmación',
  'app.pages.Interfaces.Edit.Menu.showConfirmationDialog': 'Mostrar diálogo',
  'app.pages.Interfaces.Edit.Menu.confirmationDialogMessage': 'Mensaje',
  'app.pages.Interfaces.Edit.Menu.editConfirmationDialogMessage': 'Editar mensaje',
  'app.pages.Interfaces.Edit.Menu.confirmationDialogMessageEditorTitle':
    'Mensaje del diálogo de confirmación',
  'app.pages.Interfaces.Edit.Menu.confirmationDialogMessageEmpty':
    'Se mostrará el mensaje por defecto',
  'app.pages.Interfaces.Edit.Menu.formProperties': 'Propiedades de formulario',
  'app.pages.Interfaces.Edit.Menu.validations': 'Validaciones',
  'app.pages.Interfaces.Edit.Menu.inputCubeProperties': 'Propiedades de cubo',
  'app.pages.Interfaces.Edit.selectNode': 'Selecciona un nodo para crear un componente de tipo',
  'app.pages.Interfaces.Edit.nodeType': 'Tipo de nodo',
  'app.pages.Interfaces.Edit.selectedNodeId': 'Identificador del nodo seleccionado',
  'app.pages.Interfaces.Edit.refresh': 'Refrescar interfaz',
  'app.pages.Interfaces.Edit.refreshAndReset': 'Refrescar interfaz y restablecer su vista',
  'app.pages.Interfaces.Edit.copy': 'Copiar interfaz',
  'app.pages.Interfaces.Edit.detachSidebar': 'Desacoplar sidebar',
  'app.pages.Interfaces.Edit.fixSidebar': 'Fijar sidebar',
  'app.pages.Interfaces.Edit.hidePanel': 'Ocultar panel',
  'app.pages.Interfaces.Edit.showPanel': 'Mostrar panel',
  'app.pages.Interfaces.Edit.removeComponent': 'Quitar componente',
  'app.pages.Interfaces.Edit.remove': 'Quitar',
  'app.pages.Interfaces.Edit.removeConfirmationText':
    '¿Estás seguro de querer quitar este componente?',
  'app.pages.Interfaces.Edit.discardUnsavedChanges': '¿Descartar cambios sin guardar?',
  'app.pages.Interfaces.Edit.discardUnsavedChangesText':
    '¿Estás seguro de querer descartar los cambios sin guardar?',
  'app.pages.Interfaces.Edit.showInterfaceCode': 'Mostrar código de interfaz',
  'app.pages.Interfaces.Edit.gridSettings': 'Editar configuración de grid',
  'app.pages.Interfaces.Edit.interfaceCodeEditor': 'Editor de código de interfaz',
  'app.pages.Interfaces.Edit.closeComponentCodeEditor': 'Cerrar editor de código de componente',
  'app.pages.Interfaces.Edit.customComponentCode': 'Código personalizado de componente',
  'app.pages.Interfaces.Edit.HTMLEditor': 'Editor HTML',
  'app.pages.Interfaces.Edit.menuEditor': 'Editor de menú',
  'app.pages.Interfaces.Edit.title.enabled': 'Mostrar',
  'app.pages.Interfaces.Edit.title.editTitle': 'Editar título',
  'app.pages.Interfaces.Edit.title.customTitle': 'Título personalizado',
  'app.pages.Interfaces.Edit.table.size.rowsPerPage': 'Filas por página',
  'app.pages.Interfaces.Edit.table.size.columnsPerPage': 'Columnas por página',
  'app.pages.Interfaces.Edit.table.data.showRowTotals': 'Mostrar totales de filas',
  'app.pages.Interfaces.Edit.table.data.rowTotalsPosition': 'Posición de totales de filas',
  'app.pages.Interfaces.Edit.table.data.rowTotalsAggregation': 'Agregación de totales de filas',
  'app.pages.Interfaces.Edit.table.data.showColumnTotals': 'Mostrar totales de columnas',
  'app.pages.Interfaces.Edit.table.data.removeColumnTotals': 'Quitar totales por columnas',
  'app.pages.Interfaces.Edit.table.data.removeRowTotals': 'Quitar totales por filas',
  'app.pages.Interfaces.Edit.table.data.columnTotalsPosition': 'Posición de totales de columnas',
  'app.pages.Interfaces.Edit.table.data.columnTotalsAggregation':
    'Agregación de totales de columnas',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByMember': 'Agregación por miembro',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByMemberHelp':
    'Define el método de agregación por miembro de cada dimensión. Se aplica al total inferior cuando la dimensión está en columnas y al total derecho cuando está en filas. El criterio se conserva al mover u ocultar la dimensión.',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByField': 'Agregación por campo',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationByFieldHelp':
    'Define el método de agregación del total inferior por cada campo. Los campos sin excepción usan el método general.',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationFieldsGroup': 'Campos',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationGeneral': 'General',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationNoMembers':
    'La dimensión no tiene miembros para mostrar.',
  'app.pages.Interfaces.Edit.table.data.totalsAggregationNoDimensions':
    'La tabla no tiene dimensiones para configurar.',
  'app.pages.Interfaces.Edit.table.data.compareScenarios': 'Comparar escenarios',
  'app.pages.Interfaces.Edit.table.data.disableCompareScenarios':
    'Deshabilitar comparar escenarios',
  'app.pages.Interfaces.Edit.table.data.compareAllInterfaceScenarios':
    'Comparar escenarios en todos los componentes',
  'app.pages.Interfaces.Edit.table.data.scenariosPlacement': 'Ubicación de escenarios',
  'app.pages.Interfaces.Edit.table.data.scenariosInRows': 'En filas',
  'app.pages.Interfaces.Edit.table.data.scenariosInColumns': 'En columnas',
  'app.pages.Interfaces.Edit.table.data.showValues': 'Mostrar valores',
  'app.pages.Interfaces.Edit.table.data.showDifference': 'Mostrar diferencia',
  'app.pages.Interfaces.Edit.table.data.showPercentageDifference': 'Mostrar diferencia porcentual',
  'app.pages.Interfaces.Edit.table.data.fillMissingWithZero':
    'Completar valores faltantes con cero',
  'app.pages.Interfaces.Edit.table.data.fillMissingWithZeroTooltip':
    'Reemplaza con 0 los valores faltantes en el escenario seleccionado y en el base antes de calcular diferencias.',
  'app.pages.Interfaces.Edit.table.data.zeroDivisionReturnsZero':
    'La división por cero devuelve cero',
  'app.pages.Interfaces.Edit.table.data.zeroDivisionReturnsZeroTooltip':
    'Solo para diferencia porcentual: devuelve 0 cuando el valor del escenario base es 0 en lugar de dividir por cero.',
  'app.pages.Interfaces.Edit.table.data.differenceEndText': 'Texto final de diferencia',
  'app.pages.Interfaces.Edit.table.data.percentageDifferenceEndText':
    'Texto final de diferencia porcentual',
  'app.pages.Interfaces.Edit.table.data.columnsProperties': 'Propiedades de columnas',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData': 'Ocultar datos vacíos',
  'app.pages.Interfaces.Edit.chart.data.hideEmptyLegend': 'Ocultar leyendas vacías',
  'app.pages.Interfaces.Edit.chart.data.syncYAxesRange': 'Sincronizar escalas de ejes Y',
  'app.pages.Interfaces.Edit.table.data.totalsPositions.end': 'Final',
  'app.pages.Interfaces.Edit.table.data.totalsPositions.beginning': 'Comienzo',
  'app.pages.Interfaces.Edit.table.data.showColumnFilterIcon':
    'Mostrar ícono de filtrado de columna',
  'app.pages.Interfaces.Edit.table.data.enableQuickPivot': 'Habilitar pivoteo rápido',
  'app.pages.Interfaces.Edit.table.data.hideFooter': 'Ocultar pie de página',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData.column': 'Columna',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData.row': 'Fila',
  'app.pages.Interfaces.Edit.table.data.hideEmptyData.both': 'Ambas',
  'app.pages.Interfaces.Edit.table.data.processingEngine': 'Motor de procesamiento',
  'app.pages.Interfaces.Edit.table.data.processingEngine.pandas': 'Pandas',
  'app.pages.Interfaces.Edit.table.data.processingEngine.polars': 'Polars',
  'app.pages.Interfaces.Edit.table.data.pagination': 'Paginación',
  'app.pages.Interfaces.Edit.table.data.fixedColumns': 'Columnas fijadas',
  'app.pages.Interfaces.Edit.table.data.subtotalLabel': 'Etiqueta de subtotal',
  'app.pages.Interfaces.Edit.table.data.subtotalLabelHelperText':
    "Usa '{dimension}' como variable para el valor. Dejar vacío para usar la etiqueta por defecto: '{dimension} - Subtotal'",
  'app.pages.Interfaces.Edit.table.data.showIndex': 'Mostrar columna "index"',
  'app.pages.Interfaces.Edit.events.selectedEvent': 'Evento de selección',
  'app.pages.Interfaces.Edit.events.hoverEvent': 'Evento  hover',
  'app.pages.Interfaces.Edit.events.drilldownEvent': 'Evento drilldown',
  'app.pages.Interfaces.Edit.pivot': 'Pivot',
  'app.pages.Interfaces.Edit.filter': 'Filtro',
  'app.pages.Interfaces.Edit.dataHandling': 'Manipulación de datos',
  'app.pages.Interfaces.Edit.appliedFiltersOn': 'Filtros aplicados en',
  'app.pages.Interfaces.Edit.appliedConditionFiltersOn': 'Filtros por condición aplicados en',
  'app.pages.Interfaces.Edit.appliedNodeFiltersOn': 'Filtros por valores de nodo aplicados en',
  'app.pages.Interfaces.Edit.isolateStyles': 'Aislar estilos',
  'app.pages.Interfaces.Edit.style.fontSize': 'Tamaño de fuente',
  'app.pages.Interfaces.Edit.style.fixedColumnWidth': 'Ancho de columna fijo',
  'app.pages.Interfaces.Edit.style.fontStyle': 'Estilo de fuente',
  'app.pages.Interfaces.Edit.style.fontStyle.bold': 'Negrita',
  'app.pages.Interfaces.Edit.style.fontStyle.italic': 'Cursiva',
  'app.pages.Interfaces.Edit.style.fontStyle.underline': 'Subrayado',
  'app.pages.Interfaces.Edit.style.fontColor': 'Color de fuente',
  'app.pages.Interfaces.Edit.style.backgroundColor': 'Color de fondo',
  'app.pages.Interfaces.Edit.style.headerBackgroundColor': 'Color de fondo del encabezado',
  'app.pages.Interfaces.Edit.style.headerColor': 'Color del encabezado',
  'app.pages.Interfaces.Edit.style.textAlign': 'Alineación de texto',
  'app.pages.Interfaces.Edit.style.textAlign.left': 'Izquierda',
  'app.pages.Interfaces.Edit.style.textAlign.center': 'Centrado',
  'app.pages.Interfaces.Edit.style.textAlign.right': 'Derecha',
  'app.pages.Interfaces.Edit.style.textAlign.justify': 'Justificado',
  'app.pages.Interfaces.Edit.style.verticalAlign': 'Alineación vertical',
  'app.pages.Interfaces.Edit.style.verticalAlign.top': 'Arriba',
  'app.pages.Interfaces.Edit.style.verticalAlign.middle': 'Centro',
  'app.pages.Interfaces.Edit.style.verticalAlign.bottom': 'Abajo',
  'app.pages.Interfaces.Edit.style.hideHeader': 'Ocultar encabezado',
  'app.pages.Interfaces.Edit.style.hideBorder': 'Ocultar borde',
  'app.pages.Interfaces.Edit.style.hideMaximizeButton': 'Ocultar botón de maximizar',
  'app.pages.Interfaces.Edit.style.hidePivotIcon': 'Ocultar ícono de pivoteo',
  'app.pages.Interfaces.Edit.style.showViewAsTableChartIcon':
    'Mostrar ícono “Ver como tabla/gráfico”',
  'app.pages.Interfaces.Edit.style.showComponentSettingsIcon':
    'Mostrar ícono de configuración del componente',
  'app.pages.Interfaces.Edit.style.note': '(aplica en modo visualización)',
  'app.pages.Interfaces.Edit.style.setDefaultColor': 'Establecer color por defecto',
  'app.pages.Interfaces.Edit.style.applyAndClose': 'Aplicar y cerrar',
  'app.pages.Interfaces.Edit.style.seriesColors': 'Color de series',
  'app.pages.Interfaces.Edit.style.colorPalette.increasing': 'Incremento',
  'app.pages.Interfaces.Edit.style.colorPalette.decreasing': 'Disminución',
  'app.pages.Interfaces.Edit.style.hideCharacters': 'Ocultar caracteres',
  'app.pages.Interfaces.Edit.layout.style.axesTitles': 'Títulos de ejes',
  'app.pages.Interfaces.Edit.layout.style.showYAxisTitle': 'Mostrar título de eje Y',
  'app.pages.Interfaces.Edit.layout.style.showXAxisTitle': 'Mostrar título de eje X',
  'app.pages.Interfaces.Edit.layout.color_palette': 'Paleta de colores',
  'app.pages.Interfaces.Edit.layout.color_palette.color_continuous_scale': 'Escala continua',
  'app.pages.Interfaces.Edit.layout.color_palette.color_discrete_sequence': 'Secuencia discreta',
  'app.pages.Interfaces.Edit.layout.legend': 'Leyenda',
  'app.pages.Interfaces.Edit.layout.legend.showlegend': 'Mostrar leyenda',
  'app.pages.Interfaces.Edit.layout.legend.toggleOthersWithSingleClick':
    'Alternar otros con un solo click',
  'app.pages.Interfaces.Edit.layout.legend.coloraxis_showscale': 'Mostrar escala',
  'app.pages.Interfaces.Edit.layout.legend.orientation': 'Orientación',
  'app.pages.Interfaces.Edit.layout.legend.xanchor': 'Punto de anclaje X',
  'app.pages.Interfaces.Edit.layout.legend.x': 'X',
  'app.pages.Interfaces.Edit.layout.legend.yanchor': 'Punto de anclaje Y',
  'app.pages.Interfaces.Edit.layout.legend.y': 'Y',
  'app.pages.Interfaces.Edit.layout.margins': 'Márgenes',
  'app.pages.Interfaces.Edit.layout.selectValues.auto': 'Auto',
  'app.pages.Interfaces.Edit.layout.selectValues.left': 'Izquierda',
  'app.pages.Interfaces.Edit.layout.selectValues.center': 'Centro',
  'app.pages.Interfaces.Edit.layout.selectValues.right': 'Derecha',
  'app.pages.Interfaces.Edit.layout.selectValues.top': 'Superior',
  'app.pages.Interfaces.Edit.layout.selectValues.middle': 'Medio',
  'app.pages.Interfaces.Edit.layout.selectValues.bottom': 'Inferior',
  'app.pages.Interfaces.Edit.layout.chartMode': 'Variante de gráfico',
  'app.pages.Interfaces.Edit.layout.chartMode.modePreset': 'Variante predefinida',
  'app.pages.Interfaces.Edit.layout.chartMode.stack': 'Apilado',
  'app.pages.Interfaces.Edit.layout.chartMode.relative': 'Relativo',
  'app.pages.Interfaces.Edit.layout.chartMode.group': 'Agrupado',
  'app.pages.Interfaces.Edit.layout.chartMode.overlay': 'Superpuesto',
  'app.pages.Interfaces.Edit.layout.chartMode.barmode': 'Variante de barra',
  'app.pages.Interfaces.Edit.layout.chartMode.boxmode': 'Variante de caja',
  'app.pages.Interfaces.Edit.layout.chartMode.funnelmode': 'Variante de embudo',
  'app.pages.Interfaces.Edit.layout.chartMode.violinmode': 'Variante de violín',
  'app.pages.Interfaces.Edit.layout.chartMode.waterfallmode': 'Variante de cascada',
  'app.pages.Interfaces.Edit.layout.chartMode.percent': 'Porcentaje',
  'app.pages.Interfaces.Edit.layout.chartNorm': 'Normalización de gráfico',
  'app.pages.Interfaces.Edit.layout.chartNorm.barnorm': 'Normalización de barra',
  'app.pages.Interfaces.Edit.layout.chartNorm.groupnorm': 'Normalización de grupo',
  'app.pages.Interfaces.Edit.layout.chartNorm.fraction': 'Fracción',
  'app.pages.Interfaces.Edit.layout.chartNorm.percent': 'Porcentaje',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels': 'Etiquetas',
  'app.pages.Interfaces.Edit.layout.chartNorm.labelsSecondaryAxis': 'Etiquetas - Eje secundario',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.showLabels': 'Mostrar etiquetas',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.labelField': 'Campo',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.minSize': 'Tamaño mínimo',
  'app.pages.Interfaces.Edit.layout.chartNorm.labels.mode': 'Modo',
  'app.pages.Interfaces.Edit.layout.customSeriesColors': 'Colores de series personalizados',
  'app.pages.Interfaces.Edit.layout.customName': 'Nombre personalizado',
  'app.pages.Interfaces.Edit.layout.addValue': 'Agregar valor',
  'app.pages.Interfaces.Edit.layout.addColor': 'Agregar color',
  'app.pages.Interfaces.Edit.layout.generateValuesFromColumn': 'Generar valores desde columna',
  'app.pages.Interfaces.Edit.layout.y_axis_range': 'Rango de eje Y',
  'app.pages.Interfaces.Edit.layout.y_axis_range_secondary_axis': 'Rango de eje Y - Eje secundario',
  'app.pages.Interfaces.Edit.layout.yAxisTitle': 'Título de eje Y',
  'app.pages.Interfaces.Edit.layout.xAxisTitle': 'Título de eje X',
  'app.pages.Interfaces.Edit.valueFormat.formatPreset': 'Formato preestablecido',
  'app.pages.Interfaces.Edit.valueFormat.number': 'Número',
  'app.pages.Interfaces.Edit.valueFormat.decimal': 'Decimal',
  'app.pages.Interfaces.Edit.valueFormat.integer': 'Entero',
  'app.pages.Interfaces.Edit.valueFormat.percent': 'Porcentaje',
  'app.pages.Interfaces.Edit.valueFormat.currency': 'Moneda',
  'app.pages.Interfaces.Edit.valueFormat.currencyRounded': 'Moneda (redondeado)',
  'app.pages.Interfaces.Edit.valueFormat.accounting': 'Contabilidad',
  'app.pages.Interfaces.Edit.valueFormat.accountingRounded': 'Contabilidad (redondeado)',
  'app.pages.Interfaces.Edit.valueFormat.finance': 'Financiero',
  'app.pages.Interfaces.Edit.valueFormat.financeRounded': 'Financiero (redondeado)',
  'app.pages.Interfaces.Edit.valueFormat.showNegativeInParentheses':
    'Mostrar negativos entre paréntesis',
  'app.pages.Interfaces.Edit.valueFormat.date': 'Fecha',
  'app.pages.Interfaces.Edit.valueFormat.datetime': 'Fecha hora',
  'app.pages.Interfaces.Edit.valueFormat.general': 'General',
  'app.pages.Interfaces.Edit.valueFormat.thousandsSeparator': 'Separador de miles',
  'app.pages.Interfaces.Edit.valueFormat.decimalPlaces': 'Decimales',
  'app.pages.Interfaces.Edit.valueFormat.prefix': 'Prefijo',
  'app.pages.Interfaces.Edit.valueFormat.suffix': 'Sufijo',
  'app.pages.Interfaces.Edit.valueFormat.dateFormat': 'Formato de fecha',
  'app.pages.Interfaces.Edit.valueFormat.datetimeFormat': 'Formato de fecha hora',
  'app.pages.Interfaces.Edit.valueFormat.seePatternReference': 'Ver referencia sobre patrones',
  'app.pages.Interfaces.Run.runningButton': 'Ejecutando botón',
  'app.pages.Interfaces.Edit.editTitle.showUnits': 'Mostrar unidades',
  'app.pages.Interfaces.Edit.progressBar.applyProgressBar': 'Aplicar barra de progreso',
  'app.pages.Interfaces.Edit.progressBar.max_value': 'Valor máximo',
  'app.pages.Interfaces.Edit.progressBar.min_hue': 'Matiz mínima',
  'app.pages.Interfaces.Edit.progressBar.max_hue': 'Matiz máxima',
  'app.pages.Interfaces.Edit.progressBar.saturation': 'Saturación',
  'app.pages.Interfaces.Edit.progressBar.lightness': 'Claridad',
  'app.pages.Interfaces.Edit.progressBar.show_value': 'Mostrar valor',
  'app.pages.Interfaces.Edit.heatmap.applyHeatmap': 'Aplicar mapa de calor',
  'app.pages.Interfaces.Edit.heatmap.by': 'Por',
  'app.pages.Interfaces.Edit.heatmap.hex_base_background_color': 'Color de fondo base',
  'app.pages.Interfaces.Edit.heatmap.hex_text_color': 'Color de texto',
  'app.pages.Interfaces.Edit.heatmap.exclude_nans': 'Excluir NaNs',
  'app.pages.Interfaces.Edit.heatmap.exclude_right_total': 'Excluir totales de filas',
  'app.pages.Interfaces.Edit.heatmap.exclude_bottom_total': 'Excluir totales de columnas',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor': 'Color de mapa de calor',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_green_alt': 'rojo-verde-alt',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_red_alt': 'verde-rojo-alt',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_green': 'rojo-verde',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_red': 'verde-rojo',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_white': 'rojo-blanco',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.white_red': 'blanco-rojo',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.white_green': 'blanco-verde',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_white': 'verde-blanco',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.green_blue': 'verde-azul',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.blue_green': 'azul-verde',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.red_blue': 'rojo-azul',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.blue_red': 'azul-rojo',
  'app.pages.Interfaces.Edit.heatmap.heatmapColor.custom': 'Personalizado',
  'app.pages.Interfaces.Edit.conditionalFormat.addCondition': 'Agregar condición',
  'app.pages.Interfaces.Edit.conditionalFormat.deleteAll': 'Borrar todas',
  'app.pages.Interfaces.Edit.conditionalFormat.Conditions': 'Condiciones',
  'app.pages.Interfaces.Edit.conditionalFormat.showIconOnly': 'Mostrar sólo el ícono',
  'app.pages.Interfaces.Edit.conditionalFormat.expressionInfo1':
    'Completar con una expresión donde cada nombre de columna esté encerrado entre # al inicio y al final. Todos los nombres de columnas utilizados deben estar presentes en la tabla final.',
  'app.pages.Interfaces.Edit.conditionalFormat.expressionInfo2':
    'La expresión debe retornar siempre una serie booleana.',
  'app.pages.Interfaces.Edit.conditionalFormat.expressionInfo3': 'Por ejemplo:',
  'app.pages.Interfaces.Edit.style.addNewStyle': 'Agregar nuevo estilo',
  'app.pages.Interfaces.Edit.style.deleteStyle': 'Borrar estilo',
  'app.pages.Interfaces.Edit.style.editStyle': 'Editar estilo',
  'app.pages.Interfaces.Edit.style.dimensionName': 'Nombre de dimensión',
  'app.pages.Interfaces.Edit.style.filterType': 'Tipo de filtro',
  'app.pages.Code.Diagram.Wizards.styleConditions': 'Condiciones del estilo',
  'app.pages.Code.Diagram.Wizards.filterIndexes': 'Filtrar índices',
  'app.pages.Interfaces.Edit.colorPicker.themeColors': 'Colores del tema',
  'app.pages.Interfaces.Edit.colorPicker.standardColors': 'Colores estándar',
  'app.pages.Interfaces.Edit.colorPicker.recentColors': 'Colores recientes',
  'app.pages.Interfaces.Edit.colorPicker.selectedColor': 'Color seleccionado',
  'app.pages.Interfaces.Edit.leaveInterfaceTitle': 'Interfaz con cambios no confirmados',
  'app.pages.Interfaces.Edit.leaveInterfaceContent':
    '¿Quieres confirmar los cambios o descartarlos?',
  'app.pages.Interfaces.Edit.inputNodeProperties.hideIdColumn': 'Ocultar columna con ID',
  'app.pages.Interfaces.Edit.inputNodeProperties.confirmOnChange': 'Confirmar al hacer un cambio',
  'app.pages.Interfaces.Edit.inputNodeProperties.invalidateOutputsOnChange':
    'Invalidar outputs al hacer un cambio',
  'app.pages.Interfaces.Edit.inputNodeProperties.invalidateOutputsOnConfirm':
    'Invalidar outputs al confirmar',
  'app.pages.Interfaces.Edit.inputNodeProperties.updateCalcColumnsOnChange':
    'Actualizar columnas calculadas al hacer un cambio',
  'app.pages.Interfaces.Edit.inputNodeProperties.updateCalcColumnsOnConfirm':
    'Actualizar columnas calculadas al confirmar',
  'app.pages.Interfaces.Edit.inputNodeProperties.showSelectColumnsIcon':
    'Mostrar ícono de Seleccionar columnas',
  'app.pages.Interfaces.Edit.inputNodeProperties.showEditExcelIcon':
    'Mostrar ícono de Editar en Excel',
  'app.pages.Interfaces.Edit.inputNodeProperties.showRefreshIcon':
    'Mostrar ícono de Actualizar datos',
  'app.pages.Interfaces.Edit.inputNodeProperties.showHistoryIcon':
    'Mostrar ícono de Historial de datos',
  'app.pages.Interfaces.Edit.inputNodeProperties.newRowsPosition': 'Posición de nuevas filas',
  'app.pages.Interfaces.Edit.filterIndexValues': 'Filtrar valores de índice',
  'app.pages.Interfaces.Edit.filterIndexValues.fromToError':
    'El valor "Desde" debe ser menor o igual al valor "Hasta".',
  'app.pages.Interfaces.Edit.style.applyConditionTo': 'Aplicar condición a',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customView': 'Vista personalizada',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customViewWithName':
    'Vista personalizada: {name}',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.editingCustomView':
    'Estás editando la vista personalizada "{name}"',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.originalView': 'Vista original',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.myView': 'Mi vista',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.opensByDefault': 'Se abre por defecto',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.openByDefault': 'Abrir esta vista por defecto',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.saveChangesInView':
    'Guardar cambios en "{name}"',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.saveAsNewView': 'Guardar como nueva vista…',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.newView': 'Nueva vista personalizada',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.editView': 'Editar vista personalizada',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.deleteViewConfirm':
    '¿Borrar la vista personalizada "{name}"?',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.deleteCustomView':
    'Borrar vista personalizada',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customViewSaved':
    'La vista personalizada de la interfaz se ha guardado correctamente',
  'app.pages.Interfaces.Edit.interfaceCustomViewMenu.customViewDeleted':
    'La vista personalizada de la interfaz se ha borrado correctamente',
  'app.pages.Interfaces.components.options.showPivotArea': 'Mostrar área de pivote',
  'app.pages.Interfaces.components.options.hidePivotArea': 'Ocultar área de pivote',
  'app.pages.app.properties.componentOptions': 'Opciones del componente',

  //Instance manager
  'app.pages.app.instanceManager.noInstances': 'No hay instancias',
  'app.pages.app.instanceManager.open': 'Abierto',
  'app.pages.app.instanceManager.currentApplication': 'Aplicación actual',
  'app.pages.app.instanceManager.active': 'Activo',
  'app.pages.app.instanceManager.timeoutIn': 'Tiempo de espera restante',
  'app.pages.app.instanceManager.minutes': ' min',
  'app.pages.app.instanceManager.cpu': 'CPU',
  'app.pages.app.instanceManager.memory': 'Memoria',
  'app.pages.app.instanceManager.peak': 'Pico',
  'app.pages.app.instanceManager.apiResources': 'Recursos de la aplicación',
  'app.pages.app.instanceManager.systemMemory': 'Total',
  'app.pages.app.instanceManager.inUse': 'En uso',
  'app.pages.app.instanceManager.disk': 'Disco',
  'app.pages.app.instanceManager.time': 'Tiempo',
  'app.pages.app.instanceManager.selectedInstance': 'Instancia seleccionada',
  'app.pages.app.instanceManager.pid': 'PID',
  'app.pages.app.instanceManager.memoryPeak': 'Pico de memoria',
  'app.pages.app.instanceManager.lastProcessedNode': 'Último nodo procesado',
  'app.pages.app.instanceManager.requireLogoutTitle': 'Requerir el cierre de instancia',
  'app.pages.app.instanceManager.requireLogoutMessage':
    '¿Estás seguro de enviar una petición para que el usuario cierre su instancia?',
  'app.pages.app.instanceManager.killInstanceTitle': 'Cerrar instancia',
  'app.pages.app.instanceManager.killInstanceMessage':
    'Toda la información de la instancia no guardada se perderá. ¿Estás seguro?',
  'app.pages.app.instanceManager.requestSent': 'Petición enviada',
  'app.pages.app.instanceManager.instanceClosed': 'Instancia cerrada',
  'app.pages.app.instanceManager.editionAvailable': 'Edición disponible',
  'app.pages.app.instanceManager.processing': 'Procesando',
  'app.pages.app.instanceManager.info': 'Info',
  'app.pages.app.instanceManager.openAppsOnly': 'Sólo apps abiertas',
  'app.pages.app.instanceManager.noSelectedInstance': 'No hay instancia seleccionada',
  'app.pages.app.instanceManager.scheduledTask': 'Tarea programada',
  'app.pages.app.instanceManager.hasOpenedBrowser': 'Tiene el navegador abierto',
  'app.pages.app.instanceManager.yourInstanceIsAboutToExpire':
    'Tu instancia está a punto de expirar',
  'app.pages.app.instanceManager.pressConfirmToExtendYourInstance':
    'Presiona confirmar para extender tu instancia',
  'app.pages.app.instanceManager.yourInstanceHasBeenExtended': 'Tu instancia ha sido extendida',
  'app.pages.app.instanceManager.cpuArchitecture': 'Arquitectura',
  'app.pages.app.instanceManager.userOrigin': 'Origen',
  'app.pages.app.instanceManager.internalUser': 'Interno',
  'app.pages.app.instanceManager.externalUser': 'Externo',
  'app.pages.app.instanceManager.agentUser': 'Agente',
  'app.pages.app.instanceManager.poolOrigin': 'Pool',
  'app.pages.app.instanceManager.poolForUser': 'Pool {user}',
  'app.pages.app.instanceManager.noFilteredInstances': 'Ninguna instancia coincide con los filtros',
  'app.pages.app.instanceManager.lastUpdate': 'Última actualización: {lastUpdate}',
  'app.pages.app.instanceManager.useOfMemoryAndCPUByPOD': 'Uso de CPU y memoria por POD',
  'app.pages.app.instanceManager.restartPodsInfo':
    'Limpiar datos de uso de CPU/Memoria de los Pods',
  'app.pages.app.instanceManager.totalByPod': 'Total por pod',
  //Log manager
  'app.pages.managers.logs': 'Logs',
  'app.pages.managers.logManager.startDate': 'Fecha desde',
  'app.pages.managers.logManager.endDate': 'Fecha hasta',
  'app.pages.managers.logManager.instanceKey': 'Instancia',
  'app.pages.managers.logManager.podName': 'Pod',
  'app.pages.managers.logManager.user': 'Usuario',
  'app.pages.managers.logManager.user.notFound': 'Usuario no encontrado',
  'app.pages.managers.logManager.user.selectUser': 'Selecciona o busca un usuario',
  'app.pages.managers.logManager.action': 'Acción',
  'app.pages.managers.logManager.action.notFound': 'Acción no encontrada',
  'app.pages.managers.logManager.action.selectAction': 'Selecciona o busca una acción',
  'app.pages.managers.logManager.model': 'Modelo',
  'app.pages.managers.logManager.reportDownloaded': 'Reporte descargado',
  'app.pages.managers.logManager.clearFilters': 'Borrar filtros',
  'app.pages.managers.logManager.filter': 'Filtrar',
  'app.pages.managers.logManager.table.date': 'Fecha',
  'app.pages.managers.logManager.table.query': 'Consulta',
  'app.pages.managers.logManager.table.body': 'Cuerpo',
  'app.pages.managers.logManager.table.podName': 'Pod',
  'app.pages.managers.logManager.table.memory': 'Memoria (MB)',
  'app.pages.managers.logManager.appOrQuery': 'App o consulta',
  'app.pages.managers.logManager.lastHour': 'Última hora',
  'app.pages.managers.logManager.last24Hours': 'Últimas 24 horas',
  'app.pages.managers.logManager.last7Days': 'Últimos 7 días',
  'app.pages.managers.logManager.rangeError':
    'Este rango es de {range} días. Elige hasta {days} días.',
  'app.pages.managers.logManager.rangeOrderError': '"Hasta" tiene que ser posterior a "Desde".',
  'app.pages.managers.logManager.empty.title': 'No hay solicitudes para estos filtros',
  'app.pages.managers.logManager.empty.hint':
    'No se registró nada para esta combinación entre {range}. Prueba ampliar el rango de fechas o quitar algún filtro.',
  'app.pages.managers.logManager.rangeFrom': 'Desde',
  'app.pages.managers.logManager.rangeTo': 'Hasta',
  'app.pages.managers.logManager.rangeHelper': 'Hasta {days} días',
  'app.pages.managers.logManager.downloadCsv': 'Descargar CSV',
  'app.pages.managers.logManager.filtering': 'Filtrando…',
  'app.pages.managers.logManager.detail.title': 'Detalle de la solicitud',
  'app.pages.managers.logManager.detail.properties': 'Propiedades',
  'app.pages.managers.logManager.detail.company': 'Compañía',
  'app.pages.managers.logManager.detail.appVersion': 'Versión de la app',
  'app.pages.managers.logManager.detail.noQuery': 'No se enviaron parámetros.',
  'app.pages.managers.logManager.detail.noBody': 'No se envió cuerpo.',
  'app.pages.managers.logManager.detail.clientAndServer': 'Cliente y servidor',
  'app.pages.managers.logManager.detail.ip': 'Dirección IP',
  'app.pages.managers.logManager.detail.browser': 'Navegador',
  'app.pages.managers.logManager.detail.os': 'Sistema operativo',
  'app.pages.managers.logManager.detail.device': 'Dispositivo',
  'app.pages.managers.logManager.detail.sessionDuration': 'Duración de la sesión',
  'app.pages.managers.logManager.detail.onlyThisUser': 'Ver solo las solicitudes de este usuario',
  'app.pages.managers.instanceLogs': 'Logs de instancias',
  'app.pages.managers.instanceLogs.userOrInstance': 'Usuario o id de instancia',
  'app.pages.managers.instanceLogs.pleaseSelectLog':
    'Selecciona un log de la tabla para ver los detalles',
  'app.pages.managers.instanceLogs.emptyLog': 'Log vacío',
  'app.pages.managers.instanceLogs.copyLog': 'Copiar log',
  'app.pages.managers.instanceLogs.logCopied': 'Log copiado',
  'app.pages.managers.instanceLogs.searchInLogs': 'Buscar en logs',
  'app.pages.managers.instanceLogs.searchInLogs.notFound':
    'No se encontraron coincidencias para: {text}',

  // App documentation
  'app.pages.managers.appDocumentation': 'Documentación',
  'app.pages.managers.appDocumentation.includeInterfaces': 'Incluir interfaces',
  'app.pages.managers.appDocumentation.uploadingDocumentation': 'Subiendo documentación',
  'app.pages.managers.appDocumentation.uploadSuccess': 'Documentación subida con éxito',
  'app.pages.managers.appDocumentation.includeNodes': 'Incluir nodos',
  'app.pages.managers.appDocumentation.generateAutomatically': 'Generar automáticamente',
  'app.pages.managers.appDocumentation.generating': 'Generando documentación de la aplicación...',
  'app.pages.managers.appDocumentation.options.title': 'Generar documentación',
  'app.pages.managers.appDocumentation.options.description':
    'Por defecto se documenta cada interfaz de la aplicación. De forma opcional, puedes acotar esta ejecución a un subconjunto de interfaces y/o agregar instrucciones extra para el agente documentador.',
  'app.pages.managers.appDocumentation.options.interfaces': 'Interfaces a documentar (opcional)',
  'app.pages.managers.appDocumentation.options.extraInstructions': 'Instrucciones extra (opcional)',
  'app.pages.managers.appDocumentation.options.extraInstructionsPlaceholder':
    'Ej: enfócate en el módulo de ventas, usa un tono formal, omite la sección de resumen...',

  // Documenter agents
  'app.pages.documentation.documentAutomatically': 'Generar documentación automáticamente',
  'app.pages.documentation.generateDocumentation': 'Generar documentación',
  'app.pages.documentation.generatingDocumentation': 'Generando documentación...',
  'common.documentationGenerated': 'Documentación generada correctamente',
  'common.documentation.languageRequired':
    'La aplicación debe tener un idioma por defecto configurado para generar documentación automáticamente',
  'app.pages.Code.Diagram.ContextMenu.documentNode': 'Documentar nodo',
  'app.pages.Code.Diagram.ContextMenu.documentModule': 'Documentar módulo',
  'app.pages.Code.Diagram.ContextMenu.documentSelectedNodes':
    'Documentar {count} nodos seleccionados',
  'app.pages.Code.Diagram.ContextMenu.documentSelectedModules':
    'Documentar {count} módulos seleccionados',
  'app.pages.Code.Diagram.documentingSelectedNodes': 'Documentando nodos',
  'app.pages.Code.Diagram.documentingSelectedModules': 'Documentando módulos',
  'app.pages.Code.Diagram.ContextMenu.documentOptions': 'Documentar diagrama',
  'app.pages.interfaceManager.htmlInterfaceType': 'HTML',
  'app.pages.interfaceManager.documentAllInterfaces': 'Documentar todas las interfaces',
  'app.pages.interfaceManager.documentingInterfaces': 'Documentando interfaces',
  'app.pages.interfaceManager.documentSelectedInterfaces':
    'Documentar {count} interfaces seleccionadas',
  'app.pages.interfaceManager.documentInterface': 'Documentar interfaz',
  'app.pages.interfaceManager.documentFolderContent': 'Documentar interfaces de la carpeta',
  'app.pages.interfaceManager.documentSelectedFoldersContent':
    'Documentar contenido de {count} carpetas seleccionadas',
  'app.pages.interfaceManager.documentFolder.scope.direct':
    'Solo las interfaces dentro de la(s) carpeta(s) seleccionada(s)',
  'app.pages.interfaceManager.documentFolder.scope.recursive':
    'Las interfaces de la(s) carpeta(s) y todas sus subcarpetas (recursivo)',
  'app.pages.moduleDocumentation.dialogTitle': 'Documentar módulo',
  'app.pages.moduleDocumentation.dialogTitle.multi': 'Documentar {count} módulos',
  'app.pages.moduleDocumentation.generating':
    'Se está generando la documentación automática del módulo. Esto puede tardar unos segundos.',
  'app.pages.moduleDocumentation.generating.multi':
    'Se está generando la documentación automática de {count} módulos. Esto puede tardar unos segundos.',
  'app.pages.moduleDocumentation.scope.moduleOnly': 'Solo el módulo (a partir de sus nodos)',
  'app.pages.moduleDocumentation.scope.moduleAndNodes': 'Módulo y todos los nodos internos',
  'app.pages.moduleDocumentation.scope.moduleAndNodesRecursive':
    'Módulo, nodos internos y módulos (recursivo)',
  'app.pages.documentation.options.mode.label': '¿Cómo se debe tratar la documentación existente?',
  'app.pages.documentation.options.mode.overwrite': 'Sobrescribir la documentación existente',
  'app.pages.documentation.options.mode.missingOnly':
    'Documentar solo los elementos sin documentación',
  'app.pages.documentation.options.scope.label': 'Alcance',
  'app.pages.documentation.error.generic': 'No se pudo generar la documentación.',
  'app.pages.documentCurrentView.scope.nodesOnly':
    'Solo los nodos directos de esta vista del diagrama',
  'app.pages.documentCurrentView.scope.includeModules':
    'Nodos directos y los módulos de esta vista del diagrama',
  'app.pages.documentCurrentView.scope.recursive':
    'Nodos directos, módulos y su contenido (recursivo)',

  //Interface toolbar
  'app.pages.interfaces.toolbar.cancel': 'Cancelar',
  'app.pages.interfaces.toolbar.mode': 'Modo',
  'app.pages.interfaces.toolbar.hideMinMaxLabels': 'Ocultar etiquetas de mínimo y máximo',
  'app.pages.interfaces.toolbar.mode.single': 'Simple',
  'app.pages.interfaces.toolbar.mode.multi': 'Múltiple',
  'app.pages.interfaces.toolbar.format': 'Formato',
  'app.pages.interfaces.toolbar.menu.alignment': 'Alineación',
  'app.pages.interfaces.toolbar.format.small': 'Pequeño',
  'app.pages.interfaces.toolbar.format.hidden': 'Oculto',
  'app.pages.interfaces.toolbar.format.range': 'Rango',
  'app.pages.interfaces.toolbar.format.select': 'Selección',
  'app.pages.interfaces.toolbar.format.radio': 'Radio',
  'app.pages.interfaces.toolbar.format.slider': 'Deslizador',
  'app.pages.interfaces.toolbar.format.options_list': 'Lista de opciones',
  'app.pages.interfaces.toolbar.format.selectable_chips': 'Fichas seleccionables',
  'app.pages.interfaces.toolbar.orientation': 'Orientación',
  'app.pages.interfaces.toolbar.orientation.horizontal': 'Horizontal',
  'app.pages.interfaces.toolbar.orientation.vertical': 'Vertical',
  'app.pages.interfaces.toolbar.chartType': 'Tipo de gráfico',
  'app.pages.interfaces.toolbar.chartSubtype': 'Subtipo de gráfico',
  'app.pages.interfaces.toolbar.chartType.bar': 'Barra',
  'app.pages.interfaces.toolbar.chartType.column': 'Columna',
  'app.pages.interfaces.toolbar.chartType.normal': 'Normal',
  'app.pages.interfaces.toolbar.chartType.stacked': 'Apilado',
  'app.pages.interfaces.toolbar.chartType.percentStacked': 'Porcentaje apilado',
  'app.pages.interfaces.toolbar.chartType.line': 'Línea',
  'app.pages.interfaces.toolbar.chartType.linesOnly': 'Sólo líneas',
  'app.pages.interfaces.toolbar.chartType.linesAndPoints': 'Líneas y puntos',
  'app.pages.interfaces.toolbar.chartType.pointsOnly': 'Sólo puntos',
  'app.pages.interfaces.toolbar.chartType.pie': 'Torta',
  'app.pages.interfaces.toolbar.chartType.donut': 'Dona',
  'app.pages.interfaces.toolbar.chartType.sunburst': 'Proyección solar',
  'app.pages.interfaces.toolbar.chartType.area': 'Área',
  'app.pages.interfaces.toolbar.chartType.percent': 'Porcentaje',
  'app.pages.interfaces.toolbar.chartType.scatter': 'Dispersión',
  'app.pages.interfaces.toolbar.chartType.combined': 'Combinado',
  'app.pages.interfaces.toolbar.chartType.scatterWithTrendline':
    'Dispersión con línea de tendencia',
  'app.pages.interfaces.toolbar.chartType.others': 'Otros',
  'app.pages.interfaces.toolbar.chartType.waterfall': 'Cascada',
  'app.pages.interfaces.toolbar.chartType.funnel': 'Embudo',
  'app.pages.interfaces.toolbar.chartType.timeline': 'Línea de tiempo',
  'app.pages.interfaces.toolbar.chartType.treemap': 'Mapa de árbol',
  'app.pages.interfaces.toolbar.chartType.icicle': 'Carámbano',
  'app.pages.interfaces.toolbar.chartType.funnelArea': 'Área de embudo',
  'app.pages.interfaces.toolbar.chartType.histogram': 'Histograma',
  'app.pages.interfaces.toolbar.chartType.box': 'Caja',
  'app.pages.interfaces.toolbar.chartType.violin': 'Violín',
  'app.pages.interfaces.toolbar.chartType.strip': 'Banda',
  'app.pages.interfaces.toolbar.chartType.densityHeatmap': 'Mapa de calor de densidad',
  'app.pages.interfaces.toolbar.chartType.densityContour': 'Contorno de densidad',
  'app.pages.interfaces.toolbar.chartType.scatter3d': 'Dispersión 3D',
  'app.pages.interfaces.toolbar.chartType.line3d': 'Línea 3D',
  'app.pages.interfaces.toolbar.chartType.scatterMatrix': 'Matriz de dispersión',
  'app.pages.interfaces.toolbar.chartType.parallelCoordinates': 'Coordenadas paralelas',
  'app.pages.interfaces.toolbar.chartType.parallelCategories': 'Categorías paralelas',
  'app.pages.interfaces.toolbar.chartType.scatterMapbox': 'Mapa de dispersión',
  'app.pages.interfaces.toolbar.chartType.lineMapbox': 'Mapa de línea',
  'app.pages.interfaces.toolbar.chartType.choroplethMapbox': 'Mapa de coropleta',
  'app.pages.interfaces.toolbar.chartType.densityMapbox': 'Mapa de densidad',
  'app.pages.interfaces.toolbar.chartType.scatterPolar': 'Dispersión polar',
  'app.pages.interfaces.toolbar.chartType.linePolar': 'Línea polar',
  'app.pages.interfaces.toolbar.chartType.barPolar': 'Barra polar',
  'app.pages.interfaces.toolbar.chartType.scatterTernary': 'Dispersión ternaria',
  'app.pages.interfaces.toolbar.chartType.lineTernary': 'Línea ternaria',
  'app.pages.interfaces.toolbar.chartType.groups.basics': 'Básicos',
  'app.pages.interfaces.toolbar.chartType.groups.financial': 'Financiero',
  'app.pages.interfaces.toolbar.chartType.groups.partOfWhole': 'Parte-de-todo',
  'app.pages.interfaces.toolbar.chartType.groups.1dDistributions': 'Distribuciones 1D',
  'app.pages.interfaces.toolbar.chartType.groups.2dDistributions': 'Distribuciones 2D',
  'app.pages.interfaces.toolbar.chartType.groups.3dimensional': '3-Dimensional',
  'app.pages.interfaces.toolbar.chartType.groups.multidimensional': 'Multidimensional',
  'app.pages.interfaces.toolbar.chartType.groups.tileMaps': 'Mapas de mosaicos',
  'app.pages.interfaces.toolbar.chartType.groups.polarCharts': 'Gráficos polares',
  'app.pages.interfaces.toolbar.chartType.groups.ternaryCharts': 'Gráficos ternarios',
  'app.pages.interfaces.toolbar.showComponentCode': 'Mostrar código del componente',
  'app.pages.interfaces.toolbar.openComponentCode': 'Abrir código del componente',
  'app.pages.interfaces.toolbar.clearFilters': 'Limpiar filtros',
  'app.pages.interfaces.toolbar.componentCodeEditor': 'Editor de código del componente',
  'app.pages.interfaces.toolbar.menuFormat': 'Formato del menú',
  'app.pages.interfaces.toolbar.menuFormat.accordion': 'Acordeón',
  'app.pages.interfaces.toolbar.menuFormat.compact_menu': 'Menú compacto',
  'app.pages.interfaces.toolbar.menuFormat.boxes': 'Cajas',
  'app.pages.interfaces.toolbar.menuFormat.mini': 'Mini',
  'app.pages.interfaces.toolbar.menu.newItem': 'Nuevo item',
  'app.pages.interfaces.toolbar.menu.newAction': 'Nueva acción',
  'app.pages.interfaces.toolbar.menu.addItem': 'Agregar item',
  'app.pages.interfaces.toolbar.menu.addAction': 'Agregar acción',
  'app.pages.interfaces.toolbar.menu.removeItem': 'Borrar item',
  'app.pages.interfaces.toolbar.menu.removeAction': 'Borrar acción',
  'app.pages.interfaces.toolbar.menu.root': 'Raíz',
  'app.pages.interfaces.toolbar.menu.actionType': 'Tipo de acción',
  'app.pages.interfaces.toolbar.menu.navigateTo': 'Navegar a',
  'app.pages.interfaces.toolbar.menu.target': 'Destino',
  'app.pages.interfaces.toolbar.menu.customPath': 'Ruta personalizada',
  'app.pages.interfaces.toolbar.menu.manualPath': 'Escribir ruta manual',
  'app.pages.interfaces.toolbar.menu.currentTab': 'Pestaña actual',
  'app.pages.interfaces.toolbar.menu.newTab': 'Nueva pestaña',
  'app.pages.interfaces.toolbar.menu.expanded': 'Expandido',
  'app.pages.interfaces.toolbar.menu.subtitle': 'Subtítulo',
  'app.pages.interfaces.toolbar.menu.openInterface': 'Abrir interfaz',
  'app.pages.interfaces.toolbar.menu.navigate': 'Navegar',
  'app.pages.interfaces.toolbar.menu.textColor': 'Color del texto',
  'app.pages.interfaces.toolbar.menu.iconColor': 'Color del ícono',
  'app.pages.interfaces.toolbar.menu.backgroundColor': 'Color de fondo',
  'app.pages.interfaces.toolbar.menu.hoverColor': 'Color del hover',
  'app.pages.interfaces.toolbar.menu.textTranslations': 'Traducciones de texto',
  'app.pages.interfaces.toolbar.menu.subtitleTranslations': 'Traducciones de subtítulo',
  'app.pages.interfaces.toolbar.menu.customTitleTranslations':
    'Traducciones de título personalizado',
  'app.pages.interfaces.componentHasCustomCodeMessage':
    'Este componente tiene código personalizado, lo que puede impedir que se apliquen ciertas configuraciones.',
  'app.pages.interfaces.toolbar.openHtmlEditor': 'Abrir editor HTML',
  'app.pages.interfaces.toolbar.openDynamicHtmlEditor': 'Abrir editor HTML dinámico',
  'app.pages.interfaces.toolbar.dynamicHtmlCustomization': 'Personalización HTML dinámico',
  'app.pages.interfaces.toolbar.selectSectionToGo': 'Selecciona una sección a ir',
  'app.pages.interfaces.toolbar.selectRunAppNode': 'Selecciona un nodo de aplicación a ejecutar',
  'app.pages.interfaces.toolbar.openInNewTab': 'Abrir en nueva pestaña',
  'app.pages.interfaces.toolbar.openMenuEditor': 'Abrir editor de menú',
  'app.pages.interfaces.toolbar.autoOpenSingleAction':
    'Abrir automáticamente la única acción disponible',
  'app.pages.interfaces.toolbar.showSearchInput': 'Mostrar campo de búsqueda',
  'app.pages.interfaces.toolbar.exportComponent': 'Exportar componente',
  'app.pages.interfaces.toolbar.fileFormat': 'Formato de archivo',
  'app.pages.interfaces.toolbar.numberFormat': 'Formato de número',
  'app.pages.interfaces.toolbar.exportShape': 'Disposición',
  'app.pages.interfaces.toolbar.exportShapeSeen': 'Como se ve',
  'app.pages.interfaces.toolbar.exportShapeList': 'En lista (una fila por cifra)',
  'app.pages.interfaces.tableSheet.failed': 'No se pudo descargar la tabla como planilla',
  'app.pages.interfaces.tableSheet.failedBecause':
    'No se pudo descargar la tabla como planilla: {reason}',
  'app.pages.interfaces.tableSheet.linkedName': '{title} (vinculado)',
  'app.pages.interfaces.tableSheet.openDownloaded': 'Abrí el archivo descargado con Excel',
  'app.pages.interfaces.toolbar.exportIncludeTotals': 'Incluir subtotales y totales',
  'app.pages.interfaces.toolbar.exportKeepFormats': 'Mantener formato de números ($, %, decimales)',
  'app.pages.interfaces.toolbar.columnSeparator': 'Separador de columnas',
  'app.pages.interfaces.toolbar.compressToDownload': 'Comprimir archivo para la descarga',
  'app.pages.interfaces.toolbar.excludeNullAndZero': 'Excluir valores ceros y nulos',
  'app.pages.interfaces.toolbar.fullNode': 'Nodo completo',
  'app.pages.interfaces.toolbar.currentView': 'Vista actual',
  'app.pages.interfaces.toolbar.useTitlesInExport': 'Usar nombres visibles en columnas',
  'app.pages.interfaces.toolbar.includeNestedHeaders': 'Incluir todos los niveles de encabezado',
  'app.pages.interfaces.toolbar.fileName': 'Nombre de archivo',
  'app.pages.interfaces.toolbar.multiline': 'Multilínea',
  'app.pages.interfaces.toolbar.uppercase': 'Mayúsculas',
  'app.pages.interfaces.toolbar.fixedPositionOnTop': 'Posición fija en la parte superior',
  'app.pages.interfaces.toolbar.stickyHeader': 'Encabezado adherido',
  'app.pages.interfaces.toolbar.openFilterEditor': 'Abrir editor de filtro',
  'app.pages.interfaces.toolbar.visibilityController': 'Controlador de visibilidad',
  'app.pages.interfaces.toolbar.buttonFormat.default': 'Todo el contenedor',
  'app.pages.interfaces.toolbar.buttonFormat.compact': 'Compacto',
  'app.pages.interfaces.chart': 'Gráfico',
  'app.pages.interfaces.indicator': 'Indicador',
  'app.pages.interfaces.interfaceDeleted': 'Interfaz eliminada',
  'app.pages.interfaces.folderDeleted': 'Carpeta eliminada',
  'app.pages.interfaces.interfaceDuplicated': 'Interfaz duplicada',
  'app.pages.interfaces.folderDuplicated': 'Carpeta duplicada',
  'app.pages.interfaces.viewAsChart': 'Ver como gráfico',
  'app.pages.interfaces.viewAsTable': 'Ver como tabla',
  'app.pages.interfaces.defaultInterface': 'Interfaz por defecto',
  'app.pages.interfaces.tooManyComponents':
    'Esta interfaz contiene una gran cantidad de componentes. Considera dividirla en vistas más pequeñas para mejorar la organización y el mantenimiento.',
  'app.pages.interfaces.closeAllTabs': 'Cerrar todas las tabs',
  'app.pages.interfaces.noTabsOpened': 'No hay más tabs abiertas',
  'app.pages.interfaces.closeSelectedTab': 'Cerrar la tab seleccionada',
  'app.pages.interfaces.openTabActions': 'Abrir acciones de las tabs',
  'app.pages.interfaces.compareAllScenarios': 'Comparar escenarios en todos los componentes',
  'app.pages.interfaces.openDefaultInterface': 'Abrir interfaz por defecto',
  'app.pages.interfaces.closeAllButThis': 'Cerrar todas excepto la seleccionada',
  'app.pages.interfaces.importInterface': 'Importar interfaces o carpetas',
  'app.pages.interfaces.interfaceImportedSuccessfully': 'Importación completada con éxito',
  'app.pages.interfaces.exportInterfaceSuccess': 'Interfaz exportada con éxito',
  'app.pages.interfaces.exportInterfacesSuccess': 'Interfaces exportadas con éxito',
  'app.pages.interfaces.exportFolderSuccess': 'Carpeta exportada con éxito',
  'app.pages.interfaces.exportFoldersSuccess': 'Carpetas exportadas con éxito',
  'app.pages.interfaces.interfaceCopied': 'Interfaz copiada con éxito',
  'app.pages.interfaces.interfaceMoved': 'Interfaz movida con éxito',
  'app.pages.interfaces.deleteFolder': 'Eliminar carpeta',
  'app.pages.interfaces.deleteInterfaces': 'Eliminar interfaces',
  'app.pages.interfaces.folderCopied': 'Carpeta copiada con éxito',
  'app.pages.interfaces.folderMoved': 'Carpeta movida con éxito',
  'app.pages.interfaces.interfacePermissionChanged': 'Permisos de interfaz cambiados',
  'app.pages.interfaces.htmlPreview': 'Vista previa HTML',
  'app.pages.interfaces.attribute': 'Atributo',
  'app.pages.interfaces.attributeValue': 'Valor del atributo',
  'app.pages.interfaces.typeActionValue': 'Valor de tipo de acción',
  'app.pages.interfaces.typeActionValue.modifyTypeActionValue': 'Modificar valor de tipo de acción',
  'app.pages.interfaces.runAppNode': 'Ejecutar nodo de aplicación',
  'app.pages.interfaces.sendHtmlAttributeToNode': 'Enviar atributo HTML a nodo',
  'app.pages.interfaces.attributesFromNode': 'Atributos desde nodo',
  'app.pages.interfaces.childrenFromNode': 'Hijo desde nodo',
  'app.pages.interfaces.addNodeResultLikeChildren': 'Agregar resultado de nodo como elemento hijo',
  'app.pages.interfaces.getAttributesFromNode': 'Obtener atributos desde nodo',
  'app.pages.interfaces.selectNodeToReceiveHtmlAttribute':
    'Selecciona el nodo que recibirá el atributo HTML',
  'app.pages.interfaces.sourceAttribute': 'Atributo HTML',
  'app.pages.interfaces.functionParameter': 'Parámetro de función',
  'app.pages.interfaces.targetAttribute': 'Atributo de destino',
  'app.pages.interfaces.targetAttributeValue': 'Valor de atributo de destino',
  'app.pages.interfaces.toolbar.runNodeToPreviewResult':
    'Ejecutar nodo para previsualizar resultado',
  'app.pages.interfaces.toolbar.insertHereYourHtmlCode': 'Inserta aquí tu código HTML',
  'app.pages.interfaces.toolbar.previewAvailableAfterTypingCode':
    'La vista previa estará disponible luego de la entrada de código',
  'app.pages.interfaces.toolbar.runPreviewHtml': 'Ejecutar vista previa HTML',
  'app.pages.interfaces.htmlEditor.inlineChangedOtherPart':
    'El agente solo modificó la pestaña {part}.',
  'app.pages.interfaces.toolbar.inputValue.dataType': 'Tipo de dato',
  'app.pages.interfaces.toolbar.inputValue.rule': 'Regla',
  'app.pages.interfaces.toolbar.inputValue.rule.notRange': 'Fuera de rango',
  'app.pages.interfaces.toolbar.inputValue.rule.textLength': 'Longitud de texto',
  'app.pages.interfaces.toolbar.inputValue.rule.any': 'Cualquiera',
  'app.pages.interfaces.toolbar.inputValue.customErrorMessage': 'Mensaje de error personalizado',

  // Interface pivot
  'app.pages.interfaces.pivot.x': 'X',
  'app.pages.interfaces.pivot.y': 'Y',
  'app.pages.interfaces.pivot.z': 'Z',
  'app.pages.interfaces.pivot.facet_row': 'Fila de facetas',
  'app.pages.interfaces.pivot.facet_column': 'Columna de facetas',
  'app.pages.interfaces.pivot.text': 'Texto',
  'app.pages.interfaces.pivot.animation_frame': 'Cuadro de animación',
  'app.pages.interfaces.pivot.animation_group': 'Grupo de animación',
  'app.pages.interfaces.pivot.error_x': 'Error X',
  'app.pages.interfaces.pivot.error_x_minus': 'Error X menos',
  'app.pages.interfaces.pivot.error_y': 'Error Y',
  'app.pages.interfaces.pivot.error_y_minus': 'Error Y menos',
  'app.pages.interfaces.pivot.error_z': 'Error Z',
  'app.pages.interfaces.pivot.error_z_minus': 'Error Z menos',
  'app.pages.interfaces.pivot.latitude': 'Latitud',
  'app.pages.interfaces.pivot.longitude': 'Longitud',
  'app.pages.interfaces.pivot.r': 'R',
  'app.pages.interfaces.pivot.theta': 'Theta',
  'app.pages.interfaces.pivot.measure_1': 'Medida 1',
  'app.pages.interfaces.pivot.measure_2': 'Medida 2',
  'app.pages.interfaces.pivot.measure_3': 'Medida 3',
  'app.pages.interfaces.pivot.color': 'Color',
  'app.pages.interfaces.pivot.size': 'Tamaño',
  'app.pages.interfaces.pivot.base': 'Base',
  'app.pages.interfaces.pivot.symbol': 'Símbolo',
  'app.pages.interfaces.pivot.line_group': 'Grupo de línea',
  'app.pages.interfaces.pivot.line_dash': 'Guión de línea',
  'app.pages.interfaces.pivot.pattern_shape': 'Forma de patrón',
  'app.pages.interfaces.pivot.dimensions': 'Dimensiones',
  'app.pages.interfaces.pivot.locations': 'Ubicaciones',
  'app.pages.interfaces.pivot.names': 'Nombres',
  'app.pages.interfaces.pivot.values': 'Valores',
  'app.pages.interfaces.pivot.x_start': 'X inicial',
  'app.pages.interfaces.pivot.x_end': 'X final',
  'app.pages.interfaces.pivot.path': 'Camino',
  'app.pages.interfaces.pivot.parents': 'Padres',
  'app.pages.interfaces.pivot.ids': 'IDs',
  'app.pages.interfaces.pivot.chart_type_1': 'Tipo de gráfico 1',
  'app.pages.interfaces.pivot.chart_type_2': 'Tipo de gráfico 2',
  'app.pages.interfaces.pivot.dimension': 'Dimensión',
  'app.pages.interfaces.pivot.measure': 'Medida',
  'app.pages.interfaces.pivot.rows': 'Filas',
  'app.pages.interfaces.pivot.columns': 'Columnas',
  'app.pages.interfaces.pivot.measures': 'Medidas',
  'app.pages.interfaces.pivot.series': 'Series',
  'app.pages.interfaces.pivot.sum': 'Suma',
  'app.pages.interfaces.pivot.avg': 'Promedio',
  'app.pages.interfaces.pivot.min': 'Mínimo',
  'app.pages.interfaces.pivot.max': 'Máximo',
  'app.pages.interfaces.pivot.count': 'Cuenta',
  'app.pages.interfaces.pivot.': 'No',
  'app.pages.interfaces.pivot.agg': 'Agregación',
  'app.pages.interfaces.pivot.newMeasure': 'Nueva medida',
  'app.pages.interfaces.pivot.newMeasureName': 'Nombre de nueva medida',
  'app.pages.interfaces.pivot.selectHierarchy': 'Seleccionar jerarquía',
  'app.pages.interfaces.pivot.editCalculatedMeasure': 'Editar medida calculada',
  'app.pages.interfaces.pivot.removeCalculatedMeasure': 'Eliminar medida calculada',
  'app.pages.interfaces.pivot.removeCalculatedMeasureMessage':
    '¿Estás seguro de querer eliminar "{field}"?',
  'app.pages.interfaces.pivot.function': 'Función',
  'app.pages.interfaces.pivot.calculationMode': 'Modo de cálculo',
  'app.pages.interfaces.pivot.histnorm': 'Normalización de histograma',
  'app.pages.interfaces.pivot.box': 'Caja',
  'app.pages.interfaces.pivot.marginal': 'Marginal',
  'app.pages.interfaces.pivot.calculatedMeasure': 'Medida calculada',
  'app.pages.interfaces.pivot.calculatedItem': 'Elemento calculado',
  'app.pages.interfaces.pivot.editCalculatedItem': 'Editar elemento calculado',
  'app.pages.interfaces.pivot.removeCalculatedItem': 'Eliminar elemento calculado',
  'app.pages.interfaces.pivot.removeCalculatedItemMessage':
    '¿Estás seguro de querer eliminar "{item}"?',
  'app.pages.interfaces.pivot.itemAlreadyExists': 'El elemento ya existe',
  'app.pages.interfaces.pivot.addSubtotal': 'Agregar subtotal',
  'app.pages.interfaces.pivot.editSubtotal': 'Editar subtotal',
  'app.pages.interfaces.pivot.removeSubtotal': 'Eliminar subtotal',
  'app.pages.interfaces.pivot.addSubtotalFor': 'Agregar subtotal para',
  'app.pages.interfaces.pivot.editSubtotalFor': 'Editar subtotal para',
  'app.pages.interfaces.pivot.subtotalTypeHierarchical':
    'Jerárquico (basado en la jerarquía completa de filas)',
  'app.pages.interfaces.pivot.subtotalTypeByElement':
    'Por elemento (un subtotal por cada tramo de valores consecutivos iguales)',
  'app.pages.interfaces.pivot.includeSingleElementSegments': 'Incluir tramos de un solo elemento',
  'app.pages.interfaces.pivot.subtotalAggregationMethod': 'Método de agregación',
  'app.pages.interfaces.pivot.sortAscending': 'Ordenar de forma ascendente',
  'app.pages.interfaces.pivot.sortDescending': 'Ordenar de forma descendente',
  'app.pages.interfaces.pivot.removeSorting': 'Eliminar ordenamiento',
  'app.pages.interfaces.pivot.customSortValues': 'Ordenamiento personalizado de valores',
  'app.pages.interfaces.pivot.sortValuesFor': 'Ordenar valores para',
  'app.pages.interfaces.pivot.resetCustomSort': 'Restablecer ordenamiento personalizado',
  'app.pages.interfaces.pivot.itemHasCustomSort': 'El elemento tiene un ordenamiento personalizado',
  'app.pages.interfaces.pivot.sortByIndexNode': 'Ordenar por nodo índice',
  'app.pages.interfaces.pivot.selectIndexNode': 'Seleccionar un nodo índice',
  'app.pages.interfaces.pivot.noIndexNodesFounded': 'No se encontraron nodos índice',
  'app.pages.interfaces.pivot.multiSortTitle': 'Orden personalizado',
  'app.pages.interfaces.pivot.multiSortOrderBy': 'Ordenar por',
  'app.pages.interfaces.pivot.multiSortThenBy': 'Luego por',
  'app.pages.interfaces.pivot.multiSortAscending': 'Orden ascendente',
  'app.pages.interfaces.pivot.multiSortDescending': 'Orden descendente',
  'app.pages.interfaces.pivot.multiSortAddOrder': 'Agregar orden',

  //Code widget
  'app.pages.app.code.widget.code.saveAndRun': 'Guardar y Ejecutar Código',
  'app.pages.app.code.widget.code.formatCode': 'Formatear código',
  'app.pages.app.code.widget.code.viewCodeDifferences': 'Ver diferencias de código',
  'app.pages.app.code.widget.code.hideCodeDifferences': 'Ocultar diferencias de código',
  'app.pages.app.code.widget.code.askAi': 'Preguntar a la IA',

  //Result widget
  'app.pages.app.code.widget.result.defaultview.saved':
    'La vista por defecto del nodo se ha guardado correctamente.',
  'app.pages.app.code.widget.result.notCalculated': 'El nodo no está calculado',
  'app.pages.app.code.widget.result.loading': 'Cargando resultados..',
  'app.pages.app.code.widget.code.loading': 'Cargando código..',
  'app.pages.app.code.widget.result.changeToPreviewWidget': 'Cambiar a widget de vista previa',

  //Preview widget
  'app.pages.app.code.widget.preview.resultType': 'Tipo de resultado',
  'app.pages.app.code.widget.preview.indexes': 'Índices',
  'app.pages.app.code.widget.preview.preview': 'Vista previa',
  'app.pages.app.code.widget.preview.clickToOpenSparkUI': 'Haz clic aquí para abrir Spark UI',
  'app.pages.app.code.widget.preview.sparkui': 'Spark UI',
  'app.pages.app.code.widget.preview.changeToResultWidget': 'Cambiar a widget de resultado',
  'app.pages.app.code.widget.preview.getNodePreview': 'Obtener vista previa del nodo',
  'app.pages.app.code.widget.preview.loading': 'Cargando vista previa..',
  'app.pages.app.code.widget.preview.noPreview': 'No hay vista previa disponible',

  //Console widget
  'app.pages.app.code.widget.console.preserveLog': 'Preservar log',
  'app.pages.app.code.widget.console.clearLogs': 'Borrar logs',
  'app.pages.app.code.widget.console.closeConsole': 'Cerrar consola',
  'app.pages.app.code.widget.console.showConsole': 'Abrir consola',
  'app.pages.app.code.widget.console.clearErrors': 'Limpiar errores',
  'app.pages.app.code.widget.console.copyError': 'Copiar error',
  'app.pages.app.code.widget.console.errorCopied': 'Error copiado',
  'app.pages.app.code.widget.console.performanceAnalysis': 'Análisis de rendimiento',
  'app.pages.app.code.widget.console.performance': 'Rendimiento',
  'app.pages.app.code.widget.console.percentOfTime': '% del tiempo',
  'app.pages.app.code.widget.console.fromDynamic': 'Desde dynamic',
  'app.pages.app.code.widget.console.maxMemory': 'Máximo de memoria',
  'app.pages.app.code.widget.console.kind': 'Tipo',
  'app.pages.app.code.widget.console.title': 'Título',
  'app.pages.app.code.widget.console.identifier': 'Identificador',
  'app.pages.app.code.widget.console.kindNode': 'Nodo',
  'app.pages.app.code.widget.console.kindComponent': 'Componente',
  'app.pages.app.code.widget.console.kindInterface': 'Interfaz',
  'app.pages.app.code.widget.console.usedMemory': 'Memoria usada',
  'app.pages.app.code.widget.console.processingTime': 'Tiempo de procesamiento',
  'app.pages.app.code.widget.console.enableAnalysis': 'Habilitar análisis',
  'app.pages.app.code.widget.console.disableAnalysis': 'Deshabilitar análisis',
  'app.pages.app.code.widget.console.clearResults': 'Limpiar resultados',
  'app.pages.app.code.widget.console.logs': 'Logs',
  'app.pages.app.code.widget.console.resetAppResults': 'Reiniciar resultados de la aplicación',
  'app.pages.app.code.widget.console.exportPerformanceAnalysisCsv':
    'Exportar análisis de rendimiento como CSV',
  'app.pages.app.code.widget.console.exportPerformanceAnalysisExcel':
    'Exportar análisis de rendimiento como Excel',
  'app.pages.app.code.widget.console.performanceAnalysisDownloaded':
    'El análisis de rendimiento fue descargado',
  'app.pages.app.code.widget.console.performanceAnalysisDownloadError':
    'No se pudo generar el archivo del análisis de rendimiento',

  //Task manager
  'app.pages.app.taskManager.task': 'Administrador de tareas',
  'app.pages.app.taskManager.addTaskScheduled': 'Crear tarea programada',
  'app.pages.app.taskManager.editTaskScheduled': 'Editar tarea programada',
  'app.pages.app.taskManager.createdBy': 'Creado por',
  'app.pages.app.taskManager.executorUser': 'Usuario ejecutor',
  'app.pages.app.taskManager.lastRunAt': 'Última ejecución a las',
  'app.pages.app.taskManager.nextExecution': 'Siguiente ejecución',
  'app.pages.app.taskManager.lastStatus': 'Último estado',
  'app.pages.app.taskManager.saveNeedsEveryStep':
    'Completa los campos requeridos de todos los pasos antes de guardar',
  'app.pages.app.taskManager.updateMode': 'Modo',
  'app.pages.app.taskManager.updateModeInterval': 'Por intervalo',
  'app.pages.app.taskManager.updateModeLive': 'Live',
  'app.pages.app.taskManager.appPool': 'App pool',
  'app.pages.app.taskManager.schedulerType': 'Tipo de planificador',
  'app.pages.app.taskManager.params': 'Parámetros',
  'app.pages.app.taskManager.enabled': 'Activada',
  'app.pages.app.taskManager.showTaskLog': 'Mostrar log de la tarea',
  'app.pages.app.taskManager.addAppPool': 'Crear app pool',
  'app.pages.app.taskManager.interval': 'Intervalo',
  'app.pages.app.taskManager.clocked': 'Registrado',
  'app.pages.app.taskManager.taskDeleted': 'Tarea eliminada',
  'app.pages.app.taskManager.deleteTask': 'Eliminar tarea {name}',
  'app.pages.app.taskManager.deleteTaskMessage': '¿Estás seguro de eliminar la tarea?',
  'app.pages.app.taskManager.taskActivated': 'Tarea activada',
  'app.pages.app.taskManager.taskDeactivated': 'Tarea desactivada',
  'app.pages.app.taskManager.taskAddedToQueue': 'La tarea se agregó a la cola de ejecución',
  'app.pages.app.taskManager.editAppPool': 'Editar app pool',
  'app.pages.app.taskManager.taskLogs': 'Logs de la tarea',
  'app.pages.app.taskManager.createdAt': 'Creado el',
  'app.pages.app.taskManager.state': 'Estado',
  'app.pages.app.taskManager.lastTaskExecutions': 'Últimas ejecuciones de la tarea',
  'app.pages.app.taskManager.runTask': 'Ejecutar tarea',
  'app.pages.app.taskManager.runTaskConfirmTitle': 'Ejecutar tarea {name}',
  'app.pages.app.taskManager.runTaskConfirmMessage': '¿Estás seguro de ejecutar la tarea {name}?',
  'app.pages.app.taskManager.taskAlreadyRunning': 'La tarea ya se está ejecutando',
  'app.pages.app.taskManager.taskRunningSince':
    'La tarea ya se está ejecutando: fue ejecutada el {date} hs.',
  'app.pages.app.taskManager.removeTaskFromInProgressState':
    'Eliminar tarea del estado "en progreso"',
  'app.pages.app.taskManager.taskRemovedFromInProgressState':
    'Tarea eliminada del estado "en progreso"',
  'app.pages.app.taskManager.advancedFilters': 'Filtros avanzados',
  'app.pages.app.taskManager.taskLogsDetails': 'Detalles de los logs de la tarea',
  'app.pages.app.taskManager.refreshLogs': 'Refrescar logs',
  'app.pages.app.taskManager.taskDidNotRunYet': 'La tarea aún no ha sido ejecutada',
  'app.pages.app.taskManager.description': 'Descripción',
  'app.pages.app.taskManager.activity': 'Actividad',
  'app.pages.app.taskManager.info': 'Información',
  'app.pages.app.taskManager.periodicTaskLogNotFound': 'Logs de la tarea no encontrados',
  'app.pages.app.taskManager.success': 'Éxito',
  'app.pages.app.taskManager.failure': 'Fallido',
  'app.pages.app.taskManager.maxDateError': 'La fecha máxima no puede ser menor a la fecha mínima',
  'app.pages.app.taskManager.minDate': 'Fecha mínima',
  'app.pages.app.taskManager.maxDate': 'Fecha máxima',
  'app.pages.app.taskManager.timeZones': 'Zona horaria',
  'app.pages.app.taskManager.clearForm': 'Limpiar formulario',
  'app.pages.app.taskManager.insertTheTaskName': 'Ingresa el nombre de la tarea',
  'app.pages.app.taskManager.disabled': 'Desactivada',
  'app.pages.app.taskManager.days': 'Día',
  'app.pages.app.taskManager.hours': 'Hora',
  'app.pages.app.taskManager.minutes': 'Minuto',
  'app.pages.app.taskManager.seconds': 'Segundos',
  'app.pages.app.taskManager.microseconds': 'Microsegundos',
  'app.pages.app.taskManager.every': 'Cada',
  'app.pages.app.taskManager.period': 'Periodo',
  'app.pages.app.taskManager.everyPlaceholder': 'Por favor ingresa un valor entero',
  'app.pages.app.taskManager.appPath': 'Ruta de la aplicación',
  'app.pages.app.taskManager.generalOptions': 'Opciones generales',
  'app.pages.app.taskManager.scheduler': 'Planificador',
  'app.pages.app.taskManager.everyMinute': 'Cada minuto',
  'app.pages.app.taskManager.minutesPlaceholder': 'Selecciona los minutos',
  'app.pages.app.taskManager.everyHour': 'Cada hora',
  'app.pages.app.taskManager.hoursPlaceholder': 'Selecciona las horas',
  'app.pages.app.taskManager.dayMonths': 'Día del mes',
  'app.pages.app.taskManager.everyDayOfMonths': 'Cada día del mes',
  'app.pages.app.taskManager.everyMonths': 'Cada mes',
  'app.pages.app.taskManager.everyDays': 'Cada día',
  'app.pages.app.taskManager.dayMonthsPlaceholder': 'Selecciona los días del mes',
  'app.pages.app.taskManager.months': 'Mes',
  'app.pages.app.taskManager.monthsPlaceholder': 'Selecciona los meses',
  'app.pages.app.taskManager.daysPlaceholder': 'Selecciona los días',
  'app.pages.app.taskManager.january': 'Enero',
  'app.pages.app.taskManager.february': 'Febrero',
  'app.pages.app.taskManager.march': 'Marzo',
  'app.pages.app.taskManager.april': 'Abril',
  'app.pages.app.taskManager.may': 'Mayo',
  'app.pages.app.taskManager.june': 'Junio',
  'app.pages.app.taskManager.july': 'Julio',
  'app.pages.app.taskManager.august': 'Agosto',
  'app.pages.app.taskManager.september': 'Septiembre',
  'app.pages.app.taskManager.october': 'Octubre',
  'app.pages.app.taskManager.november': 'Noviembre',
  'app.pages.app.taskManager.december': 'Diciembre',
  'app.pages.app.taskManager.monday': 'Lunes',
  'app.pages.app.taskManager.tuesday': 'Martes',
  'app.pages.app.taskManager.wednesday': 'Miércoles',
  'app.pages.app.taskManager.thursday': 'Jueves',
  'app.pages.app.taskManager.friday': 'Viernes',
  'app.pages.app.taskManager.saturday': 'Sábado',
  'app.pages.app.taskManager.sunday': 'Domingo',
  'app.pages.app.taskManager.at': '{at}',
  'app.pages.app.taskManager.on': 'el ',
  'app.pages.app.taskManager.in': 'en ',
  'app.pages.app.taskManager.pastHour': 'Pasado las ',
  'app.pages.app.taskManager.andOn': 'y los ',
  'app.pages.app.taskManager.and': 'y',
  'app.pages.app.taskManager.reset': 'Resetear',
  'app.pages.app.taskManager.nameIsRequired': 'El nombre de la tarea es requerido',
  'app.pages.app.taskManager.nameMaxLength':
    'El tamaño máximo del nombre es de {number} caracteres',
  'app.pages.app.taskManager.schedulerTypeIsRequired': 'El tipo de calendario es requerido',
  'app.pages.app.taskManager.periodIsRequired': 'Periodo es requerido',
  'app.pages.app.taskManager.everyIsRequired': 'Intervalo de tiempo es requerido',
  'app.pages.app.taskManager.everyMustBeInt': 'El intervalo de tiempo debe ser un número entero',
  'app.pages.app.taskManager.everyMaxLength':
    'El intervalo de tiempo no puede ser mayor a {number}',
  'app.pages.app.taskManager.clockedIsRequired': 'Hora del reloj es requerida',
  'app.pages.app.taskManager.nodeOrInterfaceIsRequired':
    'Requerido: selecciona al menos un nodo o una interfaz. Puedes seleccionar ambos.',
  'app.pages.app.taskManager.appPathIsRequired': 'Ubicación de la aplicación es requerida',
  'app.pages.app.taskManager.type': 'Tipo',
  'app.pages.app.taskManager.label': 'Etiqueta',
  'app.pages.app.taskManager.defaultValue': 'Valor por defecto',
  'app.pages.app.taskManager.source': 'Fuente',
  'app.pages.app.taskManager.paramsTable': 'Tabla de parámetros',
  'app.pages.app.taskManager.noParamsData': 'No hay parámetros',
  'app.pages.app.taskManager.select': 'Selección',
  'app.pages.app.taskManager.input': 'Entrada',
  'app.pages.app.taskManager.checkbox': 'Caja de verificación',
  'app.pages.app.taskManager.paramNameIsRequired': 'El nombre del parámetro es requerido',
  'app.pages.app.taskManager.labelIsRequired': 'La etiqueta es requerida',
  'app.pages.app.taskManager.paramNameInvalid':
    'Debe contener letras en minúsculas y/o números. Espacios en blanco y guiones no están permitidos',
  'app.pages.app.taskManager.paramNamePlaceholder': 'Ingresa el nombre del parámetro',
  'app.pages.app.taskManager.labelPlaceholder': 'Ingresa la etiqueta',
  'app.pages.app.taskManager.defaultValuePlaceholder': 'Ingresa el valor por defecto',
  'app.pages.app.taskManager.sourcePlaceholder': 'Ingresa la fuente',
  'app.pages.app.taskManager.taskNameExists': 'El nombre de la tarea ya existe',
  'app.pages.app.taskManager.taskCreated': 'Tarea creada',
  'app.pages.app.taskManager.taskUpdated': 'Tarea actualizada',
  'app.pages.app.taskManager.keepForEveryone': 'Mantener para todos',
  'app.pages.app.taskManager.keepForDepartments': 'Mantener para los departamentos',
  'app.pages.app.taskManager.keepForUser': 'Mantener para el usuario',
  'app.pages.app.taskManager.actionOnDone': 'Acción al finalizar',
  'app.pages.app.taskManager.status.created': 'Creado',
  'app.pages.app.taskManager.taskFinishedTitle': 'Tarea programada finalizada',
  'app.pages.app.taskManager.taskFinishedMessage': '{name} finalizó con estado: {status}',
  'app.pages.app.taskManager.status.progress': 'En progreso',
  'app.pages.app.taskManager.status.info': 'Información',
  'app.pages.app.taskManager.status.warning': 'Advertencia',
  'app.pages.app.taskManager.status.failure': 'Fallido',
  'app.pages.app.taskManager.status.failed': 'Falló',
  'app.pages.app.taskManager.status.retry': 'Reintentar',
  'app.pages.app.taskManager.status.success': 'Éxito',
  'app.pages.app.taskManager.status.passed': 'Aprobado',
  'app.pages.app.taskManager.status.revoked': 'Revocado',
  'app.pages.app.taskManager.status.started': 'Iniciado',
  'app.pages.app.taskManager.status.pending': 'Pendiente',
  'app.pages.app.taskManager.status.received': 'Recibido',
  'app.pages.app.taskManager.instances': 'Instancias',
  'app.pages.app.taskManager.enableInstanceExpire': 'Habilitar expirar la instancia',
  'app.pages.app.taskManager.expireAt': 'Expira a las',
  'app.pages.app.taskManager.instanceExpiration': 'Expiración de instancias',
  'app.pages.app.taskManager.expirationModeNone': 'No expiran',
  'app.pages.app.taskManager.expirationModeTimeOfDay': 'A una hora del día',
  'app.pages.app.taskManager.expirationModeMaxAge': 'Por antigüedad',
  'app.pages.app.taskManager.expirationModeHelp': 'Cómo funciona cada modo de expiración',
  'app.pages.app.taskManager.expirationModeNoneHelp':
    'No expiran: las instancias se mantienen en el pool hasta que un usuario las reclama.',
  'app.pages.app.taskManager.expirationModeTimeOfDayHelp':
    'A una hora del día: todas las instancias se reciclan al llegar esa hora, todos los días.',
  'app.pages.app.taskManager.expirationModeMaxAgeHelp':
    'Por antigüedad: cada instancia se recicla al cumplir ese período, contado desde que entró al pool.',
  'app.pages.app.taskManager.periodMinutes': 'Minutos',
  'app.pages.app.taskManager.periodHours': 'Horas',
  'app.pages.app.taskManager.periodDays': 'Días',
  'app.pages.app.taskManager.expireAfter': 'Expira tras',
  'app.pages.app.taskManager.maxAgePositive': 'Ingresa un período mayor a cero',
  'app.pages.app.taskManager.maxAgeTooShort':
    'Las instancias no pueden expirar en menos de {minutes} minutos',
  'app.pages.app.taskManager.sectionPool': 'Pool',
  'app.pages.app.taskManager.sectionCapacity': 'Capacidad',
  'app.pages.app.taskManager.sectionExpiration': 'Expiración',
  'app.pages.app.taskManager.poolEnabled': 'Pool habilitado',
  'app.pages.app.taskManager.instancesHelp': 'Instancias que se mantienen listas',
  'app.pages.app.taskManager.keepForEveryoneHelp':
    'Cualquier usuario de la compañía puede reclamar una instancia',
  'app.pages.app.taskManager.keepForDepartmentsHelp':
    'Cualquier miembro de los departamentos elegidos puede reclamar una instancia',
  'app.pages.app.taskManager.keepForUserHelp': 'La instancia queda reservada para un solo usuario',
  'app.pages.app.taskManager.timezoneScopeBoth':
    'Aplica a la hora de expiración y a los períodos de actividad de abajo',
  'app.pages.app.taskManager.timezoneScopeExpiration': 'Aplica a la hora de expiración de abajo',
  'app.pages.app.taskManager.timezoneScopePeriods': 'Aplica a los períodos de actividad de abajo',
  'app.pages.app.taskManager.summaryTitle': 'Este pool va a',
  'app.pages.app.taskManager.summaryKeepForEveryone':
    'Mantener {instances} instancias listas para cualquier usuario de la compañía',
  'app.pages.app.taskManager.summaryKeepForDepartments':
    'Mantener {instances} instancias listas para los departamentos elegidos',
  'app.pages.app.taskManager.summaryKeepForUser':
    'Mantener una instancia lista para el usuario elegido, salvo que ya tenga abierta esta versión de la aplicación',
  'app.pages.app.taskManager.summaryKeepUpToForDepartments':
    'Mantener hasta {instances} instancias esperando a los departamentos elegidos',
  'app.pages.app.taskManager.summaryMaxOpenInstances':
    'Dejar de crear nuevas cuando haya {max} abiertas en total, hasta que alguien cierre una',
  'app.pages.app.taskManager.maxOpenInstancesEnabled': 'Limitar instancias abiertas',
  'app.pages.app.taskManager.maxOpenInstances': 'Máximo abiertas a la vez',
  'app.pages.app.taskManager.maxOpenInstancesHelp':
    'Cuenta las del pool y las que abren los miembros de los departamentos',
  'app.pages.app.taskManager.maxOpenInstancesPositive':
    'El máximo debe ser un número entero positivo',
  'app.pages.app.taskManager.maxOpenInstancesBelowInstances':
    'Ingresa al menos la cantidad de instancias listas',
  'app.pages.app.taskManager.summaryExpireMaxAge':
    'Reciclar cada instancia {age} después de que entra al pool',
  'app.pages.app.taskManager.summaryUnitMinutes':
    '{every, plural, one {# minuto} other {# minutos}}',
  'app.pages.app.taskManager.summaryUnitHours': '{every, plural, one {# hora} other {# horas}}',
  'app.pages.app.taskManager.summaryUnitDays': '{every, plural, one {# día} other {# días}}',
  'app.pages.app.taskManager.summaryExpireTimeOfDay':
    'Reciclar todas las instancias a las {time}, todos los días, {timezone}',
  'app.pages.app.taskManager.summaryExpireNever':
    'No reciclar instancias: quedan hasta que un usuario las reclama',
  'app.pages.app.taskManager.summaryActivePeriods': 'Funcionar sólo {periods}, {timezone}',
  'app.pages.app.taskManager.summaryPeriodShape': '{days}, de {from} a {to}',
  'app.pages.app.taskManager.summaryPeriodCount': '{count} períodos',
  'app.pages.app.taskManager.summaryTakenDownOutside': 'Bajar el pool fuera de esas horas',
  'app.pages.app.taskManager.summaryAlwaysOn': 'Funcionar todo el día, todos los días',
  'app.pages.app.taskManager.activePeriodsEnabled': 'Limitar a períodos de actividad',
  'app.pages.app.taskManager.activePeriodsHelp':
    'Fuera de estos períodos el pool se apaga y no se crean instancias nuevas',
  'app.pages.app.taskManager.timezone': 'Zona horaria',
  'app.pages.app.taskManager.activePeriodFrom': 'Desde',
  'app.pages.app.taskManager.activePeriodTo': 'Hasta',
  'app.pages.app.taskManager.activePeriodCrossesMidnight': 'Cruza medianoche',
  'app.pages.app.taskManager.addActivePeriod': 'Agregar período',
  'app.pages.app.taskManager.removeActivePeriod': 'Eliminar período',
  'app.pages.app.taskManager.activePeriodsRequired': 'Agrega al menos un período',
  'app.pages.app.taskManager.activePeriodDaysRequired': 'Elige al menos un día',
  'app.pages.app.taskManager.activePeriodSameBounds':
    'El inicio y el fin no pueden ser la misma hora',
  'app.pages.app.taskManager.selectModelFIle': 'Elegir el archivo del modelo',
  'app.pages.app.taskManager.node': 'Nodo',
  'app.pages.app.taskManager.noNodesFounded': 'No se han encontrado nodos',
  'app.pages.app.taskManager.clockedWithTz': 'Registrado UTC {tz}',
  'app.pages.app.taskManager.appPoolCreated': 'App pool creada',
  'app.pages.app.taskManager.appPoolUpdated': 'App pool actualizada',
  'app.pages.app.taskManager.actionIsRequired': 'Acción al finalizar es requerido',
  'app.pages.app.taskManager.instancesPositive':
    'El valor de las instancias debe ser un número positivo',
  'app.pages.app.taskManager.instancesIsRequired': 'Instancias son requeridas',
  'app.pages.app.taskManager.departmentsAreRequired': 'Selecciona al menos un departamento',
  'app.pages.app.taskManager.userIsRequired': 'El usuario es requerido',
  'app.pages.app.taskManager.users': 'Usuarios',
  'app.pages.app.taskManager.usersPlaceholder': 'Elegir un usuario',
  'app.pages.app.taskManager.timezoneIsRequired': 'La zona horaria es requerida',
  'app.pages.app.taskManager.noTasksFound': 'Tareas no encontradas',
  'app.pages.app.taskManager.taskUser': 'Usuario de la tarea',
  'app.pages.app.taskManager.systemTask': 'Sistema',
  'app.pages.app.taskManager.noPermissionsToListTasks':
    'No tienes permisos para listar las tareas programadas',
  'app.pages.app.taskManager.resources': 'Recursos',
  'app.pages.app.taskManager.instanceTimeoutInSeconds':
    'Tiempo de espera de la instancia en segundos',
  'app.pages.app.taskManager.minTimeRequiredMessage':
    'El tiempo mínimo requerido es de 120 segundos',
  'app.pages.app.taskManager.useDepartment': 'Recursos del departamento',
  'app.pages.app.taskManager.taskId': 'Id de la tarea',
  'app.pages.app.taskManager.scheduleParams': 'Parámetros de la planificación',
  'app.pages.app.taskManager.taskParams': 'Parámetros de la tarea',
  'app.pages.app.taskManager.notificationUsers': 'Usuarios a notificar',
  'app.pages.app.taskManager.scheduleId': 'Id de planificación',
  'app.pages.app.taskManager.currentAppOnly': 'Sólo de esta aplicación',
  'app.pages.app.taskManager.showSearch': 'Mostrar buscador',
  'app.pages.app.taskManager.hideDisabledTasks': 'Ocultar tareas desactivadas',
  'app.pages.app.taskManager.automaticUpdate': 'Actualización automática',
  'app.pages.app.taskManager.automaticallyUpdate': 'Actualizar automáticamente',
  'app.pages.app.taskManager.automaticUpdateEverySeconds': 'Cada (segundos)',
  'app.pages.app.taskManager.showSystemTasks': 'Ver tareas del sistema',
  'app.pages.app.taskManager.viewResources': 'Ver recursos',
  'app.pages.app.taskManager.manual': 'Manual',
  'app.pages.app.taskManager.emailNotificationMode': 'Modo de notificación por email',
  'app.pages.app.taskManager.emailNotificationAlways': 'Enviar emails siempre',
  'app.pages.app.taskManager.emailNotificationOnFailure': 'Enviar emails solo en caso de falla',
  'app.pages.app.taskManager.emailNotificationOnSuccess': 'Enviar emails solo en caso de éxito',

  //Running node
  'app.pages.app.runningNodeModel.runningNode': 'Evaluando nodo',
  'app.pages.app.runningNodeModel.stopping': 'Deteniendo',
  'app.pages.app.runningNodeModel.stuckTitle':
    'La aplicación no respondió a la solicitud de detención.',
  'app.pages.app.runningNodeModel.stuckMessage': 'Elegir una acción o seguir esperando:',
  'app.pages.app.runningNodeModel.stuckOption1': 'Guardar cambios y forzar detención (recomendado)',
  'app.pages.app.runningNodeModel.stuckOption2':
    'Forzar detención (los cambios no guardados pueden perderse)',
  'app.pages.app.runningNodeModel.forceStop': 'Forzar detención',
  'app.pages.app.runningNodeModel.saveAndForceStop': 'Guardar cambios y forzar detención',
  'app.pages.app.runningNodeModel.phaseKilling': 'Cerrando instancia...',
  'app.pages.app.runningNodeModel.phaseCreating': 'Creando nueva instancia...',
  'app.pages.app.runningNodeModel.phaseOpening': 'Abriendo aplicación...',

  //Assets recovery
  'app.pages.app.assetsRecovery.brokenTitle': 'La aplicación no pudo reabrirse correctamente',
  'app.pages.app.assetsRecovery.brokenMessage':
    'Se detectó un problema al reabrir la aplicación. Es posible que falten el menú, las interfaces o las reglas de negocio.',
  'app.pages.app.assetsRecovery.brokenInstructions':
    'Puedes intentar recuperarla desde la última copia de seguridad, o ir al FileManager: busca una carpeta llamada "assets_old#..." junto a la carpeta de la versión de la app y renómbrala a "assets" para restaurar manualmente la última copia de seguridad. Si no estás seguro de cómo hacerlo, contacta a un responsable antes de hacer más cambios.',
  'app.pages.app.assetsRecovery.recoverFromBackupButton': 'Recuperar desde backup',
  'app.pages.app.assetsRecovery.goToFileManagerButton': 'Ir al FileManager',

  //Saving app
  'app.pages.savingApp.savingApp': 'Guardando aplicación',

  //Interface Manager
  'app.pages.interfaceManager': 'Administrador de interfaces',
  'app.pages.interfaceManager.newInterface': 'Nueva interfaz',
  'app.pages.interfaceManager.createNewInterface': 'Crear nueva interfaz',
  'app.pages.interfaceManager.editInterface': 'Editar interfaz',
  'app.pages.interfaceManager.createNewFolder': 'Crear nueva carpeta',
  'app.pages.interfaceManager.name': 'Nombre de la interfaz',
  'app.pages.interfaceManager.interfaceType': 'Tipo de interfaz',
  'app.pages.interfaceManager.interfaceType.dragDrop': 'Interfaz de componentes',
  'app.pages.interfaceManager.interfaceType.dragDropHint':
    'Dashboard drag-and-drop con componentes de Pyplan (tablas, gráficos, selectores, formularios).',
  'app.pages.interfaceManager.interfaceType.html': 'Interfaz HTML',
  'app.pages.interfaceManager.interfaceType.htmlHint':
    'HTML/JS personalizado de página completa renderizado en un iframe sandboxed, con callbacks Python.',
  'app.pages.interfaceManager.emptyHtml.title': '¿Qué quieres construir?',
  'app.pages.interfaceManager.emptyHtml.subtitle':
    'Describe el dashboard o la UI que tienes en mente. El agente Developer va a generar el HTML y el código Python para esta interfaz.',
  'app.pages.interfaceManager.emptyHtml.placeholder':
    'ej. "Una tabla de ventas por región con un gráfico de barras al costado"',
  'app.pages.interfaceManager.emptyHtml.send': 'Enviar al Developer',
  'app.pages.interfaceManager.folderName': 'Nombre de la carpeta',
  'app.pages.interfaceManager.deleteInterface': 'Eliminar interfaces',
  'app.pages.interfaceManager.deleteFolder': 'Eliminar carpeta',
  'app.pages.interfaceManager.deleteInterfaceConfirmationText':
    '¿Estás seguro de eliminar definitivamente esta interfaz?',
  'app.pages.interfaceManager.deleteFolderConfirmationText':
    '¿Estás seguro de eliminar definitivamente esta carpeta y todo su contenido?',
  'app.pages.interfaceManager.myInterfaces': 'Mis interfaces',
  'app.pages.interfaceManager.noInterfaces':
    'No hay interfaces disponibles. Crea una usando el botón Crear',
  'app.pages.interfaceManager.deniedFor': 'Denegado para',
  'app.pages.interfaceManager.allowedFor': 'Permitido para',
  'app.pages.interfaceManager.deniedForDetail': 'Denegar acceso a',
  'app.pages.interfaceManager.slashNotAllowed':
    'Carácter inválido. "/" no está permitido en el nombre de la interfaz',
  'app.pages.interfaceManager.interfaceNameRepeated': 'El nombre de la interfaz ya existe',
  'app.pages.interfaceManager.removeDocumentation': 'Eliminar documentación',
  'app.pages.interfaceManager.removeDocumentationConfirm':
    '¿Estás seguro de eliminar la documentación?',
  'app.pages.interfaceManager.shareInterface': 'Compartir interfaz',
  'app.pages.interfaceManager.interfaceLinkCopied': 'Enlace de interfaz copiado',
  'app.pages.interfaceManager.copyInterfaceLink': 'Copiar enlace de interfaz',
  'app.pages.interfaceManager.interfaceLink': 'Enlace de interfaz',
  'app.pages.interfaceManager.interfacesLinks': 'Links de interfaces',
  'app.pages.interfaceManager.interfacesLinks.notFound': 'No se encontraron links de interfaces',
  'app.pages.interfaceManager.activateInterfaceEndpoint': 'Activar interface endpoint',
  'app.pages.interfaceManager.updateInterfaceLink': 'Actualizar enlace de interfaz',
  'app.pages.interfaceManager.interfaceLinkUpdated': 'Enlace de interfaz actualizado con éxito',
  'app.pages.interfaceManager.deleteInterfaceLink': 'Eliminar enlace de interfaz: {interfaceName}',
  'app.pages.interfaceManager.deleteInterfaceLinkConfirmation':
    '¿Estás seguro de eliminar el enlace de la interfaz?',
  'app.pages.interfaceManager.interfaceLinkDeleted': 'Enlace de interfaz eliminado con éxito',
  'app.pages.interfaceManager.folderNameExists': 'El nombre de la carpeta ya existe',
  'app.pages.externalLink.customEndpointExists': 'El endpoint personalizado ya existe',
  'app.pages.externalLink.passwordRequiredDescription':
    'Por favor ingresa la contraseña para continuar',
  'app.pages.externalLink.hasPassword': 'Tiene contraseña',
  'app.pages.externalLink.requirePassword': 'Requiere contraseña',
  'app.pages.interfaceManager.basicInformation': 'Información básica',

  //File manager
  'app.pages.FileManagerPage.download': 'Descargar',
  'app.pages.FileManagerPage.zipIt': 'Comprimir',
  'app.pages.FileManagerPage.copyIn': 'Copiar',
  'app.pages.FileManagerPage.archive': 'Archivo',
  'app.pages.FileManagerPage.denyAccess': 'Denegar accesos',
  'app.pages.FileManagerPage.folder': 'Carpeta',
  'app.pages.FileManagerPage.selectAll': 'Seleccionar todos',
  'app.pages.FileManagerPage.unSelectAll': 'Deseleccionar todos',
  'app.pages.FileManagerPage.models': 'Modelos (.ppl)',
  'app.pages.FileManagerPage.csv': 'CSV {extension}',
  'app.pages.FileManagerPage.templates': 'Plantillas(.xls,.xlsx,.xlsm)',
  'app.pages.FileManagerPage.database': 'Base de datos {extension}',
  'app.pages.FileManagerPage.modules': 'Módulos (.ppm)',
  'app.pages.FileManagerPage.interfaces': 'Interfaces',
  'app.pages.FileManagerPage.zipFiles': 'Archivo zip {extension}',
  'app.pages.FileManagerPage.jsonFiles': 'Archivo Json {extension}',
  'app.pages.FileManagerPage.backup': 'Recuperar (.old)',
  'app.pages.FileManagerPage.others': 'Otros',
  'app.pages.FileManagerPage.showHidden': 'Mostrar archivos/carpetas ocultas',
  'app.pages.FileManagerPage.filterBy': 'Filtrar por',
  'app.pages.FileManagerPage.model': 'Modelo',
  'app.pages.FileManagerPage.file': 'Archivo',
  'app.pages.FileManagerPage.type': 'Tipo',
  'app.pages.FileManagerPage.location': 'Ubicación',
  'app.pages.FileManagerPage.opened': 'Abierto',
  'app.pages.FileManagerPage.size': 'Tamaño',
  'app.pages.FileManagerPage.getSize': 'Obtener tamaño',
  'app.pages.FileManagerPage.date': 'Fecha',
  'app.pages.FileManagerPage.access': 'Accesos',
  'app.pages.FileManagerPage.fileName': 'Nombre del archivo',
  'app.pages.FileManagerPage.folders': 'Carpetas',
  'app.pages.FileManagerPage.files': 'Archivos',
  'app.pages.FileManagerPage.root': 'Inicio',
  'app.pages.FileManagerPage.listView': 'Vista lista',
  'app.pages.FileManagerPage.mosaicView': 'Vista mosaico',
  'app.pages.FileManagerPage.folderEmpty': 'La carpeta está vacía',
  'app.pages.FileManagerPage.denyAccessTo': 'Denegar acceso',
  'app.pages.FileManagerPage.allowAccessTo': 'Permitir acceso',
  'app.pages.FileManagerPage.allowAccessOnlyTo': 'Permitir acceso sólo a',
  'app.pages.FileManagerPage.folderExceptions': 'Excepciones',
  'app.pages.FileManagerPage.folderExceptionsHint':
    'La restricción aplica a todas las carpetas llamadas "{folder}", salvo las rutas listadas abajo.',
  'app.pages.FileManagerPage.folderExceptionsHintAllowOnly':
    'Los departamentos elegidos pueden ver todas las carpetas llamadas {folder}, salvo las rutas listadas abajo, que quedan bloqueadas para todos.',
  'app.pages.FileManagerPage.noFolderExceptions':
    'Sin excepciones: la restricción aplica en todos lados.',
  'app.pages.FileManagerPage.folderExceptionMissing':
    'Esta carpeta ya no existe, así que la excepción no aplica y la carpeta vuelve a estar restringida. Elimínala o agrega la ruta nueva.',
  'app.pages.FileManagerPage.addFolderException': 'Agregar excepción para "{folder}"',
  'app.pages.FileManagerPage.pickFolderExceptionHint':
    'Elige la carpeta que quieres dejar accesible. Solo se pueden seleccionar carpetas llamadas "{folder}".',
  'app.pages.FileManagerPage.exceptionMustMatchFolderName':
    'Esa carpeta no se llama "{folder}", así que la excepción nunca aplicaría. Elige una carpeta con ese nombre exacto.',
  'app.pages.FileManagerPage.exceptionAlreadyAdded': 'Esa ruta ya está en la lista.',
  'app.pages.FileManagerPage.addException': 'Agregar excepción',
  'app.pages.FileManagerPage.selectedFolderException': 'Carpeta seleccionada:',
  'app.pages.FileManagerPage.noFolderSelected': 'ninguna todavía',
  'app.pages.FileManagerPage.deletedMessage': '{name} eliminado',
  'app.pages.FileManagerPage.wantToDeleteFolder': '¿Estás seguro de eliminar la carpeta?',
  'app.pages.FileManagerPage.wantToDeleteFile': '¿Estás seguro de eliminar el archivo?',
  'app.pages.FileManagerPage.deletedTitle': 'Eliminar {name}',
  'app.pages.FileManagerPage.deleteFileTitle': 'Eliminar archivo',
  'app.pages.FileManagerPage.deleteFilesTitle': 'Eliminar archivos',
  'app.pages.FileManagerPage.deleteFolderTitle': 'Eliminar carpeta',
  'app.pages.FileManagerPage.deleteFoldersTitle': 'Eliminar carpetas',
  'app.pages.FileManagerPage.deleteFilesAndFoldersTitle': 'Eliminar archivos/carpetas',
  'app.pages.FileManagerPage.wantToZipFile': '¿Estás seguro de comprimir este archivo?',
  'app.pages.FileManagerPage.zipFile': 'Comprimir {name}',
  'app.pages.FileManagerPage.unZipFile': 'Descomprimir {name}',
  'app.pages.FileManagerPage.fileZipped': '{name} comprimido',
  'app.pages.FileManagerPage.fileUnZipped': '{name} descomprimido',
  'app.pages.FileManagerPage.nodeChanged': 'Nombre cambiado a {name}',
  'app.pages.FileManagerPage.wantToUnZipFile':
    '¿Estás seguro de que quieres descomprimir este archivo?',
  'app.pages.FileManagerPage.unzip': 'Descomprimir',
  'app.pages.FileManagerPage.move': 'Mover',
  'app.pages.FileManagerPage.fileCloned': '{name} duplicado',
  'app.pages.FileManagerPage.createFolderTitle': 'Establecer nombre de carpeta',
  'app.pages.FileManagerPage.folderCreated': 'Carpeta creada',
  'app.pages.FileManagerPage.createFileTitle': 'Establecer nombre de archivo',
  'app.pages.FileManagerPage.fileCreated': 'Archivo creado',
  'app.pages.FileManagerPage.creatingFile': 'Creando archivo',
  'app.pages.FileManagerPage.folderName': 'Nombre de carpeta',
  'app.pages.FileManagerPage.deletedFilesMessage': 'Archivos o carpetas borradas',
  'app.pages.FileManagerPage.copyFileIn': 'Copiar {name} en',
  'app.pages.FileManagerPage.upload': 'Subir',
  'app.pages.FileManagerPage.wantToDelete': '¿Estás seguro de que deseas eliminar lo siguiente?',
  'app.pages.FileManagerPage.duplicatedFiles': 'Archivos duplicados',
  'app.pages.FileManagerPage.zipTitle': 'Comprimir archivos',
  'app.pages.FileManagerPage.wantToZipFileS':
    '¿Estás seguro de comprimir los archivos seleccionados?',
  'app.pages.FileManagerPage.departmentsRestrictions': 'Departamento/s restringidos',
  'app.pages.FileManagerPage.folderNameError':
    'El nombre de la carpeta es requerido y no puede estar vacío.',
  'app.pages.FileManagerPage.folderNameErrorSlash': 'El nombre de la carpeta no puede tener barra',
  'app.pages.FileManagerPage.newNameIsRequired': 'El nombre es requerido y no puede estar vacío.',
  'app.pages.FileManagerPage.filesUploaded': 'Archivos subidos',
  'app.pages.FileManagerPage.filesZipped': 'Archivos comprimidos',
  'app.pages.FileManagerPage.zippingFiles': 'Comprimiendo archivos',
  'app.pages.FileManagerPage.filesToCopy': 'Archivos para copiar',
  'app.pages.FileManagerPage.pasteHere': 'Pegar aquí',
  'app.pages.FileManagerPage.pleaseSelectAFile':
    'Selecciona una carpeta o archivo para ver sus detalles aquí.',
  'app.pages.FileManagerPage.filesCopied': 'Archivos copiados',
  'app.pages.FileManagerPage.filesMoved': 'Archivos movidos',
  'app.pages.FileManagerPage.filesDownloaded': 'Archivos descargados',
  'app.pages.FileManagerPage.downloaded': '¡Descargado!',
  'app.pages.FileManagerPage.errorDownloading': 'Hubo un error al descargar el archivo',
  'app.pages.FileManagerPage.copyCompletedSuccessfully': 'Copia completada exitosamente',
  'app.pages.FileManagerPage.moveCompletedSuccessfully': 'Movimiento completado exitosamente',
  'app.pages.FileManagerPage.fileOperationCompletedSuccessfully':
    'Operación de archivos completada exitosamente',
  'app.pages.FileManagerPage.fileOperationFailed': 'La operación de archivos falló',
  'app.pages.FileManagerPage.fileOperationError':
    'Ocurrió un error durante la operación de archivos',
  'app.pages.FileManagerPage.fileOperationInactivityTimeout':
    'La operación sigue en progreso, pero no se recibieron actualizaciones durante demasiado tiempo.',
  'app.pages.FileManagerPage.copySourceChanged':
    'No se pudo completar la copia porque la aplicación se estaba guardando mientras se copiaba. Inténtalo nuevamente en unos minutos.',
  'app.pages.FileManagerPage.fileOperationStatusUnreachable':
    'No se pudo consultar temporalmente el estado de la operación. Espera un momento e inténtalo nuevamente.',
  'app.pages.FileManagerPage.uploading': 'Subiendo...',
  'app.pages.FileManagerPage.uploaded': '¡Archivos cargados exitosamente!',
  'app.pages.FileManagerPage.compressing': 'Comprimiendo...',
  'app.pages.FileManagerPage.unzipping': 'Descomprimiendo...',
  'app.pages.FileManagerPage.duplicating': 'Duplicando...',
  'app.pages.FileManagerPage.loadingLastPath': 'Cargando última ruta..',
  'app.pages.FileManagerPage.uploadCancelled': 'Subida cancelada por el usuario',
  'app.pages.FileManagerPage.deleting': 'Eliminando',
  'app.pages.FileManagerPage.creating': 'Creando la carpeta',
  'app.pages.FileManagerPage.pastingFiles': 'Pegando archivos',
  'app.pages.FileManagerPage.configuringAccess': 'Configurando acceso',
  'app.pages.FileManagerPage.downloading': 'Descargando...',
  'app.pages.FileManagerPage.downloadReady': 'Descarga lista',
  'app.pages.FileManagerPage.duplicateTitle': 'Duplicar {name}',
  'app.pages.FileManagerPage.wantToDuplicate':
    '¿Estás seguro de duplicar los archivos seleccionados?',
  'app.pages.FileManagerPage.dragDropFilesHere': 'Arrastra y suelta los archivos aquí o',
  'app.pages.FileManagerPage.overWriteFileOrFolder': 'Sobrescribir archivo o carpeta',
  'app.pages.FileManagerPage.overWriteFileOrFolderMessage':
    '¿Estás seguro de querer sobrescribir {name}?',
  'app.pages.FileManagerPage.clearClipboard': 'Vaciar portapapeles',
  'app.pages.FileManagerPage.clipboardCleared': 'Portapapeles vacío',
  'app.pages.FileManagerPage.copyToWorkspaceTitle': 'Copiar en espacio de trabajo',
  'app.pages.FileManagerPage.copyToWorkspaceMessage':
    '¿Estás seguro de querer copiar {name} a tu espacio de trabajo?',
  'app.pages.FileManagerPage.copyingToWorkspace': 'Copiando en espacio de trabajo',
  'app.pages.FileManagerPage.copiedToWorkspace': 'Copiado en espacio de trabajo',
  'app.pages.FileManagerPage.openTextEditor': 'Abrir editor de texto',
  'app.pages.FileManagerPage.loadingFile': 'Cargando archivo',
  'app.pages.FileManagerPage.savingFile': 'Guardando archivo',
  'app.pages.FileManagerPage.fileSaved': 'Archivo guardado',
  'app.pages.FileManagerPage.fileTooLargeToRead':
    'El archivo es demasiado grande para leer. Tamaño máximo: 1MB',
  'app.pages.FileManagerPage.copyUrl': 'Copiar url',
  'app.pages.FileManagerPage.copyPath': 'Copiar ruta',
  'app.pages.FileManagerPage.goToContainingFolder': 'Ir a la carpeta contenedora',
  'app.pages.FileManagerPage.urlCopied': 'URL copiada',
  'app.pages.FileManagerPage.errorUploading': 'Ocurrió un error subiendo el archivo',
  'app.pages.FileManagerPage.errorUploadingFiles': 'No se pudieron subir los siguientes archivos:',
  'app.pages.FileManagerPage.pathCopied': 'Ruta copiada',
  'app.pages.FileManagerPage.copyingFiles': 'Copiando archivos',
  'app.pages.FileManagerPage.movingFiles': 'Moviendo archivos',
  'app.pages.FileManagerPage.preparingDownload': 'Preparando descarga',
  'app.pages.FileManagerPage.processingFiles': 'Procesando archivos',

  //Actions (for logManager filter)
  'app.pages.managers.logManager.actions.openApp': 'Abrir aplicación',
  'app.pages.managers.logManager.actions.navigateDiagram': 'Navegar diagrama',
  'app.pages.managers.logManager.actions.getArrows': 'Obtener flechas',
  'app.pages.managers.logManager.actions.getToolbars': 'Obtener toolbars',
  'app.pages.managers.logManager.actions.lastOpenApps': 'Últimas aplicaciones abiertas',
  'app.pages.managers.logManager.actions.changeToOtherInstance': 'Cambiar a otra instancia',
  'app.pages.managers.logManager.actions.getNodeProperties': 'Obtener propiedades del nodo',
  'app.pages.managers.logManager.actions.setNodeProperties': 'Establecer propiedades del nodo',
  'app.pages.managers.logManager.actions.setNodesProperties': 'Establecer propiedades de los nodos',
  'app.pages.managers.logManager.actions.getNodeInputs': 'Obtener inputs del nodo',
  'app.pages.managers.logManager.actions.getNodeOutputs': 'Obtener outputs del nodo',
  'app.pages.managers.logManager.actions.searchNodes': 'Buscar nodos',
  'app.pages.managers.logManager.actions.searchForAutocomplete': 'Buscar autocompletar',
  'app.pages.managers.logManager.actions.previewNode': 'Previsualizar nodo',
  'app.pages.managers.logManager.actions.getSelector': 'Obtener selector',
  'app.pages.managers.logManager.actions.setNodesSize': 'Establecer tamaño del nodo',
  'app.pages.managers.logManager.actions.setNodesPosition': 'Establecer posición del nodo',
  'app.pages.managers.logManager.actions.getNodeProfile': 'Obtener perfil del nodo',
  'app.pages.managers.logManager.actions.createNode': 'Crear nodo',
  'app.pages.managers.logManager.actions.deleteNodes': 'Borrar Nodos',
  'app.pages.managers.logManager.actions.createAlias': 'Crear alias',
  'app.pages.managers.logManager.actions.createInputNode': 'Crear nodo input',
  'app.pages.managers.logManager.actions.copyNodes': 'Copiar nodos',
  'app.pages.managers.logManager.actions.copyAsValues': 'Copiar como valores',
  'app.pages.managers.logManager.actions.moveNodes': 'Mover nodos',
  'app.pages.managers.logManager.actions.stop': 'Detener',
  'app.pages.managers.logManager.actions.setNodeZ': 'Establecer Z del nodo',
  'app.pages.managers.logManager.actions.setNodeIdFromTitle':
    'Establecer identificador del nodo desde título',
  'app.pages.managers.logManager.actions.executeForRefresh': 'Ejecutar para actualizar',
  'app.pages.managers.logManager.actions.exportFlatNode': 'Exportar nodo plano',
  'app.pages.managers.logManager.actions.exportCurrentNode': 'Exportar nodo actual',
  'app.pages.managers.logManager.actions.exportModuleToFile': 'Exportar módulo a archivo',
  'app.pages.managers.logManager.actions.importModuleFromFile': 'Importar módulo desde archivo',
  'app.pages.managers.logManager.actions.getFilesForImportWizard':
    'Obtener archivos desde el asistente de importación',
  'app.pages.managers.logManager.actions.callWizard': 'Llamar al asistente',
  'app.pages.managers.logManager.actions.executeButton': 'Ejecutar botón',
  'app.pages.managers.logManager.actions.isInBackground': 'Está en el fondo',
  'app.pages.managers.logManager.actions.uploadFileToTemp': 'Subir modelo a Temp',
  'app.pages.managers.logManager.actions.installLibrary': 'Instalar librerías',
  'app.pages.managers.logManager.actions.listInstalledLibraries': 'Listar librerías instaladas',
  'app.pages.managers.logManager.actions.uninstallLibrary': 'Desinstalar librerías',
  'app.pages.managers.logManager.actions.getInstallProgress': 'Obtener progreso de instalación',
  'app.pages.managers.logManager.actions.getMainFolders': 'Obtener carpetas principales',
  'app.pages.managers.logManager.actions.getFiles': 'Obtener archivos',
  'app.pages.managers.logManager.actions.createFolder': 'Crear carpeta',
  'app.pages.managers.logManager.actions.copyFileOrFolder': 'Copiar archivo o carpeta',
  'app.pages.managers.logManager.actions.renameFile': 'Renombrar archivo',
  'app.pages.managers.logManager.actions.duplicateFiles': 'Duplicar archivos',
  'app.pages.managers.logManager.actions.moveFiles': 'Mover archivos',
  'app.pages.managers.logManager.actions.copyFiles': 'Copiar archivos',
  'app.pages.managers.logManager.actions.deleteFiles': 'Borrar archivos',
  'app.pages.managers.logManager.actions.upload': 'Subir',
  'app.pages.managers.logManager.actions.unzipFile': 'Descomprimir archivos',
  'app.pages.managers.logManager.actions.zipFiles': 'Comprimir archivos',
  'app.pages.managers.logManager.actions.getHome': 'Obtener el inicio',
  'app.pages.managers.logManager.actions.optimizeTemplates': 'Optimizar plantillas',
  'app.pages.managers.logManager.actions.myReports': 'Mis reportes',
  'app.pages.managers.logManager.actions.sharedWithMe': 'Reportes compartidos conmigo',
  'app.pages.managers.logManager.actions.mySharedReports': 'Mis reportes compartidos',
  'app.pages.managers.logManager.actions.reportManager': 'Endpoint de reportes',
  'app.pages.managers.logManager.actions.getNavigator': 'Reportes - Obtener navegador',
  'app.pages.managers.logManager.actions.bulkDelete': 'Reportes - Eliminación masiva',
  'app.pages.managers.logManager.actions.changeOrder': 'Reportes - Cambiar orden',
  'app.pages.managers.logManager.actions.search': 'Reportes - Buscar',
  'app.pages.managers.logManager.actions.duplicateItems': 'Reportes - Duplicar items',
  'app.pages.managers.logManager.actions.copyToMyReports': 'Reportes - Copiar a mis reportes',
  'app.pages.managers.logManager.actions.setAsFav': 'Reportes - Establecer como favorito',
  'app.pages.managers.logManager.actions.dropOnReport': 'Reportes - Soltar en el reporte',
  'app.pages.managers.logManager.actions.exportItems': 'Reportes - Exportar items',
  'app.pages.managers.logManager.actions.importItems': 'Reportes - Importar items',
  'app.pages.managers.logManager.actions.publishItems': 'Reportes - Publicar items',
  'app.pages.managers.logManager.actions.shares': 'Obtener shares', //que es get shares
  'app.pages.managers.logManager.actions.setShares': 'Establecer shares', //que es set shares
  'app.pages.managers.logManager.actions.myDashboards': 'Mis tableros', //Uso "dashboards" o "tableros"
  'app.pages.managers.logManager.actions.companyDashboards': 'Tableros - Tableros de la compañía',
  'app.pages.managers.logManager.actions.dashboardsSharedWithMe': 'Tableros - Compartidos conmigo',
  'app.pages.managers.logManager.actions.allMyDashboards': 'Tableros - Todos mis tableros',
  'app.pages.managers.logManager.actions.mySharedDashboards': 'Tableros - Mis tableros compartidos',
  'app.pages.managers.logManager.actions.dashboardById': 'Tableros - Por identificación',
  'app.pages.managers.logManager.actions.getNodeFullData':
    'Tableros - Obtener todos los datos del nodo',
  'app.pages.managers.logManager.actions.evaluateNode': 'Tableros - Evaluar nodo',
  'app.pages.managers.logManager.actions.getOrCreate': 'Tableros - Obtener o crear',
  'app.pages.managers.logManager.actions.dashboardManager': 'Endpoints de tableros',
  'app.pages.managers.logManager.actions.dashboardBulkDelete': 'Tableros - Eliminación masiva',
  'app.pages.managers.logManager.actions.dashboardChangeOrder': 'Tableros - Cambiar orden',
  'app.pages.managers.logManager.actions.getIndexValues': 'Tableros - Obtener valores índices',
  'app.pages.managers.logManager.actions.getNodeIndexes': 'Tableros - Obtener índices de nodos',
  'app.pages.managers.logManager.actions.isResultComputed':
    'Tableros - Está calculado el resultado',
  'app.pages.managers.logManager.actions.lastOpenDashboards':
    'Tableros - Últimos tableros abiertos',
  'app.pages.managers.logManager.actions.copy': 'Tableros - Copiar',
  'app.pages.managers.logManager.actions.getCubeMetadata':
    'Tableros - Pivote - Obtener metadata del cubo',
  'app.pages.managers.logManager.actions.getCubeValues':
    'Tableros - Pivote - Obtener valores del cubo',
  'app.pages.managers.logManager.actions.setCubeChanges':
    'Tableros - Pivote - Establecer cambios del cubo',
  'app.pages.managers.logManager.actions.getDimensionValues':
    'Tableros - Pivote - Obtener valores de dimensión',
  'app.pages.managers.logManager.actions.tokenAuthEndpoints': 'Endpoints del Token Auth',
  'app.pages.managers.logManager.actions.sendPasswordResetEmail':
    'Enviar correo de restablecimiento de contraseña',
  'app.pages.managers.logManager.actions.passwordReset': 'Restablecimiento de contraseña',
  'app.pages.managers.logManager.actions.authEndpoints': 'Endpoints del Auth',
  'app.pages.managers.logManager.actions.createInstance': 'Crear instancia', //uso sesion o instancia
  'app.pages.managers.logManager.actions.getInstance': 'Obtener instancia',
  'app.pages.managers.logManager.actions.logout': 'Cerrar sesión',
  'app.pages.managers.logManager.actions.getAllInstances': 'Obtener todas las instancias',
  'app.pages.managers.logManager.actions.getMyInstances': 'Obtener mis instancias',
  'app.pages.managers.logManager.actions.killInstanceById': 'Matar instancia por id',
  'app.pages.managers.logManager.actions.createNewInstance': 'Crear nueva instancia',
  'app.pages.managers.logManager.actions.useExternalLink': 'Usar link externo',
  'app.pages.managers.logManager.actions.getSystemResources': 'Obtener recursos del sistema',
  'app.pages.managers.logManager.actions.requireLogout': 'Requerir cierre de sesión',
  'app.pages.managers.logManager.actions.getGeoData': 'Geo - Obtener información Geo',
  'app.pages.managers.logManager.actions.getGeoDetail': 'Geo - Obtener detalle Geo',
  'app.pages.managers.logManager.actions.getBubbleInfo': 'Geo - Obtener información Burbuja',
  'app.pages.managers.logManager.actions.inputForm': 'Plantilla de entrada - Listar', //input o entradas
  'app.pages.managers.logManager.actions.getMetadata': 'Formularios de entrada - Obtener metadata',
  'app.pages.managers.logManager.actions.getData': 'Plantilla de entrada - Obtener información',
  'app.pages.managers.logManager.actions.setData': 'Plantilla de entrada - Establecer información',
  'app.pages.managers.logManager.actions.result': 'Endpoints de Resultado',
  'app.pages.managers.logManager.actions.resultByNodeId': 'Resultado - Por identificador del nodo',
  'app.pages.managers.logManager.actions.activities': 'Endpoints de actividades',
  'app.pages.managers.logManager.actions.groups': 'Endpoints de grupos',
  'app.pages.managers.logManager.actions.updateGroupsPermissions':
    'Grupos - Actualizar permisos de grupos',
  'app.pages.managers.logManager.actions.users': 'Endpoints de usuarios',
  'app.pages.managers.logManager.actions.companies': 'Endpoints de compañías',
  'app.pages.managers.logManager.actions.preferenceByCode': 'Compañías - Preferencias por código',
  'app.pages.managers.logManager.actions.preferences': 'Compañías - Preferencias',
  'app.pages.managers.logManager.actions.usercompanies': 'Endpoints de compañías de usuario',
  'app.pages.managers.logManager.actions.listByCompanyId':
    'Compañías de usuario - Listar por identificador de compañía',
  'app.pages.managers.logManager.actions.userPreferenceByCode':
    'Compañías de usuario - Preferencias por código',
  'app.pages.managers.logManager.actions.userPreferences': 'Compañías de usuario - Preferencias',
  'app.pages.managers.logManager.actions.permissions': 'Endpoints de permisos',
  'app.pages.managers.logManager.actions.departments': 'Endpoints de departamentos',
  'app.pages.managers.logManager.actions.byCurrentCompany': 'Departamentos - Por compañía actual',
  'app.pages.managers.logManager.actions.denied': 'Departamentos - Denegados',
  'app.pages.managers.logManager.actions.denyItems': 'Departamentos - Denegar item',
  'app.pages.managers.logManager.actions.dashboardComments': 'Endpoints de comentarios del tablero',
  'app.pages.managers.logManager.actions.dashboardStyles': 'Endpoints de estilado del tablero',
  'app.pages.managers.logManager.actions.diagramShortcut': 'Endpoints de atajo del tablero',
  'app.pages.managers.logManager.actions.preferenceModules': 'Endpoints de módulos de preferencia',
  'app.pages.managers.logManager.actions.preferencesEndpoints': 'Endpoints de preferencia',
  'app.pages.managers.logManager.actions.userCompanyPreferences':
    'Endpoints de preferencia de usuario de compañía',
  'app.pages.managers.logManager.actions.companyPreferences':
    'Endpoints de preferencias de compañía',
  'app.pages.managers.logManager.actions.apiEndpoints': 'Endpoints de API',
  'app.pages.managers.logManager.actions.reportExternalLink':
    'Endpoints de enlaces de reportes externos',
  'app.pages.managers.logManager.actions.dashboardExternalLink':
    'Endpoints de enlaces de tableros externos',
  'app.pages.managers.logManager.actions.scheduler': 'Endpoints de planificador', //scheduler = planificador o planificador de tareas
  'app.pages.managers.logManager.actions.getPythonTimezones':
    'Planificador - Obtener zonas horarias',
  'app.pages.managers.logManager.actions.taskLog': 'Endpoints del log de tareas',
  'app.pages.managers.logManager.actions.byPeriodicTask': 'Log de tareas - Por tareas periódicas',
  'app.pages.managers.logManager.actions.filterLogs': 'Log de tareas - Filtrar logs',
  'app.pages.managers.logManager.actions.logging': 'Endpoints de logs',
  'app.pages.managers.logManager.actions.restAuth': 'Endpoints de Rest Auth',
  'app.pages.managers.logManager.actions.accounts': 'Endpoints de cuenta',
  'app.pages.managers.logManager.actions.createNewApp': 'Crear nueva aplicación',
  'app.pages.managers.logManager.actions.setSelectorValue': 'Establecer valor del selector',
  'app.pages.managers.logManager.actions.getSelectorValue': 'Obtener valor del selector',
  'app.pages.managers.logManager.actions.getSelectorOptionsAndIndex':
    'Obtener opciones e índice del selector',
  'app.pages.managers.logManager.actions.getSelectorParams': 'Obtener parámetros del selector',
  'app.pages.managers.logManager.actions.getChoice': 'Obtener choice',
  'app.pages.managers.logManager.actions.setChoiceValue': 'Establecer valor del choice',
  'app.pages.managers.logManager.actions.getChoiceValue': 'Obtener valor del choice',
  'app.pages.managers.logManager.actions.getChoiceOptions': 'Obtener opciones del choice',
  'app.pages.managers.logManager.actions.getChoiceOptionsAndIndex':
    'Obtener opciones e índice del choice',
  'app.pages.managers.logManager.actions.getChoiceParams': 'Obtener parámetros del choice',
  'app.pages.managers.logManager.actions.setInputScalarValue': 'Establecer valor del input escalar',
  'app.pages.managers.logManager.actions.callFunction': 'Llamar función',
  'app.pages.managers.logManager.actions.getWorkspaceAndPublic': 'Obtener workspace y público',
  'app.pages.managers.logManager.actions.searchFiles': 'Buscar archivos',
  'app.pages.managers.logManager.actions.departmentsByCompanyId':
    'Departamentos - Por id de compañía',
  'app.pages.managers.logManager.actions.interfaces': 'Endpoints de interfaces',
  'app.pages.managers.logManager.actions.getAllInterfaces': 'Interfaces - Obtener todas',
  'app.pages.managers.logManager.actions.listInterfaces': 'Interfaces - Listar',
  'app.pages.managers.logManager.actions.searchInterfaces': 'Interfaces - Buscar',
  'app.pages.managers.logManager.actions.createInterface': 'Interfaces - Crear',
  'app.pages.managers.logManager.actions.updateInterface': 'Interfaces - Actualizar',
  'app.pages.managers.logManager.actions.removeInterface': 'Interfaces - Eliminar',
  'app.pages.managers.logManager.actions.copyInterface': 'Interfaces - Copiar',
  'app.pages.managers.logManager.actions.moveInterface': 'Interfaces - Mover',
  'app.pages.managers.logManager.actions.duplicateInterface': 'Interfaces - Duplicar',
  'app.pages.managers.logManager.actions.exportInterfaces': 'Interfaces - Exportar',
  'app.pages.managers.logManager.actions.importInterface': 'Interfaces - Importar',
  'app.pages.managers.logManager.actions.createInterfaceFolder': 'Interfaces - Crear carpeta',
  'app.pages.managers.logManager.actions.removeInterfaceFolder': 'Interfaces - Eliminar carpeta',
  'app.pages.managers.logManager.actions.setInterfacePermission': 'Interfaces - Establecer permiso',
  'app.pages.managers.logManager.actions.getInterfaceIndexValues':
    'Interfaces - Obtener valores de índice',
  'app.pages.managers.logManager.actions.applyFormChanges': 'Aplicar cambios del formulario',
  'app.pages.managers.logManager.actions.applyTableChanges': 'Aplicar cambios de la tabla',
  'app.pages.managers.logManager.actions.interfaceExternalLink':
    'Endpoints de enlace externo de interfaz',

  //Applications
  'app.pages.applications.createApp': 'Crear aplicación',
  'app.pages.applications.applicationName': 'Nombre de la aplicación',
  'app.pages.applications.fromScratch': 'Desde cero',
  'app.pages.applications.fromScratchDescription': 'Comienza con un simple ejemplo de "Hola mundo"',
  'app.pages.applications.fromDataAnalytics': 'Análisis de datos',
  'app.pages.applications.fromDataAnalyticsDescription':
    'Ejemplo de una aplicación de análisis de datos',
  'app.pages.applications.fromBusinessPlanning': 'Planeamiento de negocios',
  'app.pages.applications.fromBusinessPlanningDescription':
    'Ejemplo de una aplicación de planeamiento de negocios',
  'app.pages.applications.applicationManager': 'Administrador de aplicaciones',
  'app.pages.applications.deleteAppTitle': 'Eliminar aplicación',
  'app.pages.applications.deleteAppMessage': '¿Estás seguro de eliminar esta aplicación?',
  'app.pages.applications.results': 'Resultados',
  'app.pages.applications.applicationDeleted': 'Aplicación borrada',
  'app.pages.applications.deletingApplication': 'Borrando aplicación',
  'app.pages.applications.applicationNameChanged': 'Nombre de aplicación renombrado.',
  'app.pages.applications.path': 'Ruta',
  'app.pages.applications.copyAppToWorkspaceTitle': 'Copiar aplicación en espacio de trabajo',
  'app.pages.applications.copyAppToWorkspaceMessage':
    '¿Estás seguro de querer copiar esta aplicación a tu espacio de trabajo?',
  'app.pages.applications.appCopiedToWorkspace': 'La aplicación fue copiada con éxito en:',
  'app.pages.applications.copyingAppToWorkspace': 'Copiando aplicación a espacio de trabajo',
  'app.pages.applications.appImported': 'Aplicación importada exitosamente',
  'app.pages.applications.createInPublic': 'Crear en espacio Public',
  'app.pages.applications.appCopied': 'Aplicación copiada',
  'app.pages.applications.copyingAppToTeam': 'Copiando aplicación en equipo',
  'app.pages.applications.copyAppToPublicMessage':
    '¿Estás seguro de querer copiar esta aplicación al espacio de trabajo Public?',
  'app.pages.applications.appCopiedToPublic': 'Aplicación copiada a Public',
  'app.pages.applications.copyingAppToPublic': 'Copiando aplicación en Public',
  'app.pages.applications.setThumbnail': 'Establecer miniatura',
  'app.pages.applications.replaceThumbnail': 'Reemplazar miniatura',
  'app.pages.applications.removeThumbnail': 'Quitar miniatura',
  'app.pages.applications.removeThumbnailMessage': '¿Estás seguro de quitar la miniatura?',
  'app.pages.applications.thumbnailRemoved': 'Miniatura quitada',
  'app.pages.applications.thumbnailUploaded': 'Miniatura subida',
  'app.pages.applications.loadingAppMessage': 'Cargando aplicación',
  'app.pages.applications.folderDuplicated': 'Carpeta duplicada',
  'app.pages.applications.deleteFolderMessage': '¿Estás seguro de eliminar la carpeta?',
  'app.pages.applications.deleteFolderTitle': 'Eliminar carpeta',
  'app.pages.applications.folderDeleted': 'Carpeta eliminada',
  'app.pages.applications.folderCutted': 'Carpeta cortada',
  'app.pages.applications.folderCopied': 'Carpeta copiada',
  'app.pages.applications.elementsPasted': 'Elementos pegados',
  'app.pages.applications.showHiddenFolders': 'Mostrar carpetas ocultas',
  'app.pages.applications.copyAppSubMenu': 'Otras opciones de copia',
  'app.pages.applications.keepId': 'Mantener id de la aplicación',
  'app.pages.applications.directAccessLink': 'Enlace de acceso directo',
  'app.pages.applications.directAccessLinkCopied': 'Enlace de acceso directo copiado correctamente',
  'app.pages.applications.directAccessLinkError':
    'No fue posible generar el enlace de acceso directo',
  'app.pages.applications.directAccessLinkDialogTitle': 'Generar enlace de acceso directo',
  'app.pages.applications.directAccessLinkDefaultVersion': 'Usar versión por defecto',
  'app.pages.applications.generatedLink': 'Enlace generado',
  'app.pages.applications.installOnPublic': 'Instalar en público',
  'app.pages.applications.generateDirectAccessLink': 'Generar enlace',

  //Application Summary
  'app.pages.applications.id': 'Identificador de la aplicación',
  'app.pages.applications.version': 'Versión de la aplicación',
  'app.pages.applications.uri': 'Ubicación',
  'app.pages.applications.isPublic': 'Está en la carpeta pública',
  'app.pages.applications.canwrite': 'Tiene permiso de escritura',
  'app.pages.applications.venvPath': 'Ruta de entorno virtual',
  'app.pages.applications.pythonVersion': 'Versión de Python',
  'app.pages.applications.cpuArchitecture': 'Arquitectura del CPU',
  'app.pages.app.cpuArchitecture.x86': 'x86',
  'app.pages.app.cpuArchitecture.arm': 'ARM',

  //Icon selector
  'app.pages.iconSelector.iconType': 'Tipo de ícono',
  'app.pages.iconSelector.iconName': 'Icono',
  'app.pages.iconSelector.solid': 'Sólido',
  'app.pages.iconSelector.regular': 'Regular',

  //Versions
  'app.pages.versions.versionManager': 'Administrador de versiones',
  'app.pages.versions.deleteVersionTitle': 'Eliminar versión',
  'app.pages.versions.deleteVersionMessage':
    '¿Estás seguro de querer eliminar la versión {version}?',
  'app.pages.versions.deleteVersionsMessage':
    '¿Estás seguro de querer eliminar las versiones {versions}?',
  'app.pages.versions.versionDeleted': 'La versión "{version}" fue eliminada',
  'app.pages.versions.versionsDeleted': 'Las versiones "{versions}" fueron eliminadas',
  'app.pages.versions.deletingVersion': 'Eliminando versión',
  'app.pages.versions.createVersion': 'Crear versión',
  'app.pages.versions.fromVersion': 'Versión de origen',
  'app.pages.versions.versionCreated': 'La versión "{version}" fue creada con éxito',
  'app.pages.versions.creationDate': 'Fecha de creación',
  'app.pages.versions.closingDate': 'Fecha de cierre',
  'app.pages.versions.archiveDate': 'Fecha de archivo',
  'app.pages.versions.lastModifiedDate': 'Fecha de última modificación',
  'app.pages.versions.viewDetails': 'Ver detalles',
  'app.pages.versions.detailsVersionTitle': 'Detalles de la versión',
  'app.pages.versions.closedBy': 'Cerrada por',
  'app.pages.versions.archivedBy': 'Archivada por',
  'app.pages.versions.lastModifiedBy': 'Última modificación por',
  'app.pages.versions.status.active': 'Activa',
  'app.pages.versions.status.closed': 'Cerrada',
  'app.pages.versions.status.archived': 'Archivada',
  'app.pages.versions.status.unarchived': 'Desarchivada',
  'app.pages.versions.setAsDefaultVersion': 'Establecer como versión por defecto',
  'app.pages.versions.setPermission': 'Establecer permiso',
  'app.pages.versions.versionPermissionChanged': 'Permiso de la versión modificado',
  'app.pages.versions.hasDepartmentRestrictions':
    'Esta versión tiene restricciones de acceso por departamento',
  'app.pages.versions.isDefaultAppVersion': 'Es la versión por defecto de la aplicación',
  'app.pages.versions.setAsDefaultVersionMessage':
    '¿Estás seguro de querer establecer la versión "{version}" como la versión por defecto de la aplicación?',
  'app.pages.versions.defaultVersionChanged': 'La versión por defecto fue modificada',
  'app.pages.versions.editProperties': 'Editar propiedades',
  'app.pages.versions.cannotDeleteReason':
    'No es posible eliminar la versión de la aplicación abierta actualmente',
  'app.pages.versions.versionModified': 'La versión {version} fue modificada con éxito',
  'app.pages.versions.versionsModified': 'Las versiones {versions} fueron modificadas con éxito',
  'app.pages.versions.cannotModifyNameReason':
    'No es posible modificar el nombre de la versión de la aplicación abierta actualmente',
  'app.pages.versions.updateVersionStatus': 'Actualizar estado de la versión',
  'app.pages.versions.updateVersionStatusMessage':
    '¿Estás seguro de querer actualizar el estado de la versión {version} a "{newStatus}"?',
  'app.pages.versions.updateVersionsStatusMessage':
    '¿Estás seguro de querer actualizar el estado de las versiones {versions} a "{newStatus}"?',
  'app.pages.versions.importVersions': 'Importar versiones',
  'app.pages.versions.exportVersions': 'Exportar versiones',
  'app.pages.versions.cannotChangeReason':
    'No es posible modificar la versión de la aplicación abierta actualmente',
  'app.pages.versions.versionsImported': 'Las versiones subidas fueron importadas con éxito',
  'app.pages.versions.uploadInstructions':
    'Subir un archivo con extensión .zip que contenga la carpeta de cada versión que se desee importar',
  'app.pages.versions.openAppVersion': 'Abrir versión de la aplicación',
  'app.pages.versions.openAppVersionOnNewInstance':
    'Abrir versión de la aplicación en una nueva instancia',
  'app.pages.versions.excludeArchivedVersions': 'Excluir versiones archivadas',
  'app.pages.versions.versionSelectedScenariosUpdated':
    'Los escenarios seleccionados de la versión se cargaron con éxito',
  'app.pages.versions.openAfterCreating': 'Abrir luego de crear',
  'app.pages.versions.versionGroup': 'Grupo de versión',
  'app.pages.versions.versionGroupPathHelp':
    'Usa / para crear grupos anidados, por ejemplo Finanzas/Presupuesto/2026.',
  'app.pages.versions.uncategorized': 'No agrupadas',
  'app.pages.versions.moreActions': 'Más acciones',
  'app.pages.versions.unsavedChangesMessage':
    'Los cambios no guardados de la versión abierta se perderán',
  'app.pages.versions.versionExported': 'Versión exportada',
  'app.pages.versions.versionsExported': 'Versiones exportadas',
  'app.pages.versions.nameExists': 'El nombre de la versión ya existe',
  'app.pages.versions.openExistingVersion': 'Abrir versión existente',
  'app.pages.versions.createNewVersion': 'Crear versión nueva',
  'app.pages.versions.manageVersions': 'Administrar versiones',
  'app.pages.versions.createNewVersionFromThis': 'Crear nueva versión a partir de ésta',
  'app.pages.versions.createNewVersionInMyWorkspace':
    'Crear nueva versión en mi espacio de trabajo',
  'app.pages.versions.createNewVersionInMyWorkspaceConfirmation':
    'No tienes permisos de escritura en el directorio de la aplicación seleccionada. Se copiará la aplicación a tu espacio de trabajo (de no existir) y se creará la nueva versión allí.',
  'app.pages.versions.newVersionName': 'Nombre de nueva versión',
  'app.pages.versions.sourceVersion': 'Versión de origen',
  'app.pages.versions.technicalVersion': 'Versión técnica',
  'app.pages.versions.technicalVersionFormatError':
    'Debe tener tres grupos de dígitos separados por puntos (ej. 3.21.005)',
  'app.pages.versions.technicalVersionHelp':
    'Identificador de versión semántica: tres grupos de dígitos separados por puntos, por ejemplo 3.21.005.',
  'app.pages.versions.otherUserWithWritePermissions':
    'Esta versión está siendo utilizada actualmente por {user} con permisos de escritura',
  'app.pages.versions.inThisApplication': 'En esta aplicación',
  'app.pages.versions.inAnotherApplication': 'En otra aplicación',
  'app.pages.versions.loadArchivedMetadata': 'Cargar metadatos de versiones archivadas',
  'app.pages.versions.archivedMetadataLoaded': 'Metadatos de versiones archivadas cargados',

  //Process manager
  'app.pages.app.processManager.addProcess': 'Crear proceso',
  'app.pages.app.processManager.editProcess': 'Editar proceso',
  'app.pages.app.processManager.duplicateProcess': 'Duplicar proceso',
  'app.pages.app.processManager.showDescription': 'Mostrar descripción',
  'app.pages.app.processManager.noDescriptionText': 'No tiene descripción',
  'app.pages.app.processManager.processTodo': 'En progreso',
  'app.pages.app.processManager.process': 'Proceso',
  'app.pages.app.processManager.subscribers': 'Subscriptores',
  'app.pages.app.processManager.status': 'Estado',
  'app.pages.app.processManager.description': 'Descripción',
  'app.pages.app.processManager.group': 'Grupo',
  'app.pages.app.processManager.task': 'Tarea',
  'app.pages.app.processManager.taskResponsible': 'Responsable de la tarea',
  'app.pages.app.processManager.taskResponsibles': 'Responsables de la tarea',
  'app.pages.app.processManager.taskActionType': 'Tipo de acción',
  'app.pages.app.processManager.isBlockedBy': 'Bloqueada por',
  'app.pages.app.processManager.expiration': 'Expiración',
  'app.pages.app.processManager.expirationType': 'Tipo de expiración',
  'app.pages.app.processManager.createGroup': 'Crear grupo',
  'app.pages.app.processManager.editGroup': 'Editar grupo',
  'app.pages.app.processManager.groupsAndTasks': 'Grupos y tareas',
  'app.pages.app.processManager.processWithoutGroups': 'Este proceso todavía no tiene grupos',
  'app.pages.app.processManager.processWithoutGroupsHint':
    'Un grupo agrupa las tareas de una etapa — crea el primero para poder agregar tareas.',
  'app.pages.app.processManager.processWithoutGroupsNeedsName':
    'Pon primero el nombre del proceso y después crea el primer grupo.',
  'app.pages.app.processManager.groupWithoutTasks': 'Todavía no hay tareas en este grupo',
  'app.pages.app.processManager.expirationDaysValue': '{days, plural, one {# día} other {# días}}',
  'app.pages.app.processManager.expirationHoursValue':
    '{hours, plural, one {# hora} other {# horas}}',
  'app.pages.app.processManager.expirationMinutesValue':
    '{minutes, plural, one {# minuto} other {# minutos}}',
  'app.pages.app.processManager.expirationFromProcess': 'desde el inicio del proceso',
  'app.pages.app.processManager.expirationFromBlocker': 'desde la tarea bloqueante',
  'app.pages.app.processManager.expirationImmediate': 'Inmediato',
  'app.pages.app.processManager.sinceProcess': 'desde que se inició el proceso',
  'app.pages.app.processManager.sinceBlockingTaskCompleted':
    'desde que se completó la tarea bloqueante',
  'app.pages.app.processManager.processCreated': 'Proceso creado',
  'app.pages.app.processManager.processUpdated': 'Proceso actualizado',
  'app.pages.app.processManager.processDuplicated': 'Proceso duplicado',
  'app.pages.app.processManager.undefined': 'Indefinido',
  'app.pages.app.processManager.processDeleted': 'Proceso eliminado',
  'app.pages.app.processManager.processNotFound': 'No se encontraron procesos',
  'app.pages.app.processManager.deleteProcess': 'Eliminar proceso',
  'app.pages.app.processManager.deleteProcessMessage': '¿Estás seguro de eliminar este proceso?',
  'app.pages.app.processManager.reviewers': 'Revisores',
  'app.pages.app.processManager.reviewerInterface': 'Interfaz de revisión',
  'app.pages.app.processManager.taskApp': 'Aplicación',
  'app.pages.app.processManager.taskAppPlaceholder': 'La aplicación del proceso',
  'app.pages.app.processManager.taskAppDefault': 'Usa la aplicación del proceso',
  'app.pages.app.processManager.taskAppVersion': 'Versión',
  'app.pages.app.processManager.taskAppVersionIsDefault': '(hoy la por defecto)',
  'app.pages.app.processManager.taskAppVersionDefault': 'Versión por defecto',
  'app.pages.app.processManager.runAs': 'Ejecutar como',
  'app.pages.app.processManager.noAgentUsers':
    'Para asignar un agente, primero crea un usuario-agente desde el manager de usuarios.',
  'app.pages.app.processManager.responsibleAgent': 'Agente del responsable',
  'app.pages.app.processManager.reviewerAgent': 'Agente del revisor',
  'app.pages.app.processManager.selectAgent': 'Elige un agente',
  'app.pages.app.processManager.peopleGroup': 'Personas',
  'app.pages.app.processManager.agentsGroup': 'Agentes',
  'app.pages.app.processManager.oneAgentResponsibleOnly':
    'Sólo un agente puede ser responsable de una tarea.',
  'app.pages.app.processManager.agentRequired': 'Elige con qué agente corre esta tarea.',
  'app.pages.app.processManager.agentSelfApproval':
    'El agente revisor tiene que ser distinto del que hace el trabajo.',
  'app.pages.app.processManager.personSelfReview':
    'Un responsable de la tarea no puede ser también su revisor.',
  'app.pages.app.processManager.agentWorking': 'Agente trabajando',
  'app.pages.app.processManager.agentTooltip': 'Agente',
  'app.pages.managers.agentAccessTokens': 'Tokens de acceso',
  'app.pages.managers.isAgent': 'Este usuario es un agente',
  'app.pages.managers.isAgentHelp':
    'Un agente no puede iniciar sesión y no tiene contraseña. Se lo puede asignar a tareas de un proceso para que el trabajo lo haga un agente.',
  'app.pages.app.processManager.expirationDays': 'Días de expiración',
  'app.pages.app.processManager.collaborators': 'Colaboradores',
  'app.pages.app.processManager.deleteGroupTitle': '¿Estás seguro de eliminar este grupo?',
  'app.pages.app.processManager.deleteGroupMessage': 'Contiene las siguientes tareas',
  'app.pages.app.processManager.deleteTaskTitle': '¿Eliminar esta tarea?',
  'app.pages.app.processManager.deleteWaitingTasks':
    'Estas tareas esperan lo que estás eliminando. Las que se queden sin tarea bloqueante conservan su fecha de vencimiento, que a partir de ahora se cuenta desde el inicio del proceso, y pueden empezar enseguida.',
  'app.pages.app.processManager.dueTypeNeedsBlocker': 'Primero elige una tarea bloqueante',
  'app.pages.app.processManager.marginSummaryTitle': 'Algunos vencimientos no cuadran',
  'app.pages.app.processManager.marginSummaryNone':
    '“{task}” vence el {date}, al mismo tiempo que “{blocker}”, a la que tiene que esperar.',
  'app.pages.app.processManager.marginSummaryNegative':
    '“{task}” vence el {taskDate}, pero “{blocker}”, a la que tiene que esperar, vence el {blockerDate} ({gap} después).',
  'app.pages.app.processManager.dueAfterEndSummary':
    '“{task}” vence el {due}, después de que termina el proceso, el {end}.',
  'app.pages.app.processManager.marginSummaryReview': 'Revisar',
  'app.pages.app.processManager.marginSummarySave': 'Guardar igual',
  'app.pages.app.processManager.marginNone':
    '“{blocker}”, que esta tarea espera, vence {blockerDue} después del inicio del proceso, igual que esta tarea: no le queda tiempo para hacerla.',
  'app.pages.app.processManager.marginNegative':
    '“{blocker}”, que esta tarea espera, vence {blockerDue} después del inicio del proceso. Esta tarea vence {gap} antes, sin haber podido empezar.',
  'app.pages.app.processManager.marginFix': 'Contar los días desde que se completa',
  'app.pages.app.processManager.addTask': 'Crear tarea',
  'app.pages.app.processManager.editTask': 'Editar tarea',
  'app.pages.app.processManager.taskStatus.not_ready_to_start': 'No lista para comenzar',
  'app.pages.app.processManager.taskStatus.not_started': 'No iniciada',
  'app.pages.app.processManager.taskStatus.in_progress': 'En progreso',
  'app.pages.app.processManager.taskStatus.pending_review': 'Pendiente de revisión',
  'app.pages.app.processManager.taskStatus.completed': 'Completada',
  'app.pages.app.processManager.restartProcess': 'Reiniciar proceso',
  'app.pages.app.processManager.processRestarted': 'Proceso reiniciado',
  'app.pages.app.processManager.autoCompleteOnDue': 'Autocompletar al vencimiento',
  'app.pages.app.processManager.autoCompleteOnDueTooltip':
    'Marcar automáticamente la tarea como completada cuando se alcance la fecha de vencimiento.',
  'app.pages.app.processManager.scheduledTaskOnFinish': 'Tarea al finalizar',
  'app.pages.app.processManager.requireAllResponsibleCompletion':
    'Requerir que todos los responsables completen la tarea',
  'app.pages.app.processManager.requireAllResponsibleCompletionTooltip':
    'Todos los responsables deben completar la tarea antes de que pueda marcarse como completada. Si no está seleccionado, solo se requiere que un responsable complete la tarea.',
  'app.pages.app.processManager.processExported': 'Proceso exportado',
  'app.pages.app.processManager.processesExported': 'Procesos exportados',
  'app.pages.app.processManager.importProcesses': 'Importar procesos',
  'app.pages.app.processManager.importProcessesInstructions':
    'Selecciona un archivo de exportación de procesos (.json) para importar',
  'app.pages.app.processManager.invalidImportFile': 'Archivo de importación inválido',
  'app.pages.app.processManager.processesImported': 'Procesos importados',
  'app.pages.app.processManager.importWarningsTitle': 'Advertencias de importación',
  'app.pages.app.processManager.importWarningsProcess': 'Proceso {processName}',
  'app.pages.app.processManager.importWarningsUnresolvedUsers': 'Usuarios no resueltos',
  'app.pages.app.processManager.importWarningsUnresolvedUserItem':
    'Tarea {taskName} - {role}: {identifier}',
  'app.pages.app.processManager.importWarningsRoleResponsible': 'responsable',
  'app.pages.app.processManager.importWarningsRoleReviewer': 'revisor',
  'app.pages.app.processManager.importWarningsRoleCollaborator': 'colaborador',
  'app.pages.app.processManager.importWarningsRoleSubscriber': 'suscriptor',
  'app.pages.app.processManager.importWarningsUnresolvedAgents': 'Agentes no resueltos',
  'app.pages.app.processManager.importWarningsUnresolvedAgentItem':
    'Tarea "{taskName}": no se asignó el agente "{agentCode}"',
  'app.pages.app.processManager.importWarningsUnresolvedActions':
    'Acciones/interfaces no resueltas',
  'app.pages.app.processManager.importWarningsUnresolvedActionItem': 'Tarea {taskName} - {field}',
  'app.pages.app.processManager.importWarningsLostAutomations': 'Automatizaciones perdidas',
  'app.pages.app.processManager.importWarningsLostAutomationItem': 'Tarea {taskName}',

  //Scenarios
  'app.pages.scenarios.scenarioManager': 'Administrador de escenarios',
  'app.pages.scenarios.deleteScenarioTitle': 'Eliminar escenario',
  'app.pages.scenarios.deleteScenarioMessage':
    '¿Estás seguro de querer eliminar el escenario "{scenario}"?',
  'app.pages.scenarios.deleteScenariosMessage':
    '¿Estás seguro de querer eliminar los escenarios "{scenarios}"?',
  'app.pages.scenarios.scenarioDeleted': 'El escenario "{scenario}" fue eliminado',
  'app.pages.scenarios.scenariosDeleted': 'Los escenarios "{scenarios}" fueron eliminados',
  'app.pages.scenarios.deletingScenario': 'Eliminando escenario',
  'app.pages.scenarios.createScenario': 'Crear escenario',
  'app.pages.scenarios.fromScenario': 'Desde escenario',
  'app.pages.scenarios.scenarioCreated': 'El escenario "{scenario}" fue creado con éxito',
  'app.pages.scenarios.lastModifiedDate': 'Última fecha de modificación',
  'app.pages.scenarios.editProperties': 'Editar propiedades',
  'app.pages.scenarios.scenarioModified': 'El escenario "{scenario}" fue modificado con éxito',
  'app.pages.scenarios.importScenarios': 'Importar escenarios',
  'app.pages.scenarios.exportScenario': 'Exportar escenario',
  'app.pages.scenarios.scenariosImported': 'Los escenarios subidos fueron importados con éxito',
  'app.pages.scenarios.uploadInstructions':
    'Subir un archivo con extensión .zip que contenga la carpeta de cada versión (con una carpeta por cada escenario dentro) que se desee importar',
  'app.pages.scenarios.alias': 'Alias',
  'app.pages.scenarios.includedNodes': 'Nodos incluidos',
  'app.pages.scenarios.includeNodesFrom': 'Incluir nodos desde',
  'app.pages.scenarios.currentInterface': 'Interfaz actual',
  'app.pages.scenarios.nodesToBeEvaluatedBeforehand': 'Nodos a evaluar previamente',
  'app.pages.scenarios.nodesToBeEvaluatedAfterwards': 'Nodos a evaluar posteriormente',
  'app.pages.scenarios.runScenarioAfterSave': 'Ejecutar escenario después de guardar',
  'app.pages.scenarios.addNode': 'Agregar nodo',
  'app.pages.scenarios.showCurrentVersionOnly': 'Mostrar sólo versión actual',
  'app.pages.scenarios.scenarioAlreadyExists':
    'Ya existe un escenario con este nombre en la versión "{version}"',
  'app.pages.scenarios.scenarioDuplicated': 'El escenario "{scenario}" fue duplicado con éxito',
  'app.pages.scenarios.duplicateScenario': 'Duplicar escenario',
  'app.pages.scenarios.saveScenario': 'Guardar escenario',
  'app.pages.scenarios.cannotSaveScenarioReason':
    'No es posible guardar escenarios en una versión que no está activa',
  'app.pages.scenarios.cannotChangeScenarioReason':
    'No es posible modificar escenarios en una versión que no está activa',
  'app.pages.scenarios.existingScenario': 'Escenario existente',
  'app.pages.scenarios.createNewScenario': 'Crear nuevo escenario',
  'app.pages.scenarios.baseScenario': 'Escenario base',
  'app.pages.scenarios.scenarioSaved': 'El escenario "{scenario}" fue guardado con éxito',
  'app.pages.scenarios.noNodesMessage':
    'El escenario elegido no incluye ningún nodo para guardar. Edita este escenario en el Administrador de Escenarios para agregarlos.',
  'app.pages.scenarios.selectScenarios': 'Seleccionar escenarios',
  'app.pages.scenarios.byInterfaceMode': 'Por interfaz',
  'app.pages.scenarios.scenariosForInterface': 'Escenarios para la interfaz: {interfaceName}',
  'app.pages.scenarios.modeUpdated': 'Modo de selección de escenarios actualizado correctamente',
  'app.pages.scenarios.selectedScenarios': 'Escenarios seleccionados',
  'app.pages.scenarios.scenarioExported': 'Escenario exportado exitosamente',
  'app.pages.scenarios.scenariosExported': 'Escenarios exportados exitosamente',
  'app.pages.scenarios.scenariosManager': 'Administrador de escenarios',
  'app.pages.scenarios.scenariosTemplates': 'Plantillas de escenarios',
  'app.pages.scenarios.createTemplate': 'Crear plantilla',
  'app.pages.scenarios.editTemplate': 'Editar plantilla',
  'app.pages.scenarios.duplicateTemplate': 'Duplicar plantilla',
  'app.pages.scenarios.deleteTemplate': 'Eliminar plantilla',
  'app.pages.scenarios.scenarioTemplateSuccessfullyCreated':
    'Plantilla de escenario creada exitosamente',
  'app.pages.scenarios.scenarioTemplateSuccessfullyModified':
    'Plantilla de escenario {template} modificada exitosamente',
  'app.pages.scenarios.deleteScenarioTemplateTitle': 'Eliminar plantilla de escenario',
  'app.pages.scenarios.deleteScenarioTemplateMessage':
    '¿Estás seguro de querer eliminar la plantilla de escenario "{scenarioTemplate}"?',
  'app.pages.scenarios.scenarioTemplateSuccessfullyDuplicated':
    'Plantilla de escenario {scenarioTemplate} duplicada exitosamente',
  'app.pages.scenarios.scenarioTemplateNameAlreadyExists':
    'Ya existe una plantilla de escenario con este nombre en la versión {version}',
  'app.pages.scenarios.templateName': 'Nombre de la plantilla',
  'app.pages.scenarios.scenarioNodesTemplate': 'Plantilla de nodos de escenario',
  'app.pages.scenarios.noOptionsTemplate': 'No hay opciones de plantilla',
  'app.pages.scenarios.addNewScenarioNodesTemplate':
    'Agregar nueva plantilla de nodos de escenario',
  'app.pages.scenarios.destinationVersion': 'Versión de destino',
  'app.pages.scenarios.updateSelectedScenarios': 'Cargar escenarios seleccionados',
  'app.pages.scenarios.visibility.whoCanSee': 'Quién puede ver este escenario',
  'app.pages.scenarios.visibility.onlyMe': 'Solo yo',
  'app.pages.scenarios.visibility.everyone': 'Todos',
  'app.pages.scenarios.visibility.byDepartments': 'Usuarios de departamentos seleccionados',
  'app.pages.scenarios.visibility.selectDepartments': 'Seleccionar departamentos',
  'app.pages.scenarios.visibility.selectDepartmentsPlaceholder': 'Elegir departamentos...',
  'app.pages.scenarios.visibility.noDepartments': 'No hay departamentos disponibles',
  'app.pages.scenarios.useCustomScenariosForInterface':
    'Selección de escenarios personalizada para la interfaz {interfaceName}',

  //My tasks
  'app.pages.app.myTasks.title': 'Mis tareas',
  'app.pages.app.myTasks.statusChanged': 'Estado cambiado',
  'app.pages.app.myTasks.showComments': 'Mostrar comentarios',
  'app.pages.app.myTasks.openTaskDetail': 'Ver el detalle de la tarea y los comentarios',
  'app.pages.app.myTasks.responsible': 'Responsable',
  'app.pages.app.myTasks.responsibles': 'Responsables',
  'app.pages.app.myTasks.deadline': 'Fecha límite',
  'app.pages.app.myTasks.finished': 'Finalizada',
  'app.pages.app.myTasks.commentDeleted': 'Comentario eliminado',
  'app.pages.app.myTasks.comments': 'Comentarios',
  'app.pages.app.myTasks.deleteComment': 'Eliminar comentario',
  'app.pages.app.myTasks.addComment': 'Crear comentario',
  'app.pages.app.myTasks.noAssignedTasks': 'Sin tareas asignadas',
  'app.pages.app.myTasks.requestChangesTitle': 'Devolver la tarea',
  'app.pages.app.myTasks.requestChangesHelp':
    'La tarea vuelve a quien es responsable de ella. Lo que escribas se publica como comentario y es lo primero que va a leer.',
  'app.pages.app.myTasks.requestChangesAgentHint':
    'El agente responsable va a volver a trabajar con esta indicación.',
  'app.pages.app.myTasks.requestChangesLabel': 'Qué hay que corregir',
  'app.pages.app.myTasks.requestChangesConfirm': 'Devolver',
  'app.pages.app.myTasks.requestChangesDone': 'La tarea volvió al responsable',
  'app.pages.app.myTasks.process': 'Proceso',
  'app.pages.app.myTasks.view': 'Vista',
  'app.pages.app.myTasks.tableView': 'Tabla',
  'app.pages.app.myTasks.timelineView': 'Línea de tiempo',
  'app.pages.app.myTasks.startedOn': 'comenzó el {date}',
  'app.pages.app.myTasks.closesOn': 'cierra el {date}',
  'app.pages.app.myTasks.cycleProgress': 'Avance del proceso',
  'app.pages.app.myTasks.tasksCompleted': '{completed} de {total} tareas completadas',
  'app.pages.app.myTasks.deadlineHealth': 'Estado de los vencimientos',
  'app.pages.app.myTasks.overdueTasks': 'vencidas',
  'app.pages.app.myTasks.atRiskTasks': 'en riesgo',
  'app.pages.app.myTasks.runway':
    'Cierra el {date} — quedan {days, plural, one {# día} other {# días}}',
  'app.pages.app.myTasks.noCloseDate': 'Sin fecha de cierre',
  'app.pages.app.myTasks.waitingOnMe': 'Esperando por mí',
  'app.pages.app.myTasks.openTasksWithYou': 'tareas abiertas contigo',
  'app.pages.app.myTasks.waitingDetail':
    '{agents, plural, =0 {ningún agente trabajando} one {# agente trabajando ahora} other {# agentes trabajando ahora}}, {blocked, plural, =0 {ninguna esperando un bloqueo} other {# esperando un bloqueo}}',
  'app.pages.app.myTasks.allMustComplete': 'todos deben completar',
  'app.pages.app.myTasks.anyCanComplete': 'cualquiera puede completar',
  'app.pages.app.myTasks.deadlineCompleted': 'completada',
  'app.pages.app.myTasks.deadlineOverdue':
    '{days, plural, one {# día de atraso} other {# días de atraso}}',
  'app.pages.app.myTasks.deadlineOverdueToday': 'vencida',
  'app.pages.app.myTasks.deadlineToday': 'hoy',
  'app.pages.app.myTasks.deadlineIn': '{days, plural, one {en # día} other {en # días}}',
  'app.pages.app.myTasks.timelineTaskColumn': 'Tarea · responsables',
  'app.pages.app.myTasks.review': 'Revisión',
  'app.pages.app.myTasks.sharedTask': 'Tarea compartida',
  'app.pages.app.myTasks.taskStatus': 'Estado de la tarea',
  'app.pages.app.myTasks.reviewRound': 'Ronda {round}',
  'app.pages.app.myTasks.sentBackAt': 'Devuelta el {date} por {author}',
  'app.pages.app.myTasks.openNamed': 'Abrir {name}',
  'app.pages.app.myTasks.saveResults': 'Guardar resultados',
  'app.pages.app.myTasks.noComments': 'Todavía no hay comentarios',
  'app.pages.app.myTasks.send': 'Enviar',
  'app.pages.app.myTasks.commentRoleAgent': 'agente',
  'app.pages.app.myTasks.commentRoleReviewer': 'revisor',
  'app.pages.app.myTasks.commentRoleResponsible': 'responsable',
  'app.pages.app.myTasks.commentSentBack': 'devuelta para corregir',
  'app.pages.app.myTasks.agentStarting': 'Iniciando…',
  'app.pages.app.myTasks.agentReportsBack': 'Informar el resultado y mover la tarea',
  'app.pages.app.myTasks.agentReportsBackHint': 'deja un comentario cuando termina',
  'app.pages.app.myTasks.agentRun': 'Ejecución {run}',
  'app.pages.app.myTasks.agentStartedAt': 'comenzó el {date}',
  'app.pages.app.myTasks.elapsedSeconds': '{seconds} s',
  'app.pages.app.myTasks.elapsedMinutes': '{minutes} min {seconds} s',
  'app.pages.app.myTasks.elapsedHours': '{hours} h {minutes} min',

  //General settings
  'app.pages.generalSettings.logsSettings': 'Configuración de los logs',
  'app.pages.generalSettings.initialPrompt': 'Indicación inicial',
  'app.pages.generalSettings.customValue': 'Valor personalizado',
  'app.pages.generalSettings.customValueRemoved': 'Valor personalizado eliminado',
  'app.pages.generalSettings.customValueSaved': 'Valor personalizado guardado exitosamente',
  'app.pages.generalSettings.paramsPlaceholder': 'Ingresa los parámetros en formato JSON',

  //App Configuration
  'app.pages.app.appConfiguration': 'Configuración de la aplicación',
  'app.pages.app.installLibrariesOnOpen': 'Instalar librerías al abrir',
  'app.pages.app.openDefaultVersionOnOpen': 'Abrir versión por defecto al abrir',
  'app.pages.app.openAsReadOnlyByDefault': 'Abrir como sólo lectura por defecto',
  'app.pages.app.defaultTabOnOpen': 'Pestaña por defecto al abrir',
  'app.pages.app.applicationLanguage': 'Idioma de la aplicación',
  'app.pages.app.quickMenu': 'Menú Rápido',
  'app.pages.app.quickMenu.fromInterface': 'De interfaz',
  'app.pages.app.quickMenu.noMenu': 'No se encontró un menú',

  //External links
  'app.pages.externalLink.deleteMessage': '¿Estás seguro de borrar el link externo?',
  'app.pages.externalLink.linkDeleted': 'Link externo eliminado',
  'app.pages.externalLink.deleteTitle': 'Eliminar link externo',
  'app.pages.externalLink.nodeId': 'Id del nodo',
  'app.pages.externalLink.commonInstance': 'Instancia común',
  'app.pages.externalLink.apiEndpoint': 'API URL',
  'app.pages.externalLink.linkUpdated': 'Enlace externo actualizado',
  'app.pages.externalLink.customEndpoint': 'Endpoint personalizado',
  'app.pages.externalLink.customEndpointError': 'Endpoint personalizado ya existe',
  'app.pages.externalLink.externalLinksNotFound': 'No hay enlaces externos',
  'app.pages.externalLink.selectApiKey': 'Selecciona una clave API',
  'app.pages.externalLink.executor': 'Ejecutor',
  'app.pages.externalLink.noApiEndpoints': 'No hay API endpoints',

  //API keys manager
  'app.pages.apiKeysManager.alias': 'Alias',
  'app.pages.apiKeysManager.key': 'Clave',
  'app.pages.apiKeysManager.active': 'Activo',
  'app.pages.apiKeysManager.lastKeyChange': 'Último cambio de la clave',
  'app.pages.apiKeysManager.showApiKeys': 'Mostrar claves API',
  'app.pages.apiKeysManager.createApiKeys': 'Crear clave API',
  'app.pages.apiKeysManager.editApiKeys': 'Editar clave API',
  'app.pages.apiKeysManager.deleteApiKeys': 'Eliminar clave API',
  'app.pages.apiKeysManager.noApiKeys': 'No hay claves API',
  'app.pages.apiKeysManager.apiKey': 'Clave API',
  'app.pages.apiKeysManager.deleteApiKeyMessage': '¿Estás seguro de eliminar la clave API?',
  'app.pages.apiKeysManager.apiKeyDeleted': 'Clave API eliminada',
  'app.pages.apiKeysManager.apiKeyUpdated': 'Clave API actualizada',
  'app.pages.apiKeysManager.apiKeyCreated': 'Clave API creada',
  'app.pages.apiKeysManager.keyCopied': 'Clave copiada',
  'app.pages.apiKeysManager.saveKeyAlert':
    '¡Atención! La clave API solo estará visible en esta ocasión. Asegúrate de copiarla ahora mismo',
  'app.pages.apiKeysManager.keyId': 'Clave Id',

  //App consolidation
  'app.pages.appConsolidation.sourceAppVersion': 'Versión de la aplicación de origen',
  'app.pages.appConsolidation.differences': 'Diferencias',
  'app.pages.appConsolidation.summary': 'Resumen',
  'app.pages.appConsolidation.businessRules': 'Reglas de negocio',
  'app.pages.appConsolidation.includeAllModules': 'Incluir todos',
  'app.pages.appConsolidation.includeAllInterfaces': 'Incluir todas',
  'app.pages.appConsolidation.replaceMatchingNodes':
    'Reemplazar los nodos coincidentes fuera de estos módulos',
  'app.pages.appConsolidation.versionMetadata': 'Metadatos de la versión',
  'app.pages.appConsolidation.itemAdded': '{name} agregada/o',
  'app.pages.appConsolidation.itemDeleted': '{name} eliminada/o',
  'app.pages.appConsolidation.itemEdited': '{name} editada/o',
  'app.pages.appConsolidation.itemsAdded': '{name} agregadas/os',
  'app.pages.appConsolidation.itemsDeleted': '{name} eliminadas/os',
  'app.pages.appConsolidation.itemsEdited': '{name} editadas/os',
  'app.pages.appConsolidation.noChanges': 'Sin cambios',
  'app.pages.appConsolidation.confirmationDialogTitle': 'Confirmar cambios de consolidación',
  'app.pages.appConsolidation.confirmationDialogText1':
    '¿Estás seguro de querer confirmar los cambios?',
  'app.pages.appConsolidation.confirmationDialogText2':
    'Los cambios aplicados a {sections} son irreversibles.',
  'app.pages.appConsolidation.compareDefinitionOnly': 'Comparar sólo definición',
  'app.pages.appConsolidation.versionFiles': 'Archivos de la versión',
  'app.pages.appConsolidation.appFiles': 'Archivos de la aplicación',
  'app.pages.appConsolidation.appMetadata': 'Metadatos de la aplicación',
  'app.pages.appConsolidation.scenarioFile': 'Archivo de escenario',
  'app.pages.appConsolidation.scenarioFiles': 'Archivos de escenarios',
  'app.pages.appConsolidation.test': 'Test',
  'app.pages.appConsolidation.scenarios': 'Escenarios',
  'app.pages.appConsolidation.tests': 'Tests',
  'app.pages.appConsolidation.skill': 'Skill',
  'app.pages.appConsolidation.skills': 'Skills',
  'app.pages.appConsolidation.htmlCode': 'HTML',
  'app.pages.appConsolidation.pythonCode': 'Código Python',

  //Office addin
  'app.pages.office.selectNode': 'Selecciona un nodo',

  //Notifications
  'app.pages.notifications.scheduler.taskFinished':
    'La tarea {match1} finalizó con el estado {match2}',
  'app.pages.notifications.workflow.taskReady':
    'La tarea {match1} del proceso {match2} está lista para comenzar',
  'app.pages.notifications.workflow.taskOverdueExtended':
    'La tarea {match1} del proceso {match2} está vencida. Esto puede afectar la finalización de tu tarea {match3}',
  'app.pages.notifications.workflow.taskOverdue':
    'La tarea {match1} del proceso {match2} está vencida',
  'app.pages.notifications.workflow.taskChangedStatus':
    'La tarea {match1} del proceso {match2} ha cambiado de estado {match3} a {match4}',
  'app.pages.notifications.workflow.processStarted': 'El proceso {match1} ha comenzado',
  'app.pages.notifications.workflow.processUpToDateAgain':
    'El proceso {match1} está nuevamente actualizado',
  'app.pages.notifications.workflow.wroteComment':
    '{match1} escribió el siguiente comentario en la tarea {match2} del proceso {match3}: {match4}',
  'app.pages.notifications.title': 'Notificaciones',
  'app.pages.notifications.allNotifications': 'Todas',
  'app.pages.notifications.unReadNotifications': 'Sin leer',
  'app.pages.notifications.noNotifications': 'Sin notificaciones',
  'app.pages.notifications.markAsRead': 'Marcar como leída',
  'app.pages.notifications.maskAsUnread': 'Marcar como no leída',
  'app.pages.notifications.notificationDeleted': 'Notificación eliminada',
  'app.pages.notifications.markAllAsRead': 'Marcar todas como leídas',
  'app.pages.notifications.yesterday': 'Ayer',
  'app.pages.notifications.unreadItem': 'No leída',
  'app.pages.notifications.bellWithUnread': 'Notificaciones: {count} sin leer',
  'app.pages.notifications.moreOptions': 'Más opciones',
  'app.pages.notifications.filter': 'Filtrar',
  'app.pages.notifications.seeAll': 'Ver todas',
  'app.pages.notifications.onlyThisApp': 'Solo esta app ({app})',
  'app.pages.notifications.onlyApp': 'Solo {app}',
  'app.pages.notifications.removeOnlyThisApp': 'Quitar filtro: solo {app}',
  'app.pages.notifications.empty.noneTitle': 'No tenés notificaciones',
  'app.pages.notifications.empty.noneBody':
    'Acá vas a ver los mensajes que te manden y los avisos de procesos y tareas programadas.',
  'app.pages.notifications.empty.noneInAppBody': 'Acá vas a ver los avisos de esta app.',
  'app.pages.notifications.empty.upToDateTitle': 'Estás al día',
  'app.pages.notifications.empty.upToDateBody': 'No tenés notificaciones sin leer.',
  'app.pages.notifications.empty.filteredTitle': 'Nada con este filtro',
  'app.pages.notifications.empty.filteredBody':
    'Probá con otro filtro o mirá todas tus notificaciones.',
  'app.pages.notifications.openApp.title': 'Abrir otra aplicación',
  'app.pages.notifications.openApp.body': 'Para ver esto se abre <b>{app}</b>.',
  'app.pages.notifications.openApp.current': 'Ahora tenés abierta {app}.',
  'app.pages.notifications.openApp.unsavedChanges':
    'Tenés cambios sin guardar en <b>{app}</b>. Si abrís sin guardar, se pierden.',
  'app.pages.notifications.openApp.open': 'Abrir {app}',
  'app.pages.notifications.openApp.saveAndOpen': 'Guardar y abrir',
  'app.pages.notifications.openApp.openWithoutSaving': 'Abrir sin guardar',
  'app.pages.notifications.today': 'Hoy',
  'app.pages.notifications.delete': 'Eliminar',
  'app.pages.notifications.messageDeleted': 'Mensaje eliminado',
  'app.pages.notifications.back': 'Volver',
  'app.pages.notifications.newMessagesHint':
    '{count, plural, one {Tenés # mensaje nuevo} other {Tenés # mensajes nuevos}}',
  'app.pages.notifications.removedUser': 'Usuario eliminado',
  'app.pages.notifications.newMessage': 'Nuevo mensaje',
  'app.pages.notifications.inbox': 'Bandeja',
  'app.pages.notifications.thisApp': 'Esta app',
  'app.pages.notifications.allApps': 'Todas las apps',
  'app.pages.notifications.widget.allowCompose': 'Permitir escribir mensajes',
  'app.pages.notifications.seeAllInBell': 'Ver todas en la campana',
  'app.pages.notifications.tab.received': 'Recibidas',
  'app.pages.notifications.tab.sent': 'Enviados',
  'app.pages.notifications.filter.messages': 'Mensajes',
  'app.pages.notifications.filter.system': 'Sistema',
  'app.pages.notifications.empty.noSentTitle': 'No enviaste mensajes',
  'app.pages.notifications.empty.noSentBody':
    'Con Nuevo mensaje le avisás algo a una persona, a un departamento o a un equipo.',
  'app.pages.notifications.message.title': 'Mensaje',
  'app.pages.notifications.message.to': 'Para {to}',
  'app.pages.notifications.message.goTo': 'Ir a {target}',
  'app.pages.notifications.message.open': 'Abrir',
  'app.pages.notifications.sent.title': 'Mensaje enviado',
  'app.pages.notifications.sent.seenBy': 'Visto por {seen} de {total}',
  'app.pages.notifications.sent.people': 'Personas',
  'app.pages.notifications.sent.groupSeen': '{seen} de {total} lo vieron',
  'app.pages.notifications.sent.seenAt': 'Visto · {when}',
  'app.pages.notifications.sent.pending': 'Pendiente',
  'app.pages.notifications.sent.alsoByEmail': 'También por mail',
  'app.pages.notifications.toast.received': '{sender} te envió un mensaje',
  'app.pages.notifications.toast.see': 'Ver',
  'app.pages.notifications.toast.sent':
    'Mensaje enviado a {count, plural, one {# persona} other {# personas}}',
  'app.pages.notifications.toast.seeSent': 'Ver enviados',
  'app.pages.notifications.section.workflow': 'Mis tareas',
  'app.pages.notifications.section.scheduler': 'Tareas programadas',
  'app.pages.notifications.section.version_manager': 'Versiones',
  'app.pages.notifications.section.scenario_manager': 'Escenarios',
  'app.pages.notifications.section.file_manager': 'Archivos',
  'app.pages.notifications.section.code': 'Código',
  'app.pages.notifications.section.automation_tests': 'Pruebas de automatización',
  'app.pages.notifications.composer.people': 'Personas',
  'app.pages.notifications.composer.departments': 'Departamentos',
  'app.pages.notifications.composer.teams': 'Equipos',
  'app.pages.notifications.composer.members': '{count, plural, one {# miembro} other {# miembros}}',
  'app.pages.notifications.composer.overLimit':
    'Llega a más de {limit} personas. Sacá algún grupo.',
  'app.pages.notifications.composer.noReach': 'Nadie de esta selección puede recibirlo.',
  'app.pages.notifications.composer.noResults': 'Sin resultados para «{query}».',
  'app.pages.notifications.composer.to': 'Para',
  'app.pages.notifications.composer.addMore': 'Agregar más…',
  'app.pages.notifications.composer.toPlaceholder': 'Personas, departamentos o equipos',
  'app.pages.notifications.composer.toHint':
    'Agregá al menos una persona, un departamento o un equipo.',
  'app.pages.notifications.composer.message': 'Mensaje',
  'app.pages.notifications.composer.messagePlaceholder':
    'Escribí el aviso. Por ejemplo: Liberé el plan, revisen la familia Chocolates.',
  'app.pages.notifications.composer.atLimit': 'Llegaste al máximo de 1000 caracteres.',
  'app.pages.notifications.composer.linkTo': 'Vincular a',
  'app.pages.notifications.composer.linkNone': 'Ninguno',
  'app.pages.notifications.composer.linkInterface': 'Interfaz',
  'app.pages.notifications.composer.linkSection': 'Sección',
  'app.pages.notifications.composer.noApp':
    'Para vincular el mensaje a una interfaz o sección, abrí una aplicación. Sin app, se envía solo el texto.',
  'app.pages.notifications.composer.alsoByEmail': 'Enviar también por mail',
  'app.pages.notifications.composer.advanced': 'Opciones avanzadas',
  'app.pages.notifications.composer.linkApp': 'Vincular a esta aplicación ({app})',
  'app.pages.notifications.composer.linkVersion': 'Abrir en esta versión ({version})',
  'app.pages.notifications.composer.send': 'Enviar',
  'app.pages.notifications.reply.label': 'Respuesta',
  'app.pages.notifications.toast.replied': '{sender} respondió tu mensaje',
  'app.pages.notifications.message.replies': 'Respuestas',
  'app.pages.notifications.message.you': 'Vos',
  'app.pages.notifications.message.replyTo': 'Responder a {name}',
  'app.pages.notifications.message.reply': 'Responder',
  'app.pages.notifications.message.unavailable': 'Este mensaje ya no está disponible.',
  'app.pages.notifications.sent.tabReads': 'Lecturas',
  'app.pages.notifications.sent.tabReplies': 'Respuestas',
  'app.pages.notifications.sent.repliesCount':
    '{count, plural, one {# respuesta} other {# respuestas}}',
  'app.pages.notifications.sent.noReplies': 'Todavía no hay respuestas.',

  // AI Agents
  'app.pages.aiAgents.aiAgents': 'Agentes de IA',
  'app.pages.aiAgents.agentsUpdated': 'Agentes disponibles actualizados',
  'app.pages.aiAgents.send': 'Enviar',
  'app.pages.aiAgents.newChat': 'Nuevo chat',
  'app.pages.aiAgents.memorySaved': 'Anoté esto en la memoria de la app:',
  'app.pages.aiAgents.memoryManage': 'Administrar',
  'app.pages.aiAgents.downloadGeneratedFile': 'Descargar este archivo',
  'app.pages.aiAgents.question.answer': 'Respecto a «{question}»:',
  'app.pages.aiAgents.question.multiSelectHint': 'Elegí una o más opciones',
  'app.pages.aiAgents.question.confirm': 'Confirmar',
  'app.pages.aiAgents.question.other': 'Otro',
  'app.pages.aiAgents.question.otherPlaceholder': 'Escribí otra respuesta',
  'app.pages.aiAgents.question.sendOther': 'Enviar respuesta',
  'app.pages.aiAgents.showPrivacyStatement': 'Política de privacidad',
  'app.pages.aiAgents.chatSuccessfullyExported': 'Chat exportado exitosamente',
  'app.pages.aiAgents.dockToTheRight': 'Anclar a la derecha',
  'app.pages.aiAgents.dockToTheLeft': 'Anclar a la izquierda',
  'app.pages.aiAgents.updateAvailableAgents': 'Actualizar agentes disponibles',
  'app.pages.aiAgents.viewTraces': 'Ver trazas',
  'app.pages.aiAgents.pinContextComponent': 'Fijar componente de contexto',
  'app.pages.aiAgents.ask': 'Preguntar',
  'app.pages.aiAgents.askAboutCoding': 'Ingresa tu solicitud de generación de código',
  'app.pages.aiAgents.dictate': 'Dictar',
  'app.pages.aiAgents.inlineNoChanges': 'El agente no propuso cambios para este código.',
  'app.pages.aiAgents.cancelRecording': 'Cancelar',
  'app.pages.aiAgents.uploadFiles': 'Subir archivos',
  'app.pages.aiAgents.addInterfaceComponent': 'Agregar componente de la interfaz',
  'app.pages.aiAgents.pickComponentHint': 'Haz click en un componente para agregarlo al contexto',
  'app.pages.aiAgents.captureScreenArea': 'Capturar sección de pantalla',
  'app.pages.aiAgents.screenCaptureHint':
    'Arrastra para seleccionar el área a capturar. Presiona Esc para cancelar.',
  'app.pages.aiAgents.screenCapturePreparing': 'Preparando la captura...',
  'app.pages.aiAgents.screenCaptureError': 'No se pudo capturar el área seleccionada',
  'app.pages.aiAgents.uploadFilesDescription':
    'Subir archivos para agregar contexto a la conversación',
  'app.pages.aiAgents.filesUploaded': '{count} archivo(s) subido(s) exitosamente',
  'app.pages.aiAgents.contextUsageTooltip':
    'Uso de contexto: {percent}% ({used} de {budget} tokens). Al llegar al 100% la conversación se compacta automáticamente, resumiendo los mensajes más antiguos.',
  'app.pages.aiAgents.compactNow': 'Compactar conversación',
  'app.pages.aiAgents.compactingSession': 'Compactando conversación...',
  'app.pages.aiAgents.invalidFileType':
    'Los archivos permitidos tienen que tener extensión: {extensions}',
  'app.pages.aiAgents.fileTooLarge':
    'El archivo "{fileName}" excede el tamaño máximo de {maxSize}MB',
  'app.pages.aiAgents.codeAssistant': 'Mostrar/ocultar asistente de código',
  'app.pages.aiAgents.unknownCodeClassification':
    'Solo puedo responder preguntas de código sobre Python.',
  'app.pages.aiAgents.sessionHistory': 'Historial de sesiones',
  'app.pages.aiAgents.restoreInterfaceChanges':
    'También revertir los cambios de la interfaz hasta este punto',
  'app.pages.aiAgents.noSessionHistory': 'No hay sesiones anteriores',
  'app.pages.aiAgents.disabledInSection': 'Este agente está deshabilitado en esta sección',
  'app.pages.aiAgents.disabledRequiresAppOpen': 'Este agente necesita una aplicación abierta',
  'app.pages.aiAgents.aiDisabledTitle': 'Las funcionalidades de IA no están activadas',
  'app.pages.aiAgents.aiDisabledDescription':
    'Las funcionalidades de IA no están activadas para esta empresa. Contacta a tu administrador para activarlas en AI Settings.',
  'app.pages.aiAgents.aiDisabledPlaceholder': 'Las funcionalidades de IA no están activadas',
  'app.pages.aiAgents.customAgentsDisabledTitle': 'Este agente no está activado',
  'app.pages.aiAgents.customAgentsDisabledDescription':
    'Los agentes personalizados no están activados para esta empresa, así que los agentes definidos dentro de esta aplicación no se pueden usar. Elige el agente Pyplan para seguir trabajando, o pídele a tu administrador que los active en AI Settings.',
  'app.pages.aiAgents.customAgentsDisabledPlaceholder':
    'Este agente no está activado para tu empresa',
  'app.pages.aiAgents.tokenUsageMenuItem': 'Tokens de IA este mes: {used} de {limit} ({percent}%)',
  'app.pages.aiAgents.tokenLimitReachedPlaceholder': 'Límite mensual de tokens de IA alcanzado',
  'app.pages.aiAgents.tokenLimitReachedTitle': 'Límite mensual de tokens de IA alcanzado',
  'app.pages.aiAgents.tokenLimitReachedDescription':
    'Esta empresa ya usó todos los tokens de IA de este mes. Contacta a tu administrador para aumentar o quitar el límite.',
  'app.pages.aiAgents.tokenUsageTooltip':
    'Estás por alcanzar tu límite de tokens de IA: {used} usados de {limit} ({percent}%)',
  'app.pages.aiAgents.tokenUsageAtLimitTooltip':
    'Alcanzaste tu límite de tokens de IA: {used} usados de {limit}. La IA no está disponible hasta el mes próximo o hasta que un administrador aumente el límite.',
  'app.pages.aiAgents.renameSession': 'Renombrar sesión',
  'app.pages.aiAgents.deleteSession': 'Eliminar sesión',
  'app.pages.aiAgents.editConversation': 'Editar conversación',
  'app.pages.aiAgents.restoreConversation': 'Restaurar conversación',
  'app.pages.aiAgents.restoreCheckpointConfirmation':
    'El mensaje seleccionado volverá al input y se eliminarán ese mensaje y todos los posteriores de la conversación. ¿Quieres continuar?',
  'app.pages.aiAgents.untitledSession': 'Sesión {date}',
  'app.pages.aiAgents.messages': 'mensajes',
  'app.pages.aiAgents.assistantComponentDeprecated': 'El componente de Asistente está obsoleto',

  // Secrets manager
  'app.pages.secretsManager.secretManager': 'Secretos',
  'app.pages.secretsManager.createSecret': 'Crear secreto',
  'app.pages.secretsManager.editSecret': 'Editar secreto',
  'app.pages.secretsManager.deleteSecret': 'Eliminar secreto',
  'app.pages.secretsManager.deleteSecretConfirmation':
    '¿Estás seguro de querer eliminar este secreto?',
  'app.pages.secretsManager.secretDeleted': 'Secreto eliminado',
  'app.pages.secretsManager.secretUpdated': 'Secreto actualizado',
  'app.pages.secretsManager.secretCreated': 'Secreto creado',
  'app.pages.secretsManager.secretKey': 'Clave del secreto',
  'app.pages.secretsManager.secretValue': 'Valor del secreto',
  'app.pages.secretsManager.noSecrets': 'No hay secretos',
  'app.pages.secretsManager.secret': 'Secreto',
  'app.pages.secretsManager.allUsers': 'Todos los usuarios',
  'app.pages.secretsManager.showSecretValue': 'Mostrar valor del secreto',
  'app.pages.secretsManager.hideSecretValue': 'Ocultar valor del secreto',
  'app.pages.secretsManager.secretKeyExists': 'La clave del secreto ya existe',
  'app.pages.secretsManager.system': 'Sistema',

  // Application Analysis
  'app.pages.appAnalysis.analysisConfiguration': 'Configuración de análisis',
  'app.pages.appAnalysis.detectNodesWithLargeDefinition': 'Detectar nodos con definición grande',
  'app.pages.appAnalysis.detectingNodesWithLargeDefinition':
    'Detectando nodos con definición grande',
  'app.pages.appAnalysis.detectingNodesWithDeprecatedType': 'Detectando nodos con tipo deprecado',
  'app.pages.appAnalysis.detectingNotUsedNodes': 'Detectando nodos no utilizados',
  'app.pages.appAnalysis.detectingAliasNodesWithoutOriginal':
    'Detectando nodos alias sin nodo original',
  'app.pages.appAnalysis.detectingEmptyModules': 'Detectando módulos vacíos',
  'app.pages.appAnalysis.detectingMultiDimensionalDataArray':
    'Detectando dataarrays multidimensionales',
  'app.pages.appAnalysis.detectingLargeNodesEvaluationTime':
    'Detectando nodos con tiempo de evaluación grande',
  'app.pages.appAnalysis.detectingLargeInterfaces': 'Detectando interfaces grandes',
  'app.pages.appAnalysis.nodesWithLargeDefinitionDetected':
    'Nodos con definición grande detectados',
  'app.pages.appAnalysis.largeDefinitionNotFound':
    'No se detectaron nodos con más de 50 líneas de código',
  'app.pages.appAnalysis.largeDefinitionFound':
    'Se detectaron {count} nodos con más de 50 líneas de código',
  'app.pages.appAnalysis.detectNodesWithDeprecatedType': 'Detectar nodos con tipo deprecado',
  'app.pages.appAnalysis.nodesWithDeprecatedTypeDetected': 'Nodos con tipo deprecado detectados',
  'app.pages.appAnalysis.deprecatedTypeNotFound': 'No se detectaron nodos con tipos obsoletos',
  'app.pages.appAnalysis.deprecatedTypeFound': 'Se detectaron {count} nodos con tipos obsoletos',
  'app.pages.appAnalysis.detectNotUsedNodes': 'Detectar nodos no utilizados',
  'app.pages.appAnalysis.notUsedNodesDetected': 'Nodos no utilizados detectados',
  'app.pages.appAnalysis.notUsedNodesNotFound': 'No se detectaron nodos sin utilizar',
  'app.pages.appAnalysis.notUsedNodesFound': 'Se detectaron {count} nodos sin utilizar',
  'app.pages.appAnalysis.detectAliasNodesWithoutOriginal': 'Detectar nodos alias sin nodo original',
  'app.pages.appAnalysis.aliasNodesWithoutOriginalDetected':
    'Nodos alias sin nodo original detectados',
  'app.pages.appAnalysis.aliasNodesWithoutOriginalNotFound':
    'No se detectaron nodos alias sin nodo original',
  'app.pages.appAnalysis.aliasNodesWithoutOriginalFound':
    'Se detectaron {count} nodos alias sin nodo original',
  'app.pages.appAnalysis.detectEmptyModules': 'Detectar módulos vacíos',
  'app.pages.appAnalysis.emptyModulesDetected': 'Módulos vacíos detectados',
  'app.pages.appAnalysis.emptyModulesNotFound': 'No se detectaron módulos vacíos',
  'app.pages.appAnalysis.emptyModulesFound': 'Se detectaron {count} módulos vacíos',
  'app.pages.appAnalysis.detectNodesWithNonExistingModule': 'Detectar nodos con módulo inexistente',
  'app.pages.appAnalysis.nodesWithNonExistingModuleDetected':
    'Nodos con módulo inexistente detectados',
  'app.pages.appAnalysis.nonExistingModuleNotFound':
    'No se detectaron nodos con módulo inexistente',
  'app.pages.appAnalysis.nonExistingModuleFound':
    'Se detectaron {count} nodos con módulo inexistente',
  'app.pages.appAnalysis.detectMultiDimensionalDataArray':
    'Detectar dataarrays multidimensionales con más de: ',
  'app.pages.appAnalysis.multiDimensionalDataArrayDetected':
    'Dataarrays multidimensionales detectados',
  'app.pages.appAnalysis.multiDimensionalDataArrayNotFound':
    'No se detectaron data arrays con más de {dimensions} dimensiones',
  'app.pages.appAnalysis.multiDimensionalDataArrayFound':
    'Se detectaron {count} data arrays con más de {dimensions} dimensiones',
  'app.pages.appAnalysis.detectLargeNodesEvaluationTime':
    'Detectar nodos con tiempo de evaluación grande',
  'app.pages.appAnalysis.largeNodesEvaluationTimeDetected':
    'Nodos con tiempo de evaluación grande detectados',
  'app.pages.appAnalysis.largeNodesEvaluationTimeNotFound':
    'No se detectaron nodos con tiempo de evaluación mayor a 5 segundos',
  'app.pages.appAnalysis.largeNodesEvaluationTimeGreaterThan5':
    'Se encontraron nodos con tiempos de evaluación mayores a 5 segundos',
  'app.pages.appAnalysis.largeNodesEvaluationTimeGreaterThan10':
    'Se encontraron nodos con tiempos de evaluación mayores a 10 segundos',
  'app.pages.appAnalysis.largeNodesEvaluationTimeGreaterThan20':
    'Se encontraron nodos con tiempos de evaluación mayores a 20 segundos',
  'app.pages.appAnalysis.detectLargeInterfaces': 'Detectar interfaces grandes',
  'app.pages.appAnalysis.largeInterfacesDetected': 'Interfaces grandes detectadas',
  'app.pages.appAnalysis.largeInterfacesNotFound':
    'No se detectaron interfaces con más de 10 componentes',
  'app.pages.appAnalysis.largeInterfacesMoreThan10':
    'Se detectaron interfaces con más de 10 componentes',
  'app.pages.appAnalysis.largeInterfacesLonger':
    'Se detectaron interfaces con más de 15 componentes',
  'app.pages.appAnalysis.detectLargeApplicationSize': 'Detectar tamaño de aplicación grande',
  'app.pages.appAnalysis.largeApplicationSizeDetected': 'Tamaño de aplicación grande detectado',
  'app.pages.appAnalysis.largeApplicationSizeNotFound':
    'El tamaño de la aplicación es inferior a 1GB',
  'app.pages.appAnalysis.largeApplicationSizeGreaterThan1GB':
    'El tamaño de la aplicación es superior a 1GB',
  'app.pages.appAnalysis.detectLargeAppVersions': 'Detectar versiones de aplicación grandes',
  'app.pages.appAnalysis.largeAppVersionsDetected': 'Versiones de aplicación grandes detectadas',
  'app.pages.appAnalysis.largeAppVersionsNotFound':
    'No se detectaron versiones de la aplicación con más de 200MB de datos',
  'app.pages.appAnalysis.largeAppVersionsGreaterThan200MB':
    'Se detectaron versiones de la aplicación con más de 200MB de datos',
  'app.pages.appAnalysis.detectDashComponents': 'Detectar componentes Dash',
  'app.pages.appAnalysis.dashComponentsDetected': 'Componentes Dash detectados',
  'app.pages.appAnalysis.dashComponentsNotFound': 'No se detectaron componentes Dash',
  'app.pages.appAnalysis.interfaceWithDashComponentsFound':
    'Se detectaron {count} interfaces con componentes Dash',
  'app.pages.appAnalysis.runningAnalysis': 'Ejecutando análisis',
  'app.pages.appAnalysis.analysisReport': 'Reporte de análisis',
  'app.pages.appAnalysis.runAnalysis': 'Ejecutar análisis',
  'app.pages.appAnalysis.newAnalysis': 'Nuevo análisis',
  'app.pages.appAnalysis.analysisDate': 'Fecha de análisis',
  'app.pages.appAnalysis.countOfLines': 'Cantidad de líneas',
  'app.pages.appAnalysis.nodeClass': 'Clase de nodo',
  'app.pages.appAnalysis.evaluationTime': 'Tiempo de evaluación',
  'app.pages.appAnalysis.countOfComponents': 'Cantidad de componentes',
  'app.pages.appAnalysis.nodesMustBeCalculated':
    'Los nodos deben estar calculados para realizar este análisis',
  'app.pages.appAnalysis.copyAllAnalysisData': 'Copiar todos los datos de análisis',
  'app.pages.appAnalysis.exportAnalysisCsv': 'Exportar análisis como CSV',
  'app.pages.appAnalysis.exportAnalysisExcel': 'Exportar análisis como Excel',
  'app.pages.appAnalysis.analysisReportDownloaded': 'Reporte de análisis descargado',
  'app.pages.appAnalysis.applicationSize': 'Tamaño de la aplicación',
  'app.pages.appAnalysis.versionSize': 'Tamaño de la versión',
  'app.pages.appAnalysis.componentName': 'Nombre del componente',
  'app.pages.appAnalysis.versionPath': 'Ruta de la versión',
  'app.pages.appAnalysis.applicationPath': 'Ruta de la aplicación',
  'app.pages.appAnalysis.detectBadPractices':
    'Detectar posibles malas prácticas en definiciones de nodos',
  'app.pages.appAnalysis.detectBadPracticesInfo':
    'Informa el uso de self.model e invalidaciones manuales (invalidate, silentInvalidate, invalidateOutputs, invalidate_nodes) en las definiciones de los nodos. Son advertencias para revisar: algunos usos, como en nodos botón o flujos de carga de datos, son legítimos',
  'app.pages.appAnalysis.badPracticesDetected': 'Posibles malas prácticas en definiciones de nodos',
  'app.pages.appAnalysis.badPracticesNotFound':
    'No se detectaron malas prácticas en las definiciones de los nodos',
  'app.pages.appAnalysis.badPracticesFound':
    'Se detectaron {count} posibles malas prácticas en las definiciones de los nodos. Revísalas: algunos usos pueden ser legítimos',
  'app.pages.appAnalysis.practice': 'Práctica',
  'app.pages.appAnalysis.lines': 'Líneas',
  'app.pages.appAnalysis.practiceSelfModel': 'Uso de self.model',
  'app.pages.appAnalysis.practiceManualInvalidation': 'Invalidación manual',

  //Upload manager
  'app.pages.app.uploadmanager.showBaseFile': 'Mostrar archivo base',
  'app.pages.app.uploadmanager.showCurrentFile': 'Mostrar archivo actual',
  'app.pages.app.uploadmanager.showLastModifiedDate': 'Mostrar última fecha de modificación',
  'app.pages.app.uploadmanager.showLastModifiedUser': 'Mostrar último usuario que modificó',
  'app.pages.app.uploadmanager.addNewFileUploadItem': 'Agregar nuevo elemento de carga de archivo',
  'app.pages.app.uploadmanager.baseFilePath': 'Path archivo base',
  'app.pages.app.uploadmanager.currentFilePath': 'Path archivo existente',
  'app.pages.app.uploadmanager.validationNode': 'Nodo de validación (opcional)',
  'app.pages.app.uploadmanager.callbackNode': 'Nodo de callback (opcional)',
  'app.pages.app.uploadmanager.invalidateNode': 'Nodo a invalidar (opcional)',
  'app.pages.app.uploadmanager.runNodesOnRestore':
    'Ejecutar nodos de callback e invalidación al restaurar un archivo del historial',
  'app.pages.app.uploadmanager.historyCount': 'Cantidad de históricos',
  'app.pages.app.uploadmanager.autoValidationTitle': 'Validación automática según archivo base',
  'app.pages.app.uploadmanager.toggleValidationOptions': 'Mostrar/ocultar validación automática',
  'app.pages.app.uploadmanager.validateSheets': 'Validar hojas',
  'app.pages.app.uploadmanager.validateColumnNames': 'Validar nombres de columnas',
  'app.pages.app.uploadmanager.validateColumnTypes': 'Validar tipos de columnas',
  'app.pages.app.uploadmanager.preserveExistingFilename': 'Preservar nombre de archivo existente',
  'app.pages.app.uploadmanager.historyPath': 'Path para guardar historial (opcional)',
  'app.pages.app.uploadmanager.navigateToInterface': 'Navegar a interfaz (opcional)',
  'app.pages.app.uploadmanager.displayOptionsTitle': 'Opciones de visualización',
  'app.pages.app.uploadmanager.toggleDisplayOptions': 'Mostrar/ocultar opciones de visualización',
  'app.pages.app.uploadmanager.showBaseDownload': 'Mostrar botón de descarga del archivo base',
  'app.pages.app.uploadmanager.showUpload': 'Mostrar botón de subir archivo',
  'app.pages.app.uploadmanager.showDownload': 'Mostrar botón de descarga',
  'app.pages.app.uploadmanager.showHistory': 'Mostrar historial de archivos',
  'app.pages.app.uploadmanager.accessTitle': 'Acceso',
  'app.pages.app.uploadmanager.toggleAccessOptions': 'Mostrar/ocultar opciones de acceso',
  'app.pages.app.uploadmanager.accessDescription':
    'Quién puede ver y cargar este archivo. Los usuarios que pueden editar interfaces también lo ven en modo edición.',
  'app.pages.app.uploadmanager.accessEveryone': 'Todos',
  'app.pages.app.uploadmanager.accessByDepartments': 'Por departamentos',
  'app.pages.app.uploadmanager.accessByUsers': 'Por usuarios',
  'app.pages.app.uploadmanager.accessDepartments': 'Departamentos',
  'app.pages.app.uploadmanager.accessUsers': 'Usuarios',
  'app.pages.app.uploadmanager.accessDepartmentsRequired': 'Selecciona al menos un departamento',
  'app.pages.app.uploadmanager.accessUsersRequired': 'Selecciona al menos un usuario',
  'app.pages.app.uploadmanager.accessDepartmentsUnavailable':
    'No se pudieron cargar los departamentos. Configurados: {departments}',
  'app.pages.app.uploadmanager.accessUnknownUser': 'Usuario no encontrado ({id})',
  'app.pages.app.uploadmanager.restrictedAccess': 'Acceso restringido',
  'app.pages.app.uploadmanager.restrictedAccessDepartments': 'Departamentos ({count})',
  'app.pages.app.uploadmanager.restrictedAccessUsers': 'Usuarios ({count})',
  'app.pages.app.uploadmanager.restrictedAccessMore': '+{count} más',
  'app.pages.app.uploadmanager.restrictedAccessNone': 'Nadie asignado',
  'app.pages.app.uploadmanager.restrictedAccessLoading': 'Cargando...',
  'app.pages.app.uploadmanager.selectHistoryPath': 'Seleccionar path de historial',
  'app.pages.app.uploadmanager.downloadBaseFile': 'Descargar archivo base',
  'app.pages.app.uploadmanager.uploadFile': 'Subir archivo',
  'app.pages.app.uploadmanager.downloadFile': 'Descargar archivo',
  'app.pages.app.uploadmanager.selectInterfaceForNavigation':
    'Seleccionar interfaz para navegación',
  'app.pages.app.uploadmanager.validatigFile': 'Validando archivo',
  'app.pages.app.uploadmanager.basePathModeForFiles': 'Modo de ruta base para archivos',
  'app.pages.app.uploadmanager.relativeToApplication': 'Relativo a la aplicación',
  'app.pages.app.uploadmanager.relativeToVersion': 'Relativo a la versión',
  'app.pages.app.uploadmanager.viewHistory': 'Ver historial',
  'app.pages.app.uploadmanager.fileRestored': 'Archivo restaurado',
  'app.pages.app.uploadmanager.fileRestoreError': 'Error al restaurar el archivo',
  'app.pages.app.uploadmanager.fileRestoredWithErrors': 'Archivo restaurado con errores',
  'app.pages.app.uploadmanager.historyFiles': 'Archivos históricos',
  'app.pages.app.uploadmanager.restoringFile': 'Restaurando archivo',
  'app.pages.app.uploadmanager.noHistoryFiles': 'No se encontraron archivos históricos',
  'app.pages.app.uploadmanager.restoreFile': 'Restaurar archivo',
  'app.pages.app.uploadmanager.confirmRestoreTitle': 'Confirmar restauración de archivo',
  'app.pages.app.uploadmanager.confirmRestoreContent':
    '¿Estás seguro de querer restaurar el archivo? Esto sobrescribirá el archivo actual con el archivo histórico seleccionado.',
  'app.pages.app.uploadmanager.downloadAllFiles': 'Descargar todos los archivos',
  'app.pages.app.uploadmanager.fileDownloaded': 'Archivo descargado',
  'app.pages.app.uploadmanager.fileDownloadError': 'Error al descargar el archivo',
  'app.pages.app.uploadmanager.confirmDeleteMessage':
    '¿Estás seguro de eliminar este elemento de carga de archivo? Esto eliminará el archivo y su historial asociado.',
  'app.pages.app.uploadmanager.noUploadItems': 'No hay elementos de carga de archivos',
  'app.pages.app.uploadmanager.baseFile': 'Archivo base',
  'app.pages.app.uploadmanager.additionalInformationOfFile': 'Información adicional del archivo',
  'app.pages.app.uploadmanager.fileSize': 'Tamaño del archivo',
  'app.pages.app.uploadmanager.showFileSize': 'Mostrar tamaño del archivo',
  'app.pages.app.uploadmanager.removeFile': 'Eliminar archivo',
  'app.pages.app.uploadmanager.fileRemoved': 'Archivo eliminado',
  'app.pages.app.uploadmanager.fileRemoveError': 'Error al eliminar el archivo',
  'app.pages.app.uploadmanager.confirmRemoveTitle': 'Confirmar eliminación de archivo',
  'app.pages.app.uploadmanager.confirmRemoveContent':
    '¿Estás seguro de que deseas eliminar el archivo? Esta acción no se puede deshacer.',
  'app.pages.app.uploadmanager.useFolderPath': 'Usar ruta de carpeta',
  'app.pages.app.uploadmanager.currentFolderPath': 'Ruta de carpeta actual',
  'app.pages.app.uploadmanager.viewFolderFiles': 'Ver archivos de la carpeta',
  'app.pages.app.uploadmanager.folderFiles': 'Archivos de la carpeta',
  'app.pages.app.uploadmanager.loadingFiles': 'Cargando archivos de la carpeta...',
  'app.pages.app.uploadmanager.filePathMustBeFile':
    'La ruta del archivo debe apuntar a un archivo, no a una carpeta',
  'app.pages.app.uploadmanager.selectFileModeFile': 'Seleccionar modo de archivo',
  'app.pages.app.uploadmanager.selectFileModeFolder': 'Seleccionar modo de carpeta',
  'app.pages.app.uploadmanager.noFilesInFolder': 'No se encontraron archivos en la carpeta',
  'app.pages.app.uploadmanager.validationStartRow': 'Fila de inicio de validación',
  'app.pages.app.uploadmanager.unknownError': 'Error desconocido',
  'app.pages.app.uploadmanager.Temporary_file_does_not_exist': 'El archivo temporal no existe',
  'app.pages.app.uploadmanager.Base_file_extension_mismatch':
    'La extensión del archivo base no coincide',
  'app.pages.app.uploadmanager.Validation_node_failed': 'El nodo de validación falló',
  'app.pages.app.uploadmanager.Validation_node_not_callable':
    'El nodo de validación no es llamable',
  'app.pages.app.uploadmanager.Base_file_does_not_exist': 'El archivo base no existe',
  'app.pages.app.uploadmanager.Sheet_names_do_not_match': 'Los nombres de las hojas no coinciden',
  'app.pages.app.uploadmanager.Both_files_must_be_excel':
    'Ambos archivos deben ser archivos de Excel',
  'app.pages.app.uploadmanager.Column_names_do_not_match':
    'Los nombres de las columnas no coinciden',
  'app.pages.app.uploadmanager.Column_type_mismatch': 'Incompatibilidad de tipo de columna',
  'app.pages.app.uploadmanager.Uploaded_file_missing_columns':
    'Al archivo subido le faltan columnas',
  'app.pages.app.uploadmanager.Uploaded_file_extra_columns':
    'El archivo subido tiene columnas adicionales',
  'app.pages.app.uploadmanager.History_directory_does_not_exist':
    'El directorio de historial no existe',
  'app.pages.app.uploadmanager.Failed_to_move_file': 'Error al mover el archivo',
  'app.pages.app.uploadmanager.Callback_node_not_callable': 'El nodo de callback no es llamable',
  'app.pages.app.uploadmanager.Callback_node_failed': 'Error al ejecutar el nodo de callback',
  'app.pages.app.uploadmanager.Invalidate_node_failed': 'Error al invalidar el nodo',
  'app.pages.app.uploadmanager.File_uploaded_successfully': 'Archivo subido con éxito',
  'app.pages.app.uploadmanager.Upload_item_not_found':
    'El ítem de archivo ya no existe en este componente',
  'app.pages.app.uploadmanager.Upload_item_access_denied':
    'No tienes acceso para cargar este archivo',

  // AI Agents
  'app.aiAgents.agentStatus.WAITING': 'Esperando',
  'app.aiAgents.agentStatus.REASONING': 'Razonando',
  'app.aiAgents.agentStatus.SEARCHING': 'Buscando',
  'app.aiAgents.agentStatus.GENERATING': 'Generando',
  'app.aiAgents.agentStatus.RESPONDING': 'Respondiendo',
  'app.aiAgents.agentStatus.USING_TOOL': 'Usando herramienta',
  'app.aiAgents.agentStatus.EXECUTING_TOOL': 'Ejecutando herramienta',
  'app.aiAgents.agentStatus.COMPLETED': 'Completado',
  'app.aiAgents.agentStatus.INDEXING_DOCUMENTS': 'Indexando documentos',
  'app.aiAgents.agentStatus.EXECUTING_CONTEXT_NODES': 'Ejecutando nodos de contexto',
  'app.aiAgents.agentStatus.COMPACTING': 'Compactando',
  'app.aiAgents.reasoning.title': 'Razonamiento',
  'app.aiAgents.toolCall.used': 'Herramienta usada:',
  'app.aiAgents.activity.working': 'Trabajando…',
  'app.aiAgents.activity.reasoning': 'razonando',
  'app.aiAgents.activity.steps': '{count, plural, one {# paso} other {# pasos}}',
  'app.aiAgents.activity.reasoned': 'Razonó',
  'app.pages.aiSettings.title': 'Configuración de IA',
  'app.pages.aiSkills.title': 'Skills y memoria',
  'app.pages.mcpUsage.title': 'Uso de MCP',
  'app.pages.mcpUsage.client': 'Cliente',
  'app.pages.mcpUsage.action': 'Acción',
  'app.pages.mcpUsage.application': 'Aplicación',
  'app.pages.mcpUsage.result': 'Resultado',
  'app.pages.mcpUsage.detail': 'Detalle',
  'app.pages.mcpUsage.noEvents': 'No hay actividad MCP registrada para estos filtros',
  'app.pages.mcpUsage.includeInternal': 'Incluir asistente interno',
  'app.pages.mcpUsage.includeInternalHint':
    'El asistente de Pyplan usa los mismos endpoints MCP. Se oculta por defecto para que esta página muestre solo los clientes externos.',
  'app.pages.mcpUsage.outcome.ok': 'OK',
  'app.pages.mcpUsage.outcome.denied': 'Denegado',
  'app.pages.mcpUsage.outcome.invalid': 'Inválido',
  'app.pages.mcpUsage.outcome.gone': 'App cerrada',
  'app.pages.mcpUsage.outcome.unavailable': 'IA apagada',
  'app.pages.mcpUsage.outcome.error': 'Error',
  'app.pages.mcpUsage.clientType.mcpToken': 'Cliente MCP',
  'app.pages.mcpUsage.clientType.pat': 'Token de acceso',
  'app.pages.mcpUsage.clientType.session': 'Sesión de Pyplan',
  'app.pages.mcpUsage.clientType.internal': 'Asistente interno',
  'app.pages.mcpUsage.clientType.unknown': 'Desconocido',
  'app.pages.mcpUsage.summary': 'Resumen',
  'app.pages.mcpUsage.totalCalls': 'Llamadas',
  'app.pages.mcpUsage.activeUsers': 'Usuarios',
  'app.pages.mcpUsage.appsTouched': 'Aplicaciones',
  'app.pages.mcpUsage.errorRate': 'Tasa de error',
  'app.pages.mcpUsage.deniedRate': 'Denegadas',
  'app.pages.mcpUsage.writeRate': 'Escrituras',
  'app.pages.mcpUsage.errorRateHint': 'Llamadas que fallaron dentro de Pyplan ({count} de {total})',
  'app.pages.mcpUsage.deniedRateHint':
    'Llamadas rechazadas por falta de permisos ({count} de {total})',
  'app.pages.mcpUsage.writeRateHint':
    'Llamadas a tools que modifican la aplicación ({count} de {total})',
  'app.pages.mcpUsage.topTools': 'Tools más usadas',
  'app.pages.mcpUsage.failingTools': 'Tools que más fallan',
  'app.pages.mcpUsage.topClients': 'Clientes',
  'app.pages.mcpUsage.topUsers': 'Usuarios',
  'app.pages.mcpUsage.topApps': 'Aplicaciones',
  'app.pages.mcpUsage.topEndpoints': 'Operaciones',
  'app.pages.mcpUsage.topSkills': 'Skills más cargadas',
  'app.pages.mcpUsage.activity': 'Actividad',
  'app.pages.mcpUsage.failedLabel': '{count} fallidas',
  'app.pages.mcpUsage.noData': 'Sin datos',
  'app.pages.mcpUsage.showSummary': 'Mostrar resumen',
  'app.pages.mcpUsage.hideSummary': 'Ocultar resumen',
  'app.pages.mcpUsage.showMoreIndicators': 'Más indicadores',
  'app.pages.mcpUsage.hideMoreIndicators': 'Menos indicadores',
  'app.pages.aiCosts.title': 'Costos de IA',
  'app.pages.aiCosts.periodFrom': 'Desde',
  'app.pages.aiCosts.periodTo': 'Hasta',
  'app.pages.aiCosts.clearFilters': 'Limpiar filtros',
  'app.pages.aiCosts.exportCsv': 'Exportar CSV',
  'app.pages.aiCosts.exportCsvTooltip': 'Una línea por empresa, mes, atribución y modelo',
  'app.pages.aiCosts.unpricedSuffix': '{tokens} sin tarifa',
  'app.pages.aiCosts.company': 'Empresa',
  'app.pages.aiCosts.period': 'Período',
  'app.pages.aiCosts.clientCost': 'Facturable al cliente',
  'app.pages.aiCosts.internalCost': 'Interno',
  'app.pages.aiCosts.totalCost': 'Total',
  'app.pages.aiCosts.totalsAllRows': 'Total — {count} filas en total',
  'app.pages.aiCosts.tokens': 'Tokens',
  'app.pages.aiCosts.runs': 'Ejecuciones',
  'app.pages.aiCosts.noData': 'No hay consumo de IA registrado para este período.',
  'app.pages.aiCosts.unpricedWarningTitle': 'Estos montos están subestimados',
  'app.pages.aiCosts.unpricedWarningBody':
    'Algunos modelos consumieron tokens sin tarifa configurada, así que se costearon en cero. Carga sus tarifas en AI Pricing y los montos van a ser correctos desde ese momento — el consumo pasado queda en cero.',
  'app.pages.aiCosts.unpricedModelLine': '{model} ({provider}): {tokens} tokens — {companies}',
  'app.pages.aiCosts.internalNote':
    'El consumo interno viene de los dominios de email habilitados en AI Settings. No es facturable y no consume la cuota de la empresa.',
  'app.pages.aiCosts.modelBreakdown': 'Desglose por modelo',
  'app.pages.aiCosts.model': 'Modelo',
  'app.pages.aiCosts.attribution': 'Atribución',
  'app.pages.aiCosts.invalidPeriod': 'Usa el formato YYYY-MM',
  'app.pages.aiSkills.newSkill': 'Nuevo skill',
  'app.pages.aiSkills.editSkill': 'Editar skill',
  'app.pages.aiSkills.deleteConfirmMessage': '¿Estás seguro de que deseas eliminar este skill?',
  'app.pages.aiSkills.noSkillsFound': 'No se encontraron skills',
  'app.pages.aiSkills.noAppOpenMessage':
    'Abre una aplicación para ver y administrar sus skills. Por ahora solo se muestran los skills de la empresa.',
  'app.pages.aiSkills.name': 'Nombre',
  'app.pages.aiSkills.level': 'Nivel',
  'app.pages.aiSkills.category': 'Categoría',
  'app.pages.aiSkills.content': 'Contenido (SKILL.md)',
  'app.pages.aiSkills.levelCompany': 'Empresa',
  'app.pages.aiSkills.levelApp': 'Aplicación',
  'app.pages.aiSkills.nameHelp': 'Letras, números, espacios, guiones, guiones bajos y puntos.',
  'app.pages.aiSkills.back': 'Volver a skills',
  'app.pages.aiSkills.import': 'Importar',
  'app.pages.aiSkills.export': 'Exportar',
  'app.pages.aiSkills.deleteConfirmTitle': 'Confirmar eliminación',
  'app.pages.aiSkills.successDeleted': 'Eliminado correctamente',
  'app.pages.aiSkills.successCreated': 'Creado correctamente',
  'app.pages.aiSkills.successUpdated': 'Actualizado correctamente',
  'app.pages.aiSkills.fieldRequired': 'Campo requerido',
  'app.pages.aiSkills.tabSkills': 'Skills',
  'app.pages.aiSkills.tabMemory': 'Memoria',
  'app.pages.aiSkills.newMemory': 'Nueva memoria',
  'app.pages.aiSkills.editMemory': 'Editar memoria',
  'app.pages.aiSkills.deleteMemoryConfirmMessage':
    '¿Estás seguro de que quieres eliminar esta memoria?',
  'app.pages.aiSkills.noMemoriesFound': 'Esta aplicación todavía no aprendió nada',
  'app.pages.aiSkills.memoryText': 'Memoria',
  'app.pages.aiSkills.memoryAgent': 'Agente',
  'app.pages.aiSkills.memoryAgentHelp':
    'Solo la lee este agente. Cada agente tiene su propia memoria.',
  'app.pages.aiSkills.memoryUpdated': 'Actualizada',
  'app.pages.aiSkills.memoryStaleHint': 'Hace mucho que no se toca. Revisa si sigue siendo cierta.',
  'app.pages.aiSkills.memoryTextHelp':
    'Una indicación sobre cómo trabajar en esta app. {count}/{max}',
  'app.pages.aiSkills.memoryTooLong': 'Una memoria puede tener como máximo {max} caracteres',
  'app.pages.aiSkills.memoryCountForAgent': '{count} de {max} memorias de {agent}',
  'app.pages.aiSkills.memoryCountAllAgents':
    '{count, plural, one {# memoria} other {# memorias}} en {agents, plural, one {# agente} other {# agentes}}',
  'app.pages.aiSkills.allAgents': 'Todos',
  'app.pages.aiSkills.categoryWorkflow': 'Forma de trabajo',
  'app.pages.aiSkills.memoryAppliesTo': 'Se aplica en',
  'app.pages.aiSkills.memoryAppliesToHelp': 'Solo se le pasa al chat mientras se trabaja ahí.',
  'app.pages.aiSkills.sectionAll': 'Todas las secciones',
  'app.pages.aiSkills.sectionCode': 'Diagrama y código',
  'app.pages.aiSkills.sectionInterfaces': 'Interfaces',
  'app.pages.aiSkills.memoryOrigin': 'Aprendida de {source}, en la conversación',
  'app.pages.aiSkills.sourceRework': 'haber tenido que rehacer el trabajo',
  'app.pages.aiSkills.sourceCorrection': 'una corrección',
  'app.pages.aiSkills.sourceFailure': 'fallas repetidas',
  'app.pages.aiSkills.sourceUserRequest': 'un pedido explícito',
  'app.pages.aiSkills.categoryStyle': 'Estilo',
  'app.pages.aiSkills.categoryPitfall': 'Error frecuente',
  'app.pages.aiSkills.noAppOpenMemoryMessage':
    'Abre una aplicación para ver y administrar su memoria.',
  'app.pages.aiSkills.memoryDisabledMessage':
    'La memoria está apagada para esta empresa, así que los agentes no la leen ni la escriben. Las memorias de abajo se conservan y se van a volver a usar si la activas.',
  'app.pages.aiSettings.currentCompany': 'Compañía actual',
  'app.pages.aiSettings.agentPreferencesTab': 'Preferencias de agentes',
  'app.pages.aiSettings.appTranslationsTab': 'Traducciones de la app',
  'app.pages.aiSettings.appTranslationsDefault': 'Parámetros de traducción',
  'app.pages.aiSettings.appTranslationsSaveSuccess':
    'La configuración de traducciones se guardó correctamente',
  'app.pages.aiSettings.invalidJson': 'Formato JSON inválido',
  'app.pages.aiSettings.saveSuccess': 'La configuración de IA se guardó correctamente',
  'app.pages.aiSettings.availabilityTab': 'Disponibilidad',
  'app.pages.aiSettings.availabilityCompanyTitle': 'Empresa actual',
  'app.pages.aiSettings.availabilityGlobalTitle': 'Valor global por defecto',
  'app.pages.aiSettings.aiEnabled': 'Funcionalidades de IA activadas',
  'app.pages.aiSettings.aiEnabledHelp':
    'Al desactivarlas se apagan todas las funcionalidades de IA para esta empresa, incluido el uso de MCP.',
  'app.pages.aiSettings.useGlobalLimit': 'Usar el límite global ({value})',
  'app.pages.aiSettings.customAgentsEnabled': 'Agentes personalizados activados',
  'app.pages.aiSettings.customAgentsEnabledHelp':
    'Cuando está desactivado, los agentes definidos dentro de las aplicaciones no se pueden usar, ni por chat ni por MCP. El agente Pyplan integrado sigue funcionando.',
  'app.pages.aiSettings.agentsInProcessesEnabled': 'Agentes en procesos activados',
  'app.pages.aiSettings.agentsInProcessesEnabledHelp':
    'Cuando está desactivado, no se pueden asignar agentes a las tareas de un proceso y los ya asignados no se ejecutan. El chat no se ve afectado.',
  'app.pages.aiSettings.globalAlwaysEnabledHelp':
    'Las funcionalidades de IA y los agentes personalizados están siempre activados a nivel global. Desactívalos por empresa en el panel de la izquierda.',
  'app.pages.aiSettings.monthlyTokenLimit': 'Límite mensual de tokens',
  'app.pages.aiSettings.monthlyTokenLimitHelp':
    '0 significa ilimitado. Se muestra un aviso a partir del 80%.',
  'app.pages.aiSettings.monthlyTokenLimitInvalid': 'Ingresa un número entero de 0 o más',
  'app.pages.aiSettings.tokensUsedThisMonth': 'Usado este mes',
  'app.pages.aiSettings.tokensUnlimited': 'ilimitado',
  'app.pages.aiSettings.fullAccessEmailDomains': 'Dominios de email con acceso total',
  'app.pages.aiSettings.fullAccessEmailDomainsHelp':
    'Dominios separados por coma que se saltan el interruptor de IA y el límite de tokens en todas las empresas. Los permisos de rol siguen aplicando. Solo a nivel global.',
  'app.pages.aiSettings.availabilitySaveSuccess': 'La disponibilidad de IA se guardó correctamente',
  // App tests
  'app.pages.app.sidebarMenu.createApplicationTest': 'Crear prueba de aplicación',
  'app.pages.app.sidebarMenu.editApplicationTest': 'Editar prueba de aplicación',
  'app.pages.app.sidebarMenu.deleteApplicationTest': 'Eliminar prueba de automatización',
  'app.pages.app.sidebarMenu.duplicateApplicationTest': 'Duplicar prueba de automatización',
  'app.pages.applicationTests.checkType': 'Tipo de chequeo',
  'app.pages.applicationTests.equalTo': 'Igual a',
  'app.pages.applicationTests.between': 'Entre',
  'app.pages.applicationTests.noEvaluationError': 'Sin error de evaluación',
  'app.pages.applicationTests.expectedValue': 'Valor esperado',
  'app.pages.applicationTests.precondition': 'Precondición',
  'app.pages.applicationTests.selectorValues': 'Valores del selector',
  'app.pages.applicationTests.addSelector': 'Agregar selector',
  'app.pages.applicationTests.addPrecondition': 'Agregar precondición',
  'app.pages.applicationTests.areYouSureToDeleteApplicationTest':
    '¿Estás seguro de que deseas eliminar las siguientes pruebas: {names}?',
  'app.pages.applicationTests.areYouSureToRunApplicationTests':
    '¿Estás seguro de que deseas ejecutar las siguientes pruebas: {names}?',
  'app.pages.applicationTests.lastExecutionStatus': 'Último estado de ejecución',
  'app.pages.applicationTests.lastExecutionDate': 'Última fecha de ejecución',
  'app.pages.applicationTests.testDeletedSuccessfully': 'Prueba eliminada con éxito',
  'app.pages.applicationTests.testCreatedSuccessfully': 'Prueba creada con éxito',
  'app.pages.applicationTests.testUpdatedSuccessfully': 'Prueba actualizada con éxito',
  'app.pages.applicationTests.testDuplicatedSuccessfully': 'Prueba duplicada con éxito',
  'app.pages.applicationTests.runApplicationTests': 'Ejecutar pruebas de aplicación',
  'app.pages.applicationTests.mainMenuInterfaces': 'Menú principal de interfaces',
  'app.pages.applicationTests.newName': 'Nuevo nombre',
  'app.pages.applicationTests.executeTests': 'Ejecutar pruebas',
  'app.pages.applicationTests.executeTestsWithNames': 'Ejecutar pruebas: {names}',
  'app.pages.applicationTests.sendEmails': 'Enviar correos electrónicos siempre',
  'app.pages.applicationTests.emailRecipients': 'Destinatarios de correo electrónico',
  'app.pages.applicationTests.sendOnFailureOnly':
    'Enviar correos electrónicos solo en caso de fallo',
  'app.pages.applicationTests.testExecutedSuccessfully': 'Test programado para ejecución',
  'app.pages.applicationTests.selectNodes': 'Seleccionar nodos',
  'app.pages.applicationTests.viewPreconditions': 'Ver precondiciones',
  'app.pages.applicationTests.settings': 'Configuración',
  'app.pages.applicationTests.areYouSureToExecuteTests':
    '¿Estás seguro de que deseas ejecutar las pruebas seleccionadas?',
  'app.pages.applicationTests.settingsSavedSuccessfully': 'Configuración guardada correctamente',
  'app.pages.applicationTests.testTypes': 'Tipos de prueba',
  'app.pages.applicationTests.configureNodes': 'Configurar nodos',
  'app.pages.applicationTests.permissions': 'Permisos',
  'app.pages.applicationTests.configurePermissions': 'Configurar permisos',
  'app.pages.applicationTests.permissionAssertionsCount':
    '{count, plural, one {# aserción} other {# aserciones}}',
  'app.pages.applicationTests.permissionsInfo':
    'Cada aserción se evalúa por cada departamento del test, como si el usuario perteneciera solo a ese departamento. Se ignoran los roles de quien ejecuta el test.',
  'app.pages.applicationTests.addPermissionAssertion': 'Agregar aserción',
  'app.pages.applicationTests.noPermissionAssertions': 'No hay aserciones configuradas',
  'app.pages.applicationTests.permissionItemType': 'Tipo',
  'app.pages.applicationTests.permissionItem': 'Ítem',
  'app.pages.applicationTests.expectedAccess': 'Acceso esperado',
  'app.pages.applicationTests.accessAllowed': 'Con acceso',
  'app.pages.applicationTests.accessDenied': 'Sin acceso',
  'app.pages.applicationTests.removePermissionAssertion': 'Eliminar aserción',
  'app.pages.applicationTests.permissionVersion': 'Versión',
  'app.pages.applicationTests.permissionType.folder': 'Carpeta',
  'app.pages.applicationTests.permissionType.application': 'Aplicación',
  'app.pages.applicationTests.permissionType.application_version': 'Versión de aplicación',
  'app.pages.applicationTests.permissionType.interface': 'Interfaz',
  'app.pages.applicationTests.permissionType.interface_folder': 'Carpeta de interfaz',
  'app.pages.applicationTests.permissionType.module': 'Módulo',
  'app.pages.applicationTests.noPreconditionsAdded': 'No se han agregado precondiciones',
  'app.pages.applicationTests.noNodesSelected': 'No se han seleccionado nodos',
  'app.pages.applicationTests.removeFilters': 'Quitar filtros',
  'app.pages.applicationTests.viewLogs': 'Ver logs',
  'app.pages.applicationTests.executionTime': 'Tiempo de ejecución',
  'app.pages.applicationTests.executionLogs': 'Logs de ejecución',
  'app.pages.applicationTests.viewTest': 'Ver prueba',
  'app.pages.applicationTests.testExecutedOn': 'Prueba ejecutada el {date}',
  'app.pages.applicationTests.testExecutedInSeconds': 'en {duration} segundos',
  'app.pages.applicationTests.preconditionInfo':
    '(Opcional) Precondiciones que deben cumplirse antes de ejecutar la prueba. Puedes agregar nodos selectores y valores esperados para esos nodos.',
  'app.pages.applicationTests.automationTests': 'Pruebas de automatización',
  'app.pages.applicationTests.testNoExecutedYet': 'La prueba aún no ha sido ejecutada',
  'app.pages.applicationTests.step': 'Paso',
  'app.pages.applicationTests.areYouSureToExecuteSingleTest':
    '¿Estás seguro de que deseas ejecutar la prueba?',
  'app.pages.applicationTests.executeSingleTest': 'Ejecutar prueba',
  'app.pages.applicationTests.hideDetails': 'Ocultar detalles',
  'app.pages.applicationTests.noLogsAvailable': 'No hay logs disponibles',
  'app.pages.applicationTests.testPassed': 'Pasados',
  'app.pages.applicationTests.testFailed': 'Fallados',
  'app.pages.applicationTests.testSuccess': 'Éxito',
  'app.pages.applicationTests.usersToNotify': 'Usuarios a notificar',
  'app.pages.applicationTests.notificationMode': 'Modo de notificación',
  'app.pages.applicationTests.noNotification': 'Sin notificación',
  // HTML EDITOR
  'app.pages.htmlEditor.insertTemplate': 'Insertar plantilla',
  'app.pages.htmlEditor.templates': 'Plantillas',
  'app.pages.htmlEditor.saveTemplate': 'Guardar plantilla',
  'app.pages.htmlEditor.replaceExisting': 'Reemplazar existente',
  'app.pages.htmlEditor.manageTemplates': 'Administrar plantillas',
  'app.pages.htmlEditor.createNewTemplate': 'Crear nueva plantilla',
  'app.pages.htmlEditor.renameOrDeleteTemplates': 'Renombrar o eliminar plantillas',
  'app.pages.htmlEditor.copyFormatting': 'Copiar formato',
  'app.pages.htmlEditor.template': 'Plantilla',
  'app.pages.htmlEditor.templateSavedSuccessfully': 'Plantilla guardada correctamente.',
  'app.pages.htmlEditor.templateReplacedSuccessfully': 'Plantilla reemplazada correctamente.',
  'app.pages.htmlEditor.templateRenamedSuccessfully': 'Plantilla renombrada correctamente.',
  'app.pages.htmlEditor.templateDeletedSuccessfully': 'Plantilla eliminada correctamente.',
  'app.pages.htmlEditor.noTemplatesToManage': 'No hay plantillas para administrar.',
  'app.pages.htmlEditor.noTemplatesDefined': 'No hay plantillas definidas.',
  'app.pages.htmlEditor.htmlTemplates': 'Plantillas HTML',
  'app.pages.htmlEditor.showCodeAssistant': 'Mostrar asistente de código',

  // AI Traces
  'app.pages.aiTraces.traces': 'Trazas',
  'app.pages.aiTraces.title': 'Trazas de IA',
  'app.pages.aiTraces.userSessionsTitle': 'Sesiones de IA por usuario',
  'app.pages.app.sidebarMenu.aiSessions': 'Sesiones de IA',
  'app.pages.aiTraces.workflow': 'Flujo de trabajo',
  'app.pages.aiTraces.agent': 'Agente',
  'app.pages.aiTraces.provider': 'Proveedor',
  'app.pages.aiTraces.tokens': 'Tokens',
  'app.pages.aiTraces.inputTokens': 'Tokens de entrada',
  'app.pages.aiTraces.outputTokens': 'Tokens de salida',
  'app.pages.aiTraces.totalTokens': 'Tokens totales',
  'app.pages.aiTraces.cachedTokens': 'Tokens en caché',
  'app.pages.aiTraces.reasoningTokens': 'Tokens de razonamiento',
  'app.pages.aiTraces.duration': 'Duración',
  'app.pages.aiTraces.environment': 'Entorno',
  'app.pages.aiTraces.groupId': 'Sesión',
  'app.pages.aiTraces.downloadReport': 'Descargar reporte de trazas',
  'app.pages.aiTraces.reportDownloaded': 'Reporte de trazas descargado',
  'app.pages.aiTraces.noTraces': 'No se encontraron trazas',
  'app.pages.aiTraces.filterProvider': 'Filtrar por proveedor',
  'app.pages.aiTraces.filterAgent': 'Filtrar por agente',
  'app.pages.aiTraces.filterStatus': 'Filtrar por estado',
  'app.pages.aiTraces.dateFrom': 'Desde',
  'app.pages.aiTraces.dateTo': 'Hasta',
  'app.pages.aiTraces.allProviders': 'Todos los proveedores',
  'app.pages.aiTraces.allAgents': 'Todos los agentes',
  'app.pages.aiTraces.allStatuses': 'Todos los estados',
  'app.pages.aiTraces.spanDetail': 'Detalle del span',
  'app.pages.aiTraces.spanId': 'ID del span',
  'app.pages.aiTraces.startedAt': 'Inicio',
  'app.pages.aiTraces.endedAt': 'Fin',
  'app.pages.aiTraces.noData': 'No hay datos disponibles para este span.',
  'app.pages.aiTraces.spans': 'Spans',
  'app.pages.aiTraces.stopped': 'Detenido',
  'app.pages.aiTraces.stopExecution': 'Detener ejecución',
  'app.pages.aiTraces.stopExecutionConfirmTitle': '¿Detener la ejecución?',
  'app.pages.aiTraces.stopExecutionConfirmContent':
    'Se le pedirá al agente que se detenga lo antes posible. Las llamadas a herramientas pendientes pueden completarse antes de que la ejecución se detenga. ¿Continuar?',
  'app.pages.aiTraces.stopExecutionSuccess':
    'Solicitud de detención enviada. El agente se detendrá en breve.',
  'app.pages.aiTraces.stopExecutionError': 'No se pudo detener la ejecución del agente.',
  'app.pages.aiTraces.stopExecutionNotInProgress': 'La ejecución ya no está en curso.',
  'app.pages.aiTraces.selectSpan': 'Selecciona un span para ver sus detalles',
  'app.pages.aiTraces.noSpans': 'No hay spans disponibles',
  'app.pages.aiTraces.instructions': 'Instrucciones',
  'app.pages.aiTraces.systemInstructions': 'Instrucciones del sistema',
  'app.pages.aiTraces.configuration': 'Configuración',
  'app.pages.aiTraces.topP': 'Top P',
  'app.pages.aiTraces.reasoningEffort': 'Esfuerzo de razonamiento',
  'app.pages.aiTraces.reasoningSummary': 'Resumen de razonamiento',
  'app.pages.aiTraces.functionCall': 'Llamada de función',
  'app.pages.aiTraces.functionName': 'Nombre de función',
  'app.pages.aiTraces.arguments': 'Argumentos',
  'app.pages.aiTraces.functions': 'Funciones',
  'app.pages.aiTraces.handoff': 'Transferencia',
  'app.pages.aiTraces.fromAgent': 'Desde agente',
  'app.pages.aiTraces.toAgent': 'Hacia agente',
  'app.pages.aiTraces.guardrail': 'Guardrail',
  'app.pages.aiTraces.triggered': 'Activado',
  'app.pages.aiTraces.handoffs': 'Transferencias',
  'app.pages.aiTraces.responseId': 'ID de respuesta',
  'app.pages.aiTraces.rawData': 'Datos crudos',
  'app.pages.aiTraces.tokenSummary': 'Resumen de tokens',
  'app.pages.aiTraces.sessionDetails': 'Detalles de la sesión',
  'app.pages.aiTraces.viewSessionDetails': 'Ver detalles de la sesión',
  'app.pages.aiTraces.sessions': 'Sesiones',
  'app.pages.aiTraces.sessionTitle': 'Título',
  'app.pages.aiTraces.sessionId': 'ID de sesión',
  'app.pages.aiTraces.unknownUser': 'Desconocido',
  'app.pages.aiTraces.session': 'Sesión',
  'app.pages.aiTraces.lastActivity': 'Última actividad',
  'app.pages.aiTraces.traceCount': 'Trazas',
  'app.pages.aiTraces.sessionCount': 'Sesiones',
  'app.pages.aiTraces.cacheRatio': 'Caché',
  'app.pages.aiTraces.agents': 'Agentes',
  'app.pages.aiTraces.models': 'Modelos',
  'app.pages.aiTraces.elapsed': 'Tiempo transcurrido',
  'app.pages.aiTraces.viewConversation': 'Ver conversación',
  'app.pages.aiTraces.unpricedWarning':
    '{count, plural, one {# traza usó} other {# trazas usaron}} un modelo sin precio configurado: el costo mostrado es menor al real.',
  'app.pages.aiTraces.retentionNotice':
    'Cubre las trazas de los últimos {days} días. Para facturación, usa el reporte de costos de IA.',
  'app.pages.aiTraces.noSessions': 'No se encontraron sesiones',
  'app.pages.aiTraces.noUsers': 'No se encontraron usuarios',
  'app.pages.aiTraces.sessionNotFound': 'La sesión no tiene trazas en el período seleccionado',
  'app.pages.aiTraces.sessionDialogTitle': 'Conversación de la sesión',
  'app.pages.aiTraces.noSessionMessages': 'No se encontraron mensajes para esta sesión.',
  'app.pages.aiTraces.sessionLoadError': 'No se pudo cargar la conversación de la sesión.',
  'app.pages.aiTraces.temperature': 'Temperatura',
  'app.pages.aiTraces.appVersion': 'Versión de la aplicación',
  'app.pages.aiTraces.costSummary': 'Resumen de costos',
  'app.pages.aiTraces.inputCost': 'Costo de entrada',
  'app.pages.aiTraces.outputCost': 'Costo de salida',
  'app.pages.aiTraces.cachedCost': 'Costo de caché',
  'app.pages.aiTraces.totalCost': 'Costo total',

  // AI Pricing
  'app.pages.aiProvider.title': 'Proveedores de IA',
  'app.pages.aiModel.title': 'Modelos de IA',
  'app.pages.aiPricing.title': 'Precios de IA',
  'app.pages.aiPricing.providersTab': 'Proveedores',
  'app.pages.aiPricing.pricingTab': 'Precios',
  'app.pages.aiPricing.newProvider': 'Nuevo proveedor',
  'app.pages.aiPricing.editProvider': 'Editar proveedor',
  'app.pages.aiPricing.newModel': 'Nuevo modelo',
  'app.pages.aiPricing.editModel': 'Editar modelo',
  'app.pages.aiPricing.newTier': 'Nuevo nivel de precios',
  'app.pages.aiPricing.editTier': 'Editar nivel de precios',
  'app.pages.aiPricing.deleteConfirmTitle': 'Confirmar eliminación',
  'app.pages.aiPricing.deleteConfirmMessage': '¿Estás seguro de que deseas eliminar este elemento?',
  'app.pages.aiPricing.successCreated': 'Creado exitosamente',
  'app.pages.aiPricing.successUpdated': 'Actualizado exitosamente',
  'app.pages.aiPricing.successDeleted': 'Eliminado exitosamente',
  'app.pages.aiPricing.filterByModel': 'Filtrar por modelo',
  'app.pages.aiPricing.allModels': 'Todos los modelos',
  'app.pages.aiPricing.noProvidersFound': 'No se encontraron proveedores',
  'app.pages.aiPricing.noModelsFound': 'No se encontraron modelos',
  'app.pages.aiPricing.noTiersFound': 'No se encontraron niveles de precios',
  'app.pages.aiPricing.modelCode': 'Código del modelo',
  'app.pages.aiPricing.tokensMin': 'Tokens mín',
  'app.pages.aiPricing.tokensMax': 'Tokens máx',
  'app.pages.aiPricing.inputPrice': 'Precio entrada',
  'app.pages.aiPricing.cachePrice': 'Precio caché',
  'app.pages.aiPricing.outputPrice': 'Precio salida',
  'app.pages.aiPricing.pricePerMillionTokens': 'Precio por millón de tokens',
  'app.pages.aiPricing.tokensMaxMustBeGreater': 'El máximo debe ser mayor que el mínimo',
  'app.pages.aiPricing.unlimited': 'Ilimitado',
  'app.pages.aiPricing.successChangedStatus': 'Estado del modelo cambiado exitosamente',

  // nextMcp
  'app.pages.nextMcp.authorizeMcpAccess': 'Autorizar acceso MCP',
  'app.pages.nextMcp.mcpRequestAccess':
    'Un cliente MCP está solicitando acceso a tu cuenta de Pyplan ({username}).',
  'app.pages.nextMcp.mcpRequestAccessNoUser':
    'Un cliente MCP está solicitando acceso a tu cuenta de Pyplan.',
  'app.pages.nextMcp.company': 'Empresa',
  'app.pages.nextMcp.authorize': 'Autorizar',
  'app.pages.nextMcp.missingOAuthParams':
    'Faltan parámetros de OAuth. Por favor, reinicia el flujo desde tu cliente MCP.',
  'app.pages.nextMcp.noActiveCompanies': 'Tu usuario no tiene empresas activas.',
  'app.pages.nextMcp.aiDisabledForCompany':
    'Las funcionalidades de IA no están activadas para esta empresa, así que no se puede vincular a un cliente MCP. Contacta a tu administrador para activarlas.',
  'app.pages.nextMcp.unableToLoadSession':
    'No se pudo cargar tu sesión de Pyplan. Por favor, inténtalo de nuevo.',
  'app.pages.nextMcp.noTokenReturned': 'La API de Pyplan no devolvió un token DRF',
  'app.pages.nextMcp.unexpectedCallback': 'Respuesta inesperada del callback',
  'app.pages.nextMcp.authorizationFailed': 'La autorización falló',

  // Test applications
  'app.pages.testApplications.testApplications': 'Prueba de aplicaciones',
  'app.pages.testApplications.applicationPath': 'Aplicación',
  'app.pages.testApplications.version': 'Versión',
  'app.pages.testApplications.lastExecutionDate': 'Fecha de última ejecución',
  'app.pages.testApplications.lastExecutionStatus': 'Estado de última ejecución',
  'app.pages.testApplications.enabled': 'Habilitado',
  'app.pages.testApplications.actions': 'Acciones',
  'app.pages.testApplications.run': 'Ejecutar',
  'app.pages.testApplications.addApplication': 'Agregar aplicación',
  'app.pages.testApplications.editConfiguration': 'Editar configuración',
  'app.pages.testApplications.emailSectionTitle': 'Envío de email al finalizar',
  'app.pages.testApplications.removeApplication': 'Quitar aplicación',
  'app.pages.testApplications.viewLogs': 'Ver registros',
  'app.pages.testApplications.defaultVersion': 'Versión por defecto',
  'app.pages.testApplications.selectApplication': 'Selecciona una aplicación',
  'app.pages.testApplications.selectApplicationHelper':
    'Elige una aplicación desde el administrador de archivos para registrarla para pruebas.',
  'app.pages.testApplications.responsibles': 'Responsables',
  'app.pages.testApplications.sendOnFailureOnly': 'Enviar correos solo en caso de falla',
  'app.pages.testApplications.applicationAdded': 'Aplicación agregada correctamente',
  'app.pages.testApplications.applicationRemoved': 'Aplicación quitada correctamente',
  'app.pages.testApplications.configurationSaved': 'Configuración guardada correctamente',
  'app.pages.testApplications.runScheduled': 'Pruebas programadas para ejecución',
  'app.pages.testApplications.areYouSureToRemove':
    '¿Estás seguro de que quieres quitar las siguientes aplicaciones: {names}?',
  'app.pages.testApplications.noApplicationsRegistered':
    'No hay aplicaciones registradas para pruebas',
  'app.pages.testApplications.executionLogs': 'Registros de ejecución',
  'app.experience.newExperience': 'Nueva experiencia',
  'app.experience.switchedToNext':
    'Estás usando la nueva experiencia. Las secciones actualizadas muestran el diseño nuevo; el resto se irá actualizando de a poco.',
  'app.experience.switchedToNextWithoutViews':
    'Estás usando la nueva experiencia. El diseño nuevo se irá habilitando de a poco en cada sección.',
  'app.experience.switchError': 'No se pudo cambiar la experiencia. Intentá de nuevo.',
  'app.pages.home.subtitle': 'Abrí tus aplicaciones y retomá donde lo dejaste.',
  'app.pages.home.openInstances': 'Instancias abiertas',
  'app.pages.home.moreWorkspaces': '{count} más',
  'app.pages.home.searchWorkspaces': 'Buscar espacios de trabajo',
  'app.pages.home.view': 'Vista',
  'app.pages.home.listView': 'Vista de lista',
  'app.pages.home.gridView': 'Vista de cuadrícula',
  'app.pages.home.emptyWorkspace': 'No hay aplicaciones en este espacio de trabajo.',
  'app.pages.home.appOptions': 'Opciones de la aplicación',
  'app.pages.home.workspace': 'Espacio de trabajo'
}

export default messages
